export default [
  {
    value: '中国',
    key: 1156,
    id: 1156,
    children: [
      {
        value: '台湾省',
        key: 710000,
        id: 710000,
        children: [
          {
            value: '高雄市',
            key: 710200,
            id: 710200
          },
          {
            value: '花莲县',
            key: 712200,
            id: 712200
          },
          {
            value: '嘉义市',
            key: 710700,
            id: 710700
          },
          {
            value: '南投县',
            key: 711500,
            id: 711500
          },
          {
            value: '澎湖县',
            key: 712300,
            id: 712300
          },
          {
            value: '屏东县',
            key: 712000,
            id: 712000
          },
          {
            value: '台北市',
            key: 710100,
            id: 710100
          },
          {
            value: '台东县',
            key: 712100,
            id: 712100
          },
          {
            value: '台南市',
            key: 710500,
            id: 710500
          },
          {
            value: '台中市',
            key: 710400,
            id: 710400
          },
          {
            value: '桃园市',
            key: 711100,
            id: 711100
          },
          {
            value: '新竹市',
            key: 710600,
            id: 710600
          },
          {
            value: '宜兰县',
            key: 710900,
            id: 710900
          },
          {
            value: '云林县',
            key: 711700,
            id: 711700
          },
          {
            value: '彰化县',
            key: 711400,
            id: 711400
          },
          {
            value: '新竹县',
            key: 711300,
            id: 711300
          },
          {
            value: '嘉义县',
            key: 711900,
            id: 711900
          },
          {
            value: '基隆市',
            key: 713100,
            id: 713100
          },
          {
            value: '新北市',
            key: 713200,
            id: 713200
          },
          {
            value: '苗栗县',
            key: 713300,
            id: 713300
          }
        ]
      },
      {
        value: '西藏自治区',
        key: 540000,
        id: 540000,
        children: [
          {
            value: '昌都市',
            key: 542100,
            id: 542100,
            children: [
              {
                value: '卡若区',
                key: '542121',
                id: 542121
              },
              {
                value: '江达县',
                key: '542122',
                id: 542122
              },
              {
                value: '贡觉县',
                key: '542123',
                id: 542123
              },
              {
                value: '类乌齐县',
                key: 'lwq',
                id: 542124
              },
              {
                value: '丁青县',
                key: 'dq',
                id: 542125
              },
              {
                value: '察雅县',
                key: 'cy',
                id: 542126
              },
              {
                value: '八宿县',
                key: 'bs',
                id: 542127
              },
              {
                value: '左贡县',
                key: 'zg',
                id: 542128
              },
              {
                value: '芒康县',
                key: 'mk',
                id: 542129
              },
              {
                value: '洛隆县',
                key: 'll',
                id: 542132
              },
              {
                value: '边坝县',
                key: 'bb',
                id: 542133
              }
            ]
          },
          {
            value: '拉萨市',
            key: 540100,
            id: 540100,
            children: [
              {
                value: '城关区',
                key: 540102,
                id: 540102
              },
              {
                value: '林周县',
                key: 540121,
                id: 540121
              },
              {
                value: '当雄县',
                key: 540122,
                id: 540122
              },
              {
                value: '尼木县',
                key: 540123,
                id: 540123
              },
              {
                value: '曲水县',
                key: 540124,
                id: 540124
              },
              {
                value: '堆龙德庆区',
                key: 540125,
                id: 540125
              },
              {
                value: '达孜区',
                key: 540126,
                id: 540126
              },
              {
                value: '墨竹工卡县',
                key: 540127,
                id: 540127
              }
            ]
          },
          {
            value: '林芝市',
            key: 542600,
            id: 542600,
            children: [
              {
                value: '巴宜区',
                key: 542621,
                id: 542621
              },
              {
                value: '工布江达县',
                key: 542622,
                id: 542622
              },
              {
                value: '米林县',
                key: 542623,
                id: 542623
              },
              {
                value: '墨脱县',
                key: 542624,
                id: 542624
              },
              {
                value: '波密县',
                key: 542625,
                id: 542625
              },
              {
                value: '察隅县',
                key: 542626,
                id: 542626
              },
              {
                value: '朗县',
                key: 542627,
                id: 542627
              }
            ]
          },
          {
            value: '日喀则市',
            key: 540200,
            id: 540200,
            children: [
              {
                value: '桑珠孜区',
                key: 540202,
                id: 540202
              },
              {
                value: '南木林县',
                key: 540221,
                id: 540221
              },
              {
                value: '江孜县',
                key: 540222,
                id: 540222
              },
              {
                value: '定日县',
                key: 540223,
                id: 540223
              },
              {
                value: '萨迦县',
                key: 540224,
                id: 540224
              },
              {
                value: '拉孜县',
                key: 540225,
                id: 540225
              },
              {
                value: '昂仁县',
                key: 540226,
                id: 540226
              },
              {
                value: '谢通门县',
                key: 540227,
                id: 540227
              },
              {
                value: '白朗县',
                key: 540228,
                id: 540228
              },
              {
                value: '仁布县',
                key: 540229,
                id: 540229
              },
              {
                value: '康马县',
                key: 540230,
                id: 540230
              },
              {
                value: '定结县',
                key: 540231,
                id: 540231
              },
              {
                value: '仲巴县',
                key: 540232,
                id: 540232
              },
              {
                value: '亚东县',
                key: 540233,
                id: 540233
              },
              {
                value: '吉隆县',
                key: 540234,
                id: 540234
              },
              {
                value: '聂拉木县',
                key: 540235,
                id: 540235
              },
              {
                value: '萨嘎县',
                key: 540236,
                id: 540236
              },
              {
                value: '岗巴县',
                key: 540237,
                id: 540237
              }
            ]
          },
          {
            value: '山南市',
            key: 542200,
            id: 542200,
            children: [
              {
                value: '乃东区',
                key: 542221,
                id: 542221
              },
              {
                value: '扎囊县',
                key: 542222,
                id: 542222
              },
              {
                value: '贡嘎县',
                key: 542223,
                id: 542223
              },
              {
                value: '桑日县',
                key: 542224,
                id: 542224
              },
              {
                value: '琼结县',
                key: 542225,
                id: 542225
              },
              {
                value: '曲松县',
                key: 542226,
                id: 542226
              },
              {
                value: '措美县',
                key: 542227,
                id: 542227
              },
              {
                value: '洛扎县',
                key: 542228,
                id: 542228
              },
              {
                value: '加查县',
                key: 542229,
                id: 542229
              },
              {
                value: '隆子县',
                key: 542231,
                id: 542231
              },
              {
                value: '错那县',
                key: 542232,
                id: 542232
              },
              {
                value: '浪卡子县',
                key: 542233,
                id: 542233
              }
            ]
          },
          {
            value: '阿里地区',
            key: 542500,
            id: 542500,
            children: [
              {
                value: '普兰县',
                key: 542521,
                id: 542521
              },
              {
                value: '札达县',
                key: 542522,
                id: 542522
              },
              {
                value: '噶尔县',
                key: 542523,
                id: 542523
              },
              {
                value: '日土县',
                key: 542524,
                id: 542524
              },
              {
                value: '革吉县',
                key: 542525,
                id: 542525
              },
              {
                value: '改则县',
                key: 542526,
                id: 542526
              },
              {
                value: '措勤县',
                key: 542527,
                id: 542527
              }
            ]
          },
          {
            value: '那曲市',
            key: 542400,
            id: 542400,
            children: [
              {
                value: '色尼区',
                key: 542421,
                id: 542421
              },
              {
                value: '嘉黎县',
                key: 542422,
                id: 542422
              },
              {
                value: '比如县',
                key: 542423,
                id: 542423
              },
              {
                value: '聂荣县',
                key: 542424,
                id: 542424
              },
              {
                value: '安多县',
                key: 542425,
                id: 542425
              },
              {
                value: '申扎县',
                key: 542426,
                id: 542426
              },
              {
                value: '索县',
                key: 542427,
                id: 542427
              },
              {
                value: '班戈县',
                key: 542428,
                id: 542428
              },
              {
                value: '巴青县',
                key: 542429,
                id: 542429
              },
              {
                value: '尼玛县',
                key: 542430,
                id: 542430
              },
              {
                value: '双湖县',
                key: 542431,
                id: 542431
              }
            ]
          }
        ]
      },
      {
        value: '青海省',
        key: 630000,
        id: 630000,
        children: [
          {
            value: '海北藏族自治州',
            key: 632200,
            id: 632200,
            children: [
              {
                value: '门源回族自治县',
                key: 632221,
                id: 632221
              },
              {
                value: '祁连县',
                key: 632222,
                id: 632222
              },
              {
                value: '海晏县',
                key: 632223,
                id: 632223
              },
              {
                value: '刚察县',
                key: 632224,
                id: 632224
              }
            ]
          },
          {
            value: '海东市',
            key: 630200,
            id: 630200,
            children: [
              {
                value: '乐都区',
                key: 630202,
                id: 630202
              },
              {
                value: '平安区',
                key: 630221,
                id: 630221
              },
              {
                value: '民和回族土族自治县',
                key: 630222,
                id: 630222
              },
              {
                value: '互助土族自治县',
                key: 630223,
                id: 630223
              },
              {
                value: '化隆回族自治县',
                key: 630224,
                id: 630224
              },
              {
                value: '循化撒拉族自治县',
                key: 630225,
                id: 630225
              }
            ]
          },
          {
            value: '海南藏族自治州',
            key: 632500,
            id: 632500,
            children: [
              {
                value: '共和县',
                key: 632521,
                id: 632521
              },
              {
                value: '同德县',
                key: 632522,
                id: 632522
              },
              {
                value: '贵德县',
                key: 632523,
                id: 632523
              },
              {
                value: '兴海县',
                key: 632524,
                id: 632524
              },
              {
                value: '贵南县',
                key: 632525,
                id: 632525
              }
            ]
          },
          {
            value: '海西蒙古族藏族自治州',
            key: 632800,
            id: 632800,
            children: [
              {
                value: '格尔木市',
                key: 632801,
                id: 632801
              },
              {
                value: '德令哈市',
                key: 632802,
                id: 632802
              },
              {
                value: '乌兰县',
                key: 632821,
                id: 632821
              },
              {
                value: '都兰县',
                key: 632822,
                id: 632822
              },
              {
                value: '天峻县',
                key: 632823,
                id: 632823
              },
              {
                value: '冷湖行政委员会',
                key: 632824,
                id: 632824
              },
              {
                value: '大柴旦行政委员会',
                key: 632825,
                id: 632825
              },
              {
                value: '茫崖行政委员会',
                key: 632826,
                id: 632826
              }
            ]
          },
          {
            value: '西宁市',
            key: 630100,
            id: 630100,
            children: [
              {
                value: '城东区',
                key: 630102,
                id: 630102
              },
              {
                value: '城中区',
                key: 630103,
                id: 630103
              },
              {
                value: '城西区',
                key: 630104,
                id: 630104
              },
              {
                value: '城北区',
                key: 630105,
                id: 630105
              },
              {
                value: '大通回族土族自治县',
                key: 630121,
                id: 630121
              },
              {
                value: '湟中县',
                key: 630122,
                id: 630122
              },
              {
                value: '湟源县',
                key: 630123,
                id: 630123
              }
            ]
          },
          {
            value: '果洛藏族自治州',
            key: 632600,
            id: 632600,
            children: [
              {
                value: '玛沁县',
                key: 632621,
                id: 632621
              },
              {
                value: '班玛县',
                key: 632622,
                id: 632622
              },
              {
                value: '甘德县',
                key: 632623,
                id: 632623
              },
              {
                value: '达日县',
                key: 632624,
                id: 632624
              },
              {
                value: '久治县',
                key: 632625,
                id: 632625
              },
              {
                value: '玛多县',
                key: 632626,
                id: 632626
              }
            ]
          },
          {
            value: '黄南藏族自治州',
            key: 632300,
            id: 632300,
            children: [
              {
                value: '同仁县',
                key: 632321,
                id: 632321
              },
              {
                value: '尖扎县',
                key: 632322,
                id: 632322
              },
              {
                value: '泽库县',
                key: 632323,
                id: 632323
              },
              {
                value: '河南蒙古族自治县',
                key: 632324,
                id: 632324
              }
            ]
          },
          {
            value: '玉树藏族自治州',
            key: 632700,
            id: 632700,
            children: [
              {
                value: '玉树市',
                key: 632721,
                id: 632721
              },
              {
                value: '杂多县',
                key: 632722,
                id: 632722
              },
              {
                value: '称多县',
                key: 632723,
                id: 632723
              },
              {
                value: '治多县',
                key: 632724,
                id: 632724
              },
              {
                value: '囊谦县',
                key: 632725,
                id: 632725
              },
              {
                value: '曲麻莱县',
                key: 632726,
                id: 632726
              }
            ]
          }
        ]
      },
      {
        value: '四川省',
        key: 510000,
        id: 510000,
        children: [
          {
            key: 510300,
            value: '自贡市',
            id: 510300,
            children: [
              {
                key: 510302,
                value: '自流井区',
                id: 510302
              },
              {
                key: 510303,
                value: '贡井区',
                id: 510303
              },
              {
                key: 510304,
                value: '大安区',
                id: 510304
              },
              {
                key: 510311,
                value: '沿滩区',
                id: 510311
              },
              {
                key: 510321,
                value: '荣县',
                id: 510321
              },
              {
                key: 510322,
                value: '富顺县',
                id: 510322
              }
            ]
          },
          {
            key: 511500,
            value: '宜宾市',
            id: 511500,
            children: [
              {
                key: 511502,
                value: '翠屏区',
                id: 511502
              },
              {
                key: 511503,
                value: '南溪区',
                id: 511503
              },
              {
                key: 511521,
                value: '宜宾县',
                id: 511521
              },
              {
                key: 511523,
                value: '江安县',
                id: 511523
              },
              {
                key: 511524,
                value: '长宁县',
                id: 511524
              },
              {
                key: 511525,
                value: '高县',
                id: 511525
              },
              {
                key: 511526,
                value: '珙县',
                id: 511526
              },
              {
                key: 511527,
                value: '筠连县',
                id: 511527
              },
              {
                key: 511528,
                value: '兴文县',
                id: 511528
              },
              {
                key: 511529,
                value: '屏山县',
                id: 511529
              }
            ]
          },
          {
            key: 512000,
            value: '资阳市',
            id: 512000,
            children: [
              {
                key: 512002,
                value: '雁江区',
                id: 512002
              },
              {
                key: 512021,
                value: '安岳县',
                id: 512021
              },
              {
                key: 512022,
                value: '乐至县',
                id: 512022
              }
            ]
          },
          {
            key: 510500,
            value: '泸州市',
            id: 510500,
            children: [
              {
                key: 510502,
                value: '江阳区',
                id: 510502
              },
              {
                key: 510503,
                value: '纳溪区',
                id: 510503
              },
              {
                key: 510504,
                value: '龙马潭区',
                id: 510504
              },
              {
                key: 510521,
                value: '泸县',
                id: 510521
              },
              {
                key: 510522,
                value: '合江县',
                id: 510522
              },
              {
                key: 510524,
                value: '叙永县',
                id: 510524
              },
              {
                key: 510525,
                value: '古蔺县',
                id: 510525
              }
            ]
          },
          {
            key: 511400,
            value: '眉山市',
            id: 511400,
            children: [
              {
                key: 511402,
                value: '东坡区',
                id: 511402
              },
              {
                key: 511421,
                value: '仁寿县',
                id: 511421
              },
              {
                key: 511422,
                value: '彭山区',
                id: 511422
              },
              {
                key: 511423,
                value: '洪雅县',
                id: 511423
              },
              {
                key: 511424,
                value: '丹棱县',
                id: 511424
              },
              {
                key: 511425,
                value: '青神县',
                id: 511425
              }
            ]
          },
          {
            key: 510700,
            value: '绵阳市',
            id: 510700,
            children: [
              {
                key: '510703',
                value: '涪城区',
                id: 510703
              },
              {
                key: '510704',
                value: '游仙区',
                id: 510704
              },
              {
                key: '510722',
                value: '三台县',
                id: 510722
              },
              {
                key: '510723',
                value: '盐亭县',
                id: 510723
              },
              {
                key: '510724',
                value: '安州区',
                id: 510724
              },
              {
                key: '510725',
                value: '梓潼县',
                id: 510725
              },
              {
                key: '510726',
                value: '北川羌族自治县',
                id: 510726
              },
              {
                key: '510727',
                value: '平武县',
                id: 510727
              },
              {
                key: '510781',
                value: '江油市',
                id: 510781
              }
            ]
          },
          {
            key: 511000,
            value: '内江市',
            id: 511000,
            children: [
              {
                key: 511002,
                value: '市中区',
                id: 511002
              },
              {
                key: 511011,
                value: '东兴区',
                id: 511011
              },
              {
                key: '511024',
                value: '威远县',
                id: 511024
              },
              {
                key: '511025',
                value: '资中县',
                id: 511025
              },
              {
                key: '511028',
                value: '隆昌市',
                id: 511028
              }
            ]
          },
          {
            key: '511300',
            value: '南充市',
            id: 511300,
            children: [
              {
                key: '511302',
                value: '顺庆区',
                id: 511302
              },
              {
                key: '511303',
                value: '高坪区',
                id: 511303
              },
              {
                key: '511304',
                value: '嘉陵区',
                id: 511304
              },
              {
                key: '511321',
                value: '南部县',
                id: 511321
              },
              {
                key: '511322',
                value: '营山县',
                id: 511322
              },
              {
                key: '511323',
                value: '蓬安县',
                id: 511323
              },
              {
                key: '511324',
                value: '仪陇县',
                id: 511324
              },
              {
                key: '511325',
                value: '西充县',
                id: 511325
              },
              {
                key: '511381',
                value: '阆中市',
                id: 511381
              }
            ]
          },
          {
            key: '510400',
            value: '攀枝花市',
            id: 510400,
            children: [
              {
                key: '510402',
                value: '东区',
                id: 510402
              },
              {
                key: '510403',
                value: '西区',
                id: 510403
              },
              {
                key: '510411',
                value: '仁和区',
                id: 510411
              },
              {
                key: '510421',
                value: '米易县',
                id: 510421
              },
              {
                key: '510422',
                value: '盐边县',
                id: 510422
              }
            ]
          },
          {
            key: '510900',
            value: '遂宁市',
            id: 510900,
            children: [
              {
                key: '510903',
                value: '船山区',
                id: 510903
              },
              {
                key: '510904',
                value: '安居区',
                id: 510904
              },
              {
                key: '510921',
                value: '蓬溪县',
                id: 510921
              },
              {
                key: '510922',
                value: '射洪县',
                id: 510922
              },
              {
                key: '510923',
                value: '大英县',
                id: 510923
              }
            ]
          },
          {
            key: '511800',
            value: '雅安市',
            id: 511800,
            children: [
              {
                key: '511802',
                value: '雨城区',
                id: 511802
              },
              {
                key: '511803',
                value: '名山区',
                id: 511803
              },
              {
                key: '511822',
                value: '荥经县',
                id: 511822
              },
              {
                key: '511823',
                value: '汉源县',
                id: 511823
              },
              {
                key: '511824',
                value: '石棉县',
                id: 511824
              },
              {
                key: '511825',
                value: '天全县',
                id: 511825
              },
              {
                key: '511826',
                value: '芦山县',
                id: 511826
              },
              {
                key: '511827',
                value: '宝兴县',
                id: 511827
              }
            ]
          },
          {
            key: '513200',
            value: '阿坝藏族羌族自治州',
            id: 513200,
            children: [
              {
                key: '513221',
                value: '汶川县',
                id: 513221
              },
              {
                key: '513222',
                value: '理县',
                id: 513222
              },
              {
                key: '513223',
                value: '茂县',
                id: 513223
              },
              {
                key: '513224',
                value: '松潘县',
                id: 513224
              },
              {
                key: '513225',
                value: '九寨沟县',
                id: 513225
              },
              {
                key: '513226',
                value: '金川县',
                id: 513226
              },
              {
                key: '513227',
                value: '小金县',
                id: 513227
              },
              {
                key: '513228',
                value: '黑水县',
                id: 513228
              },
              {
                key: '513229',
                value: '马尔康市',
                id: 513229
              },
              {
                key: '513230',
                value: '壤塘县',
                id: 513230
              },
              {
                key: '513231',
                value: '阿坝县',
                id: 513231
              },
              {
                key: '513232',
                value: '若尔盖县',
                id: 513232
              },
              {
                key: '513233',
                value: '红原县',
                id: 513233
              }
            ]
          },
          {
            key: '511900',
            value: '巴中市',
            id: 511900,
            children: [
              {
                key: '511902',
                value: '巴州区',
                id: 511902
              },
              {
                key: '511903',
                value: '恩阳区',
                id: 511903
              },
              {
                key: '511921',
                value: '通江县',
                id: 511921
              },
              {
                key: '511922',
                value: '南江县',
                id: 511922
              },
              {
                key: '511923',
                value: '平昌县',
                id: 511923
              }
            ]
          },
          {
            key: '510100',
            value: '成都市',
            id: 510100,
            children: [
              {
                key: '510104',
                value: '锦江区',
                id: 510104
              },
              {
                key: '510105',
                value: '青羊区',
                id: 510105
              },
              {
                key: '510106',
                value: '金牛区',
                id: 510106
              },
              {
                key: '510107',
                value: '武侯区',
                id: 510107
              },
              {
                key: '510108',
                value: '成华区',
                id: 510108
              },
              {
                key: '510112',
                value: '龙泉驿区',
                id: 510112
              },
              {
                key: '510113',
                value: '青白江区',
                id: 510113
              },
              {
                key: '510114',
                value: '新都区',
                id: 510114
              },
              {
                key: '510115',
                value: '温江区',
                id: 510115
              },
              {
                key: '510121',
                value: '金堂县',
                id: 510121
              },
              {
                key: '510122',
                value: '双流区',
                id: 510122
              },
              {
                key: '510124',
                value: '郫都区',
                id: 510124
              },
              {
                key: '510129',
                value: '大邑县',
                id: 510129
              },
              {
                key: '510131',
                value: '蒲江县',
                id: 510131
              },
              {
                key: '510132',
                value: '新津县',
                id: 510132
              },
              {
                key: '510181',
                value: '都江堰市',
                id: 510181
              },
              {
                key: '510182',
                value: '彭州市',
                id: 510182
              },
              {
                key: '510183',
                value: '邛崃市',
                id: 510183
              },
              {
                key: '510184',
                value: '崇州市',
                id: 510184
              },
              {
                key: '510185',
                value: '简阳市',
                id: 510185
              }
            ]
          },
          {
            key: '511700',
            value: '达州市',
            id: 511700,
            children: [
              {
                key: '511702',
                value: '通川区',
                id: 511702
              },
              {
                key: '511721',
                value: '达川区',
                id: 511721
              },
              {
                key: '511722',
                value: '宣汉县',
                id: 511722
              },
              {
                key: '511723',
                value: '开江县',
                id: 511723
              },
              {
                key: '511724',
                value: '大竹县',
                id: 511724
              },
              {
                key: '511725',
                value: '渠县',
                id: 511725
              },
              {
                key: '511781',
                value: '万源市',
                id: 511781
              }
            ]
          },
          {
            key: '510600',
            value: '德阳市',
            id: 510600,
            children: [
              {
                key: '510603',
                value: '旌阳区',
                id: 510603
              },
              {
                key: '510623',
                value: '中江县',
                id: 510623
              },
              {
                key: '510626',
                value: '罗江区',
                id: 510626
              },
              {
                key: '510681',
                value: '广汉市',
                id: 510681
              },
              {
                key: '510682',
                value: '什邡市',
                id: 510682
              },
              {
                key: '510683',
                value: '绵竹市',
                id: 510683
              }
            ]
          },
          {
            key: '513300',
            value: '甘孜藏族自治州',
            id: 513300,
            children: [
              {
                key: '513321',
                value: '康定市',
                id: 513321
              },
              {
                key: '513322',
                value: '泸定县',
                id: 513322
              },
              {
                key: '513323',
                value: '丹巴县',
                id: 513323
              },
              {
                key: '513324',
                value: '九龙县',
                id: 513324
              },
              {
                key: '513325',
                value: '雅江县',
                id: 513325
              },
              {
                key: '513326',
                value: '道孚县',
                id: 513326
              },
              {
                key: '513327',
                value: '炉霍县',
                id: 513327
              },
              {
                key: '513328',
                value: '甘孜县',
                id: 513328
              },
              {
                value: '新龙县',
                id: 513329,
                key: '513329'
              },
              {
                key: '513330',
                value: '德格县',
                id: 513330
              },
              {
                key: 513331,
                value: '白玉县',
                id: 513331
              },
              {
                key: 513332,
                value: '石渠县',
                id: 513332
              },
              {
                key: 513333,
                value: '色达县',
                id: 513333
              },
              {
                key: 513334,
                value: '理塘县',
                id: 513334
              },
              {
                key: 513335,
                value: '巴塘县',
                id: 513335
              },
              {
                key: 513336,
                value: '乡城县',
                id: 513336
              },
              {
                key: 513337,
                value: '稻城县',
                id: 513337
              },
              {
                key: 513338,
                value: '得荣县',
                id: 513338
              }
            ]
          },
          {
            key: 511600,
            value: '广安市',
            id: 511600,
            children: [
              {
                key: 511602,
                value: '广安区',
                id: 511602
              },
              {
                key: 511603,
                value: '前锋区',
                id: 511603
              },
              {
                key: 511621,
                value: '岳池县',
                id: 511621
              },
              {
                key: 511622,
                value: '武胜县',
                id: 511622
              },
              {
                key: 511623,
                value: '邻水县',
                id: 511623
              },
              {
                key: 511681,
                value: '华蓥市',
                id: 511681
              }
            ]
          },
          {
            key: 510800,
            value: '广元市',
            id: 510800,
            children: [
              {
                key: 510802,
                value: '利州区',
                id: 510802
              },
              {
                key: 510811,
                value: '昭化区',
                id: 510811
              },
              {
                key: 510812,
                value: '朝天区',
                id: 510812
              },
              {
                key: 510821,
                value: '旺苍县',
                id: 510821
              },
              {
                key: 510822,
                value: '青川县',
                id: 510822
              },
              {
                key: 510823,
                value: '剑阁县',
                id: 510823
              },
              {
                key: 510824,
                value: '苍溪县',
                id: 510824
              }
            ]
          },
          {
            key: 511100,
            value: '乐山市',
            id: 511100,
            children: [
              {
                value: '市中区',
                id: 511102,
                key: 511102
              },
              {
                value: '沙湾区',
                id: 511111,
                key: 511111
              },
              {
                value: '五通桥区',
                id: 511112,
                key: 511112
              },
              {
                value: '金口河区',
                id: 511113,
                key: 511113
              },
              {
                value: '犍为县',
                id: 511123,
                key: 511123
              },
              {
                value: '井研县',
                id: 511124,
                key: 511124
              },
              {
                value: '夹江县',
                id: 511126,
                key: 511126
              },
              {
                value: '沐川县',
                id: 511129,
                key: 511129
              },
              {
                value: '峨边彝族自治县',
                id: 511132,
                key: 511132
              },
              {
                value: '马边彝族自治县',
                id: 511133,
                key: 511133
              },
              {
                value: '峨眉山市',
                id: 511181,
                key: 511181
              }
            ]
          },
          {
            key: 513400,
            value: '凉山彝族自治州',
            id: 513400,
            children: [
              {
                value: '西昌市',
                id: 513401,
                key: 513401
              },
              {
                value: '木里藏族自治县',
                id: 513422,
                key: 513422
              },
              {
                value: '盐源县',
                id: 513423,
                key: 513423
              },
              {
                value: '德昌县',
                id: 513424,
                key: 513424
              },
              {
                value: '会理县',
                id: 513425,
                key: 513425
              },
              {
                value: '会东县',
                id: 513426,
                key: 513426
              },
              {
                value: '宁南县',
                id: 513427,
                key: 513427
              },
              {
                value: '普格县',
                id: 513428,
                key: 513428
              },
              {
                value: '布拖县',
                id: 513429,
                key: 513429
              },
              {
                value: '金阳县',
                id: 513430,
                key: 513430
              },
              {
                value: '昭觉县',
                id: 513431,
                key: 513431
              },
              {
                value: '喜德县',
                id: 513432,
                key: 513432
              },
              {
                value: '冕宁县',
                id: 513433,
                key: 513433
              },
              {
                value: '越西县',
                id: 513434,
                key: 513434
              },
              {
                value: '甘洛县',
                id: 513435,
                key: 513435
              },
              {
                value: '美姑县',
                id: 513436,
                key: 513436
              },
              {
                value: '雷波县',
                id: 513437,
                key: 513437
              }
            ]
          }
        ]
      },
      {
        key: 450000,
        value: '广西壮族自治区',
        id: 450000,
        children: [
          {
            key: 451000,
            value: '百色市',
            id: 451000,
            children: [
              {
                value: '右江区',
                id: 451002,
                key: 451002
              },
              {
                value: '田阳县',
                id: 451021,
                key: 451021
              },
              {
                value: '田东县',
                id: 451022,
                key: 451022
              },
              {
                value: '平果县',
                id: 451023,
                key: 451023
              },
              {
                value: '德保县',
                id: 451024,
                key: 451024
              },
              {
                value: '靖西市',
                id: 451025,
                key: 451025
              },
              {
                value: '那坡县',
                id: 451026,
                key: 451026
              },
              {
                value: '凌云县',
                id: 451027,
                key: 451027
              },
              {
                value: '乐业县',
                id: 451028,
                key: 451028
              },
              {
                value: '田林县',
                id: 451029,
                key: 451029
              },
              {
                value: '西林县',
                id: 451030,
                key: 451030
              },
              {
                value: '隆林各族自治县',
                id: 451031,
                key: 451031
              }
            ]
          },
          {
            key: 450500,
            value: '北海市',
            id: 450500,
            children: [
              {
                value: '海城区',
                id: 450502,
                key: 450502
              },
              {
                value: '银海区',
                id: 450503,
                key: 450503
              },
              {
                value: '铁山港区',
                id: 450512,
                key: 450512
              },
              {
                value: '合浦县',
                id: 450521,
                key: 450521
              }
            ]
          },
          {
            key: 451400,
            value: '崇左市',
            id: 451400,
            children: [
              {
                value: '江州区',
                id: 451402,
                key: 451402
              },
              {
                value: '扶绥县',
                id: 451421,
                key: 451421
              },
              {
                value: '宁明县',
                id: 451422,
                key: 451422
              },
              {
                value: '龙州县',
                id: 451423,
                key: 451423
              },
              {
                value: '大新县',
                id: 451424,
                key: 451424
              },
              {
                value: '天等县',
                id: 451425,
                key: 451425
              },
              {
                value: '凭祥市',
                id: 451481,
                key: 451481
              }
            ]
          },
          {
            key: 450600,
            value: '防城港市',
            id: 450600,
            children: [
              {
                value: '港口区',
                id: 450602,
                key: 450602
              },
              {
                value: '防城区',
                id: 450603,
                key: 450603
              },
              {
                value: '上思县',
                id: 450621,
                key: 450621
              },
              {
                value: '东兴市',
                id: 450681,
                key: 450681
              }
            ]
          },
          {
            key: 450800,
            value: '贵港市',
            id: 450800,
            children: [
              {
                value: '港北区',
                id: 450802,
                key: 450802
              },
              {
                value: '港南区',
                id: 450803,
                key: 450803
              },
              {
                value: '覃塘区',
                id: 450804,
                key: 450804
              },
              {
                value: '平南县',
                id: 450821,
                key: 450821
              },
              {
                value: '桂平市',
                id: 450881,
                key: 450881
              }
            ]
          },
          {
            key: 450300,
            value: '桂林市',
            id: 450300,
            children: [
              {
                value: '秀峰区',
                id: 450302,
                key: 450302
              },
              {
                value: '叠彩区',
                id: 450303,
                key: 450303
              },
              {
                value: '象山区',
                id: 450304,
                key: 450304
              },
              {
                value: '七星区',
                id: 450305,
                key: 450305
              },
              {
                value: '雁山区',
                id: 450311,
                key: 450311
              },
              {
                value: '临桂区',
                id: 450312,
                key: 450312
              },
              {
                value: '阳朔县',
                id: 450321,
                key: 450321
              },
              {
                value: '灵川县',
                id: 450323,
                key: 450323
              },
              {
                value: '全州县',
                id: 450324,
                key: 450324
              },
              {
                value: '兴安县',
                id: 450325,
                key: 450325
              },
              {
                value: '永福县',
                id: 450326,
                key: 450326
              },
              {
                value: '灌阳县',
                id: 450327,
                key: 450327
              },
              {
                value: '龙胜各族自治县',
                id: 450328,
                key: 450328
              },
              {
                value: '资源县',
                id: 450329,
                key: 450329
              },
              {
                value: '平乐县',
                id: 450330,
                key: 450330
              },
              {
                value: '荔浦县',
                id: 450331,
                key: 450331
              },
              {
                value: '恭城瑶族自治县',
                id: 450332,
                key: 450332
              }
            ]
          },
          {
            key: 451200,
            value: '河池市',
            id: 451200,
            children: [
              {
                value: '金城江区',
                id: 451202,
                key: 451202
              },
              {
                value: '南丹县',
                id: 451221,
                key: 451221
              },
              {
                value: '天峨县',
                id: 451222,
                key: 451222
              },
              {
                value: '凤山县',
                id: 451223,
                key: 451223
              },
              {
                value: '东兰县',
                id: 451224,
                key: 451224
              },
              {
                value: '罗城仫佬族自治县',
                id: 451225,
                key: 451225
              },
              {
                value: '环江毛南族自治县',
                id: 451226,
                key: 451226
              },
              {
                value: '巴马瑶族自治县',
                id: 451227,
                key: 451227
              },
              {
                value: '都安瑶族自治县',
                id: 451228,
                key: 451228
              },
              {
                value: '大化瑶族自治县',
                id: 451229,
                key: 451229
              },
              {
                value: '宜州区',
                id: 451281,
                key: 451281
              }
            ]
          },
          {
            key: 451100,
            value: '贺州市',
            id: 451100,
            children: [
              {
                value: '八步区',
                id: 451102,
                key: 451102
              },
              {
                value: '平桂区',
                id: 451103,
                key: 451103
              },
              {
                value: '昭平县',
                id: 451121,
                key: 451121
              },
              {
                value: '钟山县',
                id: 451122,
                key: 451122
              },
              {
                value: '富川瑶族自治县',
                id: 451123,
                key: 451123
              }
            ]
          },
          {
            key: 451300,
            value: '来宾市',
            id: 451300,
            children: [
              {
                value: '兴宾区',
                id: 451302,
                key: 451302
              },
              {
                value: '忻城县',
                id: 451321,
                key: 451321
              },
              {
                value: '象州县',
                id: 451322,
                key: 451322
              },
              {
                value: '武宣县',
                id: 451323,
                key: 451323
              },
              {
                value: '金秀瑶族自治县',
                id: 451324,
                key: 451324
              },
              {
                value: '合山市',
                id: 451381,
                key: 451381
              }
            ]
          },
          {
            key: 450200,
            value: '柳州市',
            id: 450200,
            children: [
              {
                value: '城中区',
                id: 450202,
                key: 450202
              },
              {
                value: '鱼峰区',
                id: 450203,
                key: 450203
              },
              {
                value: '柳南区',
                id: 450204,
                key: 450204
              },
              {
                value: '柳北区',
                id: 450205,
                key: 450205
              },
              {
                value: '柳江区',
                id: 450221,
                key: 450221
              },
              {
                value: '柳城县',
                id: 450222,
                key: 450222
              },
              {
                value: '鹿寨县',
                id: 450223,
                key: 450223
              },
              {
                value: '融安县',
                id: 450224,
                key: 450224
              },
              {
                value: '融水苗族自治县',
                id: 450225,
                key: 450225
              },
              {
                value: '三江侗族自治县',
                id: 450226,
                key: 450226
              }
            ]
          },
          {
            key: 450100,
            value: '南宁市',
            id: 450100,
            children: [
              {
                value: '兴宁区',
                id: 450102,
                key: 450102
              },
              {
                value: '青秀区',
                id: 450103,
                key: 450103
              },
              {
                value: '江南区',
                id: 450105,
                key: 450105
              },
              {
                value: '西乡塘区',
                id: 450107,
                key: 450107
              },
              {
                value: '良庆区',
                id: 450108,
                key: 450108
              },
              {
                value: '邕宁区',
                id: 450109,
                key: 450109
              },
              {
                value: '武鸣区',
                id: 450122,
                key: 450122
              },
              {
                value: '隆安县',
                id: 450123,
                key: 450123
              },
              {
                value: '马山县',
                id: 450124,
                key: 450124
              },
              {
                value: '上林县',
                id: 450125,
                key: 450125
              },
              {
                value: '宾阳县',
                id: 450126,
                key: 450126
              },
              {
                value: '横县',
                id: 450127,
                key: 450127
              }
            ]
          },
          {
            key: 450700,
            value: '钦州市',
            id: 450700,
            children: [
              {
                value: '钦南区',
                id: 450702,
                key: 450702
              },
              {
                value: '钦北区',
                id: 450703,
                key: 450703
              },
              {
                value: '灵山县',
                id: 450721,
                key: 450721
              },
              {
                value: '浦北县',
                id: 450722,
                key: 450722
              }
            ]
          },
          {
            key: 450400,
            value: '梧州市',
            id: 450400,
            children: [
              {
                value: '万秀区',
                id: 450403,
                key: 450403
              },
              {
                value: '长洲区',
                id: 450405,
                key: 450405
              },
              {
                value: '龙圩区',
                id: 450406,
                key: 450406
              },
              {
                value: '苍梧县',
                id: 450421,
                key: 450421
              },
              {
                value: '藤县',
                id: 450422,
                key: 450422
              },
              {
                value: '蒙山县',
                id: 450423,
                key: 450423
              },
              {
                value: '岑溪市',
                id: 450481,
                key: 450481
              }
            ]
          },
          {
            key: 450900,
            value: '玉林市',
            id: 450900,
            children: [
              {
                value: '玉州区',
                id: 450902,
                key: 450902
              },
              {
                value: '福绵区',
                id: 450903,
                key: 450903
              },
              {
                value: '容县',
                id: 450921,
                key: 450921
              },
              {
                value: '陆川县',
                id: 450922,
                key: 450922
              },
              {
                value: '博白县',
                id: 450923,
                key: 450923
              },
              {
                value: '兴业县',
                id: 450924,
                key: 450924
              },
              {
                value: '北流市',
                id: 450981,
                key: 450981
              }
            ]
          }
        ]
      },
      {
        key: 320000,
        value: '江苏省',
        id: 320000,
        children: [
          {
            key: 321000,
            value: '扬州市',
            id: 321000,
            children: [
              {
                value: '广陵区',
                id: 321002,
                key: 321002
              },
              {
                value: '邗江区',
                id: 321003,
                key: 321003
              },
              {
                value: '江都区',
                id: 321012,
                key: 321012
              },
              {
                value: '宝应县',
                id: 321023,
                key: 321023
              },
              {
                value: '仪征市',
                id: 321081,
                key: 321081
              },
              {
                value: '高邮市',
                id: 321084,
                key: 321084
              }
            ]
          },
          {
            key: 321100,
            value: '镇江市',
            id: 321100,
            children: [
              {
                value: '京口区',
                id: 321102,
                key: 321102
              },
              {
                value: '润州区',
                id: 321111,
                key: 321111
              },
              {
                value: '丹徒区',
                id: 321112,
                key: 321112
              },
              {
                value: '丹阳市',
                id: 321181,
                key: 321181
              },
              {
                value: '扬中市',
                id: 321182,
                key: 321182
              },
              {
                value: '句容市',
                id: 321183,
                key: 321183
              }
            ]
          },
          {
            key: 320400,
            value: '常州市',
            id: 320400,
            children: [
              {
                value: '天宁区',
                id: 320402,
                key: 320402
              },
              {
                value: '钟楼区',
                id: 320404,
                key: 320404
              },
              {
                value: '新北区',
                id: 320411,
                key: 320411
              },
              {
                value: '武进区',
                id: 320412,
                key: 320412
              },
              {
                value: '溧阳市',
                id: 320481,
                key: 320481
              },
              {
                value: '金坛区',
                id: 320482,
                key: 320482
              }
            ]
          },
          {
            key: 320800,
            value: '淮安市',
            id: 320800,
            children: [
              {
                value: '淮安区',
                id: 320803,
                key: 320803
              },
              {
                value: '淮阴区',
                id: 320804,
                key: 320804
              },
              {
                value: '清江浦区',
                id: 320812,
                key: 320812
              },
              {
                value: '涟水县',
                id: 320826,
                key: 320826
              },
              {
                value: '洪泽区',
                id: 320829,
                key: 320829
              },
              {
                value: '盱眙县',
                id: 320830,
                key: 320830
              },
              {
                value: '金湖县',
                id: 320831,
                key: 320831
              }
            ]
          },
          {
            key: 320700,
            value: '连云港市',
            id: 320700,
            children: [
              {
                value: '连云区',
                id: 320703,
                key: 320703
              },
              {
                value: '海州区',
                id: 320706,
                key: 320706
              },
              {
                value: '赣榆区',
                id: 320721,
                key: 320721
              },
              {
                value: '东海县',
                id: 320722,
                key: 320722
              },
              {
                value: '灌云县',
                id: 320723,
                key: 320723
              },
              {
                value: '灌南县',
                id: 320724,
                key: 320724
              }
            ]
          },
          {
            key: 320100,
            value: '南京市',
            id: 320100,
            children: [
              {
                value: '玄武区',
                id: 320102,
                key: 320102
              },
              {
                value: '秦淮区',
                id: 320104,
                key: 320104
              },
              {
                value: '建邺区',
                id: 320105,
                key: 320105
              },
              {
                value: '鼓楼区',
                id: 320106,
                key: 320106
              },
              {
                value: '浦口区',
                id: 320111,
                key: 320111
              },
              {
                value: '栖霞区',
                id: 320113,
                key: 320113
              },
              {
                value: '雨花台区',
                id: 320114,
                key: 320114
              },
              {
                value: '江宁区',
                id: 320115,
                key: 320115
              },
              {
                value: '六合区',
                id: 320116,
                key: 320116
              },
              {
                value: '溧水区',
                id: 320117,
                key: 320117
              },
              {
                value: '高淳区',
                id: 320118,
                key: 320118
              }
            ]
          },
          {
            key: 320600,
            value: '南通市',
            id: 320600,
            children: [
              {
                value: '崇川区',
                id: 320602,
                key: 320602
              },
              {
                value: '港闸区',
                id: 320611,
                key: 320611
              },
              {
                value: '通州区',
                id: 320612,
                key: 320612
              },
              {
                value: '海安县',
                id: 320621,
                key: 320621
              },
              {
                value: '如东县',
                id: 320623,
                key: 320623
              },
              {
                value: '启东市',
                id: 320681,
                key: 320681
              },
              {
                value: '如皋市',
                id: 320682,
                key: 320682
              },
              {
                value: '海门市',
                id: 320684,
                key: 320684
              }
            ]
          },
          {
            key: 320500,
            value: '苏州市',
            id: 320500,
            children: [
              {
                value: '虎丘区',
                id: 320505,
                key: 320505
              },
              {
                value: '吴中区',
                id: 320506,
                key: 320506
              },
              {
                value: '相城区',
                id: 320507,
                key: 320507
              },
              {
                value: '姑苏区',
                id: 320508,
                key: 320508
              },
              {
                value: '吴江区',
                id: 320509,
                key: 320509
              },
              {
                value: '常熟市',
                id: 320581,
                key: 320581
              },
              {
                value: '张家港市',
                id: 320582,
                key: 320582
              },
              {
                value: '昆山市',
                id: 320583,
                key: 320583
              },
              {
                value: '太仓市',
                id: 320585,
                key: 320585
              }
            ]
          },
          {
            key: 321300,
            value: '宿迁市',
            id: 321300,
            children: [
              {
                value: '宿城区',
                id: 321302,
                key: 321302
              },
              {
                value: '宿豫区',
                id: 321311,
                key: 321311
              },
              {
                value: '沭阳县',
                id: 321322,
                key: 321322
              },
              {
                value: '泗阳县',
                id: 321323,
                key: 321323
              },
              {
                value: '泗洪县',
                id: 321324,
                key: 321324
              }
            ]
          },
          {
            key: 321200,
            value: '泰州市',
            id: 321200,
            children: [
              {
                value: '海陵区',
                id: 321202,
                key: 321202
              },
              {
                value: '高港区',
                id: 321203,
                key: 321203
              },
              {
                value: '姜堰区',
                id: 321204,
                key: 321204
              },
              {
                value: '兴化市',
                id: 321281,
                key: 321281
              },
              {
                value: '靖江市',
                id: 321282,
                key: 321282
              },
              {
                value: '泰兴市',
                id: 321283,
                key: 321283
              }
            ]
          },
          {
            key: 320200,
            value: '无锡市',
            id: 320200,
            children: [
              {
                value: '锡山区',
                id: 320205,
                key: 320205
              },
              {
                value: '惠山区',
                id: 320206,
                key: 320206
              },
              {
                value: '滨湖区',
                id: 320211,
                key: 320211
              },
              {
                value: '梁溪区',
                id: 320213,
                key: 320213
              },
              {
                value: '新吴区',
                id: 320214,
                key: 320214
              },
              {
                value: '江阴市',
                id: 320281,
                key: 320281
              },
              {
                value: '宜兴市',
                id: 320282,
                key: 320282
              }
            ]
          },
          {
            key: 320300,
            value: '徐州市',
            id: 320300,
            children: [
              {
                value: '鼓楼区',
                id: 320302,
                key: 320302
              },
              {
                value: '云龙区',
                id: 320303,
                key: 320303
              },
              {
                value: '贾汪区',
                id: 320305,
                key: 320305
              },
              {
                value: '泉山区',
                id: 320311,
                key: 320311
              },
              {
                value: '铜山区',
                id: 320312,
                key: 320312
              },
              {
                value: '丰县',
                id: 320321,
                key: 320321
              },
              {
                value: '沛县',
                id: 320322,
                key: 320322
              },
              {
                value: '睢宁县',
                id: 320324,
                key: 320324
              },
              {
                value: '新沂市',
                id: 320381,
                key: 320381
              },
              {
                value: '邳州市',
                id: 320382,
                key: 320382
              }
            ]
          },
          {
            key: 320900,
            value: '盐城市',
            id: 320900,
            children: [
              {
                value: '亭湖区',
                id: 320902,
                key: 320902
              },
              {
                value: '盐都区',
                id: 320903,
                key: 320903
              },
              {
                value: '响水县',
                id: 320921,
                key: 320921
              },
              {
                value: '滨海县',
                id: 320922,
                key: 320922
              },
              {
                value: '阜宁县',
                id: 320923,
                key: 320923
              },
              {
                value: '射阳县',
                id: 320924,
                key: 320924
              },
              {
                value: '建湖县',
                id: 320925,
                key: 320925
              },
              {
                value: '东台市',
                id: 320981,
                key: 320981
              },
              {
                value: '大丰区',
                id: 320982,
                key: 320982
              }
            ]
          }
        ]
      },
      {
        key: 220000,
        value: '吉林省',
        id: 220000,
        children: [
          {
            key: 222400,
            value: '延边朝鲜族自治州',
            id: 222400,
            children: [
              {
                value: '延吉市',
                id: 222401,
                key: 222401
              },
              {
                value: '图们市',
                id: 222402,
                key: 222402
              },
              {
                value: '敦化市',
                id: 222403,
                key: 222403
              },
              {
                value: '珲春市',
                id: 222404,
                key: 222404
              },
              {
                value: '龙井市',
                id: 222405,
                key: 222405
              },
              {
                value: '和龙市',
                id: 222406,
                key: 222406
              },
              {
                value: '汪清县',
                id: 222424,
                key: 222424
              },
              {
                value: '安图县',
                id: 222426,
                key: 222426
              }
            ]
          },
          {
            key: 220400,
            value: '辽源市',
            id: 220400,
            children: [
              {
                value: '龙山区',
                id: 220402,
                key: 220402
              },
              {
                value: '西安区',
                id: 220403,
                key: 220403
              },
              {
                value: '东丰县',
                id: 220421,
                key: 220421
              },
              {
                value: '东辽县',
                id: 220422,
                key: 220422
              }
            ]
          },
          {
            key: 220300,
            value: '四平市',
            id: 220300,
            children: [
              {
                value: '铁西区',
                id: 220302,
                key: 220302
              },
              {
                value: '铁东区',
                id: 220303,
                key: 220303
              },
              {
                value: '梨树县',
                id: 220322,
                key: 220322
              },
              {
                value: '伊通满族自治县',
                id: 220323,
                key: 220323
              },
              {
                value: '公主岭市',
                id: 220381,
                key: 220381
              },
              {
                value: '双辽市',
                id: 220382,
                key: 220382
              }
            ]
          },
          {
            key: 220700,
            value: '松原市',
            id: 220700,
            children: [
              {
                value: '宁江区',
                id: 220702,
                key: 220702
              },
              {
                value: '前郭尔罗斯蒙古族自治县',
                id: 220721,
                key: 220721
              },
              {
                value: '长岭县',
                id: 220722,
                key: 220722
              },
              {
                value: '乾安县',
                id: 220723,
                key: 220723
              },
              {
                value: '扶余市',
                id: 220724,
                key: 220724
              }
            ]
          },
          {
            key: 220500,
            value: '通化市',
            id: 220500,
            children: [
              {
                value: '东昌区',
                id: 220502,
                key: 220502
              },
              {
                value: '二道江区',
                id: 220503,
                key: 220503
              },
              {
                value: '通化县',
                id: 220521,
                key: 220521
              },
              {
                value: '辉南县',
                id: 220523,
                key: 220523
              },
              {
                value: '柳河县',
                id: 220524,
                key: 220524
              },
              {
                value: '梅河口市',
                id: 220581,
                key: 220581
              },
              {
                value: '集安市',
                id: 220582,
                key: 220582
              }
            ]
          },
          {
            key: 220800,
            value: '白城市',
            id: 220800,
            children: [
              {
                value: '洮北区',
                id: 220802,
                key: 220802
              },
              {
                value: '镇赉县',
                id: 220821,
                key: 220821
              },
              {
                value: '通榆县',
                id: 220822,
                key: 220822
              },
              {
                value: '洮南市',
                id: 220881,
                key: 220881
              },
              {
                value: '大安市',
                id: 220882,
                key: 220882
              }
            ]
          },
          {
            key: 220600,
            value: '白山市',
            id: 220600,
            children: [
              {
                value: '浑江区',
                id: 220602,
                key: 220602
              },
              {
                value: '江源区',
                id: 220605,
                key: 220605
              },
              {
                value: '抚松县',
                id: 220621,
                key: 220621
              },
              {
                value: '靖宇县',
                id: 220622,
                key: 220622
              },
              {
                value: '长白朝鲜族自治县',
                id: 220623,
                key: 220623
              },
              {
                value: '临江市',
                id: 220681,
                key: 220681
              }
            ]
          },
          {
            key: 220100,
            value: '长春市',
            id: 220100,
            children: [
              {
                value: '南关区',
                id: 220102,
                key: 220102
              },
              {
                value: '宽城区',
                id: 220103,
                key: 220103
              },
              {
                value: '朝阳区',
                id: 220104,
                key: 220104
              },
              {
                value: '二道区',
                id: 220105,
                key: 220105
              },
              {
                value: '绿园区',
                id: 220106,
                key: 220106
              },
              {
                value: '双阳区',
                id: 220112,
                key: 220112
              },
              {
                value: '农安县',
                id: 220122,
                key: 220122
              },
              {
                value: '九台区',
                id: 220181,
                key: 220181
              },
              {
                value: '榆树市',
                id: 220182,
                key: 220182
              },
              {
                value: '德惠市',
                id: 220183,
                key: 220183
              }
            ]
          },
          {
            key: 220200,
            value: '吉林市',
            id: 220200,
            children: [
              {
                value: '昌邑区',
                id: 220202,
                key: 220202
              },
              {
                value: '龙潭区',
                id: 220203,
                key: 220203
              },
              {
                value: '船营区',
                id: 220204,
                key: 220204
              },
              {
                value: '丰满区',
                id: 220211,
                key: 220211
              },
              {
                value: '永吉县',
                id: 220221,
                key: 220221
              },
              {
                value: '蛟河市',
                id: 220281,
                key: 220281
              },
              {
                value: '桦甸市',
                id: 220282,
                key: 220282
              },
              {
                value: '舒兰市',
                id: 220283,
                key: 220283
              },
              {
                value: '磐石市',
                id: 220284,
                key: 220284
              }
            ]
          }
        ]
      },
      {
        key: 370000,
        value: '山东省',
        id: 370000,
        children: [
          {
            key: 371600,
            value: '滨州市',
            id: 371600,
            children: [
              {
                value: '滨城区',
                id: 371602,
                key: 371602
              },
              {
                value: '沾化区',
                id: 371603,
                key: 371603
              },
              {
                value: '惠民县',
                id: 371621,
                key: 371621
              },
              {
                value: '阳信县',
                id: 371622,
                key: 371622
              },
              {
                value: '无棣县',
                id: 371623,
                key: 371623
              },
              {
                value: '博兴县',
                id: 371625,
                key: 371625
              },
              {
                value: '邹平县',
                id: 371626,
                key: 371626
              }
            ]
          },
          {
            key: 371400,
            value: '德州市',
            id: 371400,
            children: [
              {
                value: '德城区',
                id: 371402,
                key: 371402
              },
              {
                value: '陵城区',
                id: 371403,
                key: 371403
              },
              {
                value: '宁津县',
                id: 371422,
                key: 371422
              },
              {
                value: '庆云县',
                id: 371423,
                key: 371423
              },
              {
                value: '临邑县',
                id: 371424,
                key: 371424
              },
              {
                value: '齐河县',
                id: 371425,
                key: 371425
              },
              {
                value: '平原县',
                id: 371426,
                key: 371426
              },
              {
                value: '夏津县',
                id: 371427,
                key: 371427
              },
              {
                value: '武城县',
                id: 371428,
                key: 371428
              },
              {
                value: '乐陵市',
                id: 371481,
                key: 371481
              },
              {
                value: '禹城市',
                id: 371482,
                key: 371482
              }
            ]
          },
          {
            key: 370500,
            value: '东营市',
            id: 370500,
            children: [
              {
                value: '东营区',
                id: 370502,
                key: 370502
              },
              {
                value: '河口区',
                id: 370503,
                key: 370503
              },
              {
                value: '垦利区',
                id: 370521,
                key: 370521
              },
              {
                value: '利津县',
                id: 370522,
                key: 370522
              },
              {
                value: '广饶县',
                id: 370523,
                key: 370523
              }
            ]
          },
          {
            key: 371700,
            value: '菏泽市',
            id: 371700,
            children: [
              {
                value: '牡丹区',
                id: 371702,
                key: 371702
              },
              {
                value: '曹县',
                id: 371721,
                key: 371721
              },
              {
                value: '单县',
                id: 371722,
                key: 371722
              },
              {
                value: '成武县',
                id: 371723,
                key: 371723
              },
              {
                value: '巨野县',
                id: 371724,
                key: 371724
              },
              {
                value: '郓城县',
                id: 371725,
                key: 371725
              },
              {
                value: '鄄城县',
                id: 371726,
                key: 371726
              },
              {
                value: '定陶区',
                id: 371727,
                key: 371727
              },
              {
                value: '东明县',
                id: 371728,
                key: 371728
              }
            ]
          },
          {
            key: 370100,
            value: '济南市',
            id: 370100,
            children: [
              {
                value: '历下区',
                id: 370102,
                key: 370102
              },
              {
                value: '市中区',
                id: 370103,
                key: 370103
              },
              {
                value: '槐荫区',
                id: 370104,
                key: 370104
              },
              {
                value: '天桥区',
                id: 370105,
                key: 370105
              },
              {
                value: '历城区',
                id: 370112,
                key: 370112
              },
              {
                value: '长清区',
                id: 370113,
                key: 370113
              },
              {
                value: '平阴县',
                id: 370124,
                key: 370124
              },
              {
                value: '济阳县',
                id: 370125,
                key: 370125
              },
              {
                value: '商河县',
                id: 370126,
                key: 370126
              },
              {
                value: '章丘区',
                id: 370181,
                key: 370181
              }
            ]
          },
          {
            key: 370800,
            value: '济宁市',
            id: 370800,
            children: [
              {
                value: '任城区',
                id: 370811,
                key: 370811
              },
              {
                value: '兖州区',
                id: 370812,
                key: 370812
              },
              {
                value: '微山县',
                id: 370826,
                key: 370826
              },
              {
                value: '鱼台县',
                id: 370827,
                key: 370827
              },
              {
                value: '金乡县',
                id: 370828,
                key: 370828
              },
              {
                value: '嘉祥县',
                id: 370829,
                key: 370829
              },
              {
                value: '汶上县',
                id: 370830,
                key: 370830
              },
              {
                value: '泗水县',
                id: 370831,
                key: 370831
              },
              {
                value: '梁山县',
                id: 370832,
                key: 370832
              },
              {
                value: '曲阜市',
                id: 370881,
                key: 370881
              },
              {
                value: '邹城市',
                id: 370883,
                key: 370883
              }
            ]
          },
          {
            key: 371200,
            value: '莱芜市',
            id: 371200,
            children: [
              {
                value: '莱城区',
                id: 371202,
                key: 371202
              },
              {
                value: '钢城区',
                id: 371203,
                key: 371203
              }
            ]
          },
          {
            key: 371500,
            value: '聊城市',
            id: 371500,
            children: [
              {
                value: '东昌府区',
                id: 371502,
                key: 371502
              },
              {
                value: '阳谷县',
                id: 371521,
                key: 371521
              },
              {
                value: '莘县',
                id: 371522,
                key: 371522
              },
              {
                value: '茌平县',
                id: 371523,
                key: 371523
              },
              {
                value: '东阿县',
                id: 371524,
                key: 371524
              },
              {
                value: '冠县',
                id: 371525,
                key: 371525
              },
              {
                value: '高唐县',
                id: 371526,
                key: 371526
              },
              {
                value: '临清市',
                id: 371581,
                key: 371581
              }
            ]
          },
          {
            key: 371300,
            value: '临沂市',
            id: 371300,
            children: [
              {
                value: '兰山区',
                id: 371302,
                key: 371302
              },
              {
                value: '罗庄区',
                id: 371311,
                key: 371311
              },
              {
                value: '河东区',
                id: 371312,
                key: 371312
              },
              {
                value: '沂南县',
                id: 371321,
                key: 371321
              },
              {
                value: '郯城县',
                id: 371322,
                key: 371322
              },
              {
                value: '沂水县',
                id: 371323,
                key: 371323
              },
              {
                value: '兰陵县',
                id: 371324,
                key: 371324
              },
              {
                value: '费县',
                id: 371325,
                key: 371325
              },
              {
                value: '平邑县',
                id: 371326,
                key: 371326
              },
              {
                value: '莒南县',
                id: 371327,
                key: 371327
              },
              {
                value: '蒙阴县',
                id: 371328,
                key: 371328
              },
              {
                value: '临沭县',
                id: 371329,
                key: 371329
              }
            ]
          },
          {
            key: 370200,
            value: '青岛市',
            id: 370200,
            children: [
              {
                value: '市南区',
                id: 370202,
                key: 370202
              },
              {
                value: '市北区',
                id: 370203,
                key: 370203
              },
              {
                value: '黄岛区',
                id: 370211,
                key: 370211
              },
              {
                value: '崂山区',
                id: 370212,
                key: 370212
              },
              {
                value: '李沧区',
                id: 370213,
                key: 370213
              },
              {
                value: '城阳区',
                id: 370214,
                key: 370214
              },
              {
                value: '胶州市',
                id: 370281,
                key: 370281
              },
              {
                value: '即墨区',
                id: 370282,
                key: 370282
              },
              {
                value: '平度市',
                id: 370283,
                key: 370283
              },
              {
                value: '莱西市',
                id: 370285,
                key: 370285
              }
            ]
          },
          {
            key: 371100,
            value: '日照市',
            id: 371100,
            children: [
              {
                value: '东港区',
                id: 371102,
                key: 371102
              },
              {
                value: '岚山区',
                id: 371103,
                key: 371103
              },
              {
                value: '五莲县',
                id: 371121,
                key: 371121
              },
              {
                value: '莒县',
                id: 371122,
                key: 371122
              }
            ]
          },
          {
            key: 370900,
            value: '泰安市',
            id: 370900,
            children: [
              {
                value: '泰山区',
                id: 370902,
                key: 370902
              },
              {
                value: '岱岳区',
                id: 370911,
                key: 370911
              },
              {
                value: '宁阳县',
                id: 370921,
                key: 370921
              },
              {
                value: '东平县',
                id: 370923,
                key: 370923
              },
              {
                value: '新泰市',
                id: 370982,
                key: 370982
              },
              {
                value: '肥城市',
                id: 370983,
                key: 370983
              }
            ]
          },
          {
            key: 371000,
            value: '威海市',
            id: 371000,
            children: [
              {
                value: '环翠区',
                id: 371002,
                key: 371002
              },
              {
                value: '文登区',
                id: 371081,
                key: 371081
              },
              {
                value: '荣成市',
                id: 371082,
                key: 371082
              },
              {
                value: '乳山市',
                id: 371083,
                key: 371083
              }
            ]
          },
          {
            key: 370700,
            value: '潍坊市',
            id: 370700,
            children: [
              {
                value: '潍城区',
                id: 370702,
                key: 370702
              },
              {
                value: '寒亭区',
                id: 370703,
                key: 370703
              },
              {
                value: '坊子区',
                id: 370704,
                key: 370704
              },
              {
                value: '奎文区',
                id: 370705,
                key: 370705
              },
              {
                value: '临朐县',
                id: 370724,
                key: 370724
              },
              {
                value: '昌乐县',
                id: 370725,
                key: 370725
              },
              {
                value: '青州市',
                id: 370781,
                key: 370781
              },
              {
                value: '诸城市',
                id: 370782,
                key: 370782
              },
              {
                value: '寿光市',
                id: 370783,
                key: 370783
              },
              {
                value: '安丘市',
                id: 370784,
                key: 370784
              },
              {
                value: '高密市',
                id: 370785,
                key: 370785
              },
              {
                value: '昌邑市',
                id: 370786,
                key: 370786
              }
            ]
          },
          {
            key: 370600,
            value: '烟台市',
            id: 370600,
            children: [
              {
                value: '芝罘区',
                id: 370602,
                key: 370602
              },
              {
                value: '福山区',
                id: 370611,
                key: 370611
              },
              {
                value: '牟平区',
                id: 370612,
                key: 370612
              },
              {
                value: '莱山区',
                id: 370613,
                key: 370613
              },
              {
                value: '长岛县',
                id: 370634,
                key: 370634
              },
              {
                value: '龙口市',
                id: 370681,
                key: 370681
              },
              {
                value: '莱阳市',
                id: 370682,
                key: 370682
              },
              {
                value: '莱州市',
                id: 370683,
                key: 370683
              },
              {
                value: '蓬莱市',
                id: 370684,
                key: 370684
              },
              {
                value: '招远市',
                id: 370685,
                key: 370685
              },
              {
                value: '栖霞市',
                id: 370686,
                key: 370686
              },
              {
                value: '海阳市',
                id: 370687,
                key: 370687
              }
            ]
          },
          {
            key: 370400,
            value: '枣庄市',
            id: 370400,
            children: [
              {
                value: '市中区',
                id: 370402,
                key: 370402
              },
              {
                value: '薛城区',
                id: 370403,
                key: 370403
              },
              {
                value: '峄城区',
                id: 370404,
                key: 370404
              },
              {
                value: '台儿庄区',
                id: 370405,
                key: 370405
              },
              {
                value: '山亭区',
                id: 370406,
                key: 370406
              },
              {
                value: '滕州市',
                id: 370481,
                key: 370481
              }
            ]
          },
          {
            key: 370300,
            value: '淄博市',
            id: 370300,
            children: [
              {
                value: '淄川区',
                id: 370302,
                key: 370302
              },
              {
                value: '张店区',
                id: 370303,
                key: 370303
              },
              {
                value: '博山区',
                id: 370304,
                key: 370304
              },
              {
                value: '临淄区',
                id: 370305,
                key: 370305
              },
              {
                value: '周村区',
                id: 370306,
                key: 370306
              },
              {
                value: '桓台县',
                id: 370321,
                key: 370321
              },
              {
                value: '高青县',
                id: 370322,
                key: 370322
              },
              {
                value: '沂源县',
                id: 370323,
                key: 370323
              }
            ]
          }
        ]
      },
      {
        key: 340000,
        value: '安徽省',
        id: 340000,
        children: [
          {
            key: 340800,
            value: '安庆市',
            id: 340800,
            children: [
              {
                value: '迎江区',
                id: 340802,
                key: 340802
              },
              {
                value: '大观区',
                id: 340803,
                key: 340803
              },
              {
                value: '宜秀区',
                id: 340811,
                key: 340811
              },
              {
                value: '怀宁县',
                id: 340822,
                key: 340822
              },
              {
                value: '潜山县',
                id: 340824,
                key: 340824
              },
              {
                value: '太湖县',
                id: 340825,
                key: 340825
              },
              {
                value: '宿松县',
                id: 340826,
                key: 340826
              },
              {
                value: '望江县',
                id: 340827,
                key: 340827
              },
              {
                value: '岳西县',
                id: 340828,
                key: 340828
              },
              {
                value: '桐城市',
                id: 340881,
                key: 340881
              }
            ]
          },
          {
            key: 340300,
            value: '蚌埠市',
            id: 340300,
            children: [
              {
                value: '龙子湖区',
                id: 340302,
                key: 340302
              },
              {
                value: '蚌山区',
                id: 340303,
                key: 340303
              },
              {
                value: '禹会区',
                id: 340304,
                key: 340304
              },
              {
                value: '淮上区',
                id: 340311,
                key: 340311
              },
              {
                value: '怀远县',
                id: 340321,
                key: 340321
              },
              {
                value: '五河县',
                id: 340322,
                key: 340322
              },
              {
                value: '固镇县',
                id: 340323,
                key: 340323
              }
            ]
          },
          {
            key: 341600,
            value: '亳州市',
            id: 341600,
            children: [
              {
                value: '谯城区',
                id: 341602,
                key: 341602
              },
              {
                value: '涡阳县',
                id: 341621,
                key: 341621
              },
              {
                value: '蒙城县',
                id: 341622,
                key: 341622
              },
              {
                value: '利辛县',
                id: 341623,
                key: 341623
              }
            ]
          },
          {
            key: 341700,
            value: '池州市',
            id: 341700,
            children: [
              {
                value: '贵池区',
                id: 341702,
                key: 341702
              },
              {
                value: '东至县',
                id: 341721,
                key: 341721
              },
              {
                value: '石台县',
                id: 341722,
                key: 341722
              },
              {
                value: '青阳县',
                id: 341723,
                key: 341723
              }
            ]
          },
          {
            key: 341100,
            value: '滁州市',
            id: 341100,
            children: [
              {
                value: '琅琊区',
                id: 341102,
                key: 341102
              },
              {
                value: '南谯区',
                id: 341103,
                key: 341103
              },
              {
                value: '来安县',
                id: 341122,
                key: 341122
              },
              {
                value: '全椒县',
                id: 341124,
                key: 341124
              },
              {
                value: '定远县',
                id: 341125,
                key: 341125
              },
              {
                value: '凤阳县',
                id: 341126,
                key: 341126
              },
              {
                value: '天长市',
                id: 341181,
                key: 341181
              },
              {
                value: '明光市',
                id: 341182,
                key: 341182
              }
            ]
          },
          {
            key: 341200,
            value: '阜阳市',
            id: 341200,
            children: [
              {
                value: '颍州区',
                id: 341202,
                key: 341202
              },
              {
                value: '颍东区',
                id: 341203,
                key: 341203
              },
              {
                value: '颍泉区',
                id: 341204,
                key: 341204
              },
              {
                value: '临泉县',
                id: 341221,
                key: 341221
              },
              {
                value: '太和县',
                id: 341222,
                key: 341222
              },
              {
                value: '阜南县',
                id: 341225,
                key: 341225
              },
              {
                value: '颍上县',
                id: 341226,
                key: 341226
              },
              {
                value: '界首市',
                id: 341282,
                key: 341282
              }
            ]
          },
          {
            key: 340100,
            value: '合肥市',
            id: 340100,
            children: [
              {
                value: '瑶海区',
                id: 340102,
                key: 340102
              },
              {
                value: '庐阳区',
                id: 340103,
                key: 340103
              },
              {
                value: '蜀山区',
                id: 340104,
                key: 340104
              },
              {
                value: '包河区',
                id: 340111,
                key: 340111
              },
              {
                value: '长丰县',
                id: 340121,
                key: 340121
              },
              {
                value: '肥东县',
                id: 340122,
                key: 340122
              },
              {
                value: '肥西县',
                id: 340123,
                key: 340123
              },
              {
                value: '庐江县',
                id: 340124,
                key: 340124
              },
              {
                value: '巢湖市',
                id: 340181,
                key: 340181
              }
            ]
          },
          {
            key: 340600,
            value: '淮北市',
            id: 340600,
            children: [
              {
                value: '杜集区',
                id: 340602,
                key: 340602
              },
              {
                value: '相山区',
                id: 340603,
                key: 340603
              },
              {
                value: '烈山区',
                id: 340604,
                key: 340604
              },
              {
                value: '濉溪县',
                id: 340621,
                key: 340621
              }
            ]
          },
          {
            key: 340400,
            value: '淮南市',
            id: 340400,
            children: [
              {
                value: '大通区',
                id: 340402,
                key: 340402
              },
              {
                value: '田家庵区',
                id: 340403,
                key: 340403
              },
              {
                value: '谢家集区',
                id: 340404,
                key: 340404
              },
              {
                value: '八公山区',
                id: 340405,
                key: 340405
              },
              {
                value: '潘集区',
                id: 340406,
                key: 340406
              },
              {
                value: '凤台县',
                id: 340421,
                key: 340421
              },
              {
                value: '寿县',
                id: 340422,
                key: 340422
              }
            ]
          },
          {
            key: 341000,
            value: '黄山市',
            id: 341000,
            children: [
              {
                value: '屯溪区',
                id: 341002,
                key: 341002
              },
              {
                value: '黄山区',
                id: 341003,
                key: 341003
              },
              {
                value: '徽州区',
                id: 341004,
                key: 341004
              },
              {
                value: '歙县',
                id: 341021,
                key: 341021
              },
              {
                value: '休宁县',
                id: 341022,
                key: 341022
              },
              {
                value: '黟县',
                id: 341023,
                key: 341023
              },
              {
                value: '祁门县',
                id: 341024,
                key: 341024
              }
            ]
          },
          {
            key: 341500,
            value: '六安市',
            id: 341500,
            children: [
              {
                value: '金安区',
                id: 341502,
                key: 341502
              },
              {
                value: '裕安区',
                id: 341503,
                key: 341503
              },
              {
                value: '叶集区',
                id: 341504,
                key: 341504
              },
              {
                value: '霍邱县',
                id: 341522,
                key: 341522
              },
              {
                value: '舒城县',
                id: 341523,
                key: 341523
              },
              {
                value: '金寨县',
                id: 341524,
                key: 341524
              },
              {
                value: '霍山县',
                id: 341525,
                key: 341525
              }
            ]
          },
          {
            key: 340500,
            value: '马鞍山市',
            id: 340500,
            children: [
              {
                value: '花山区',
                id: 340503,
                key: 340503
              },
              {
                value: '雨山区',
                id: 340504,
                key: 340504
              },
              {
                value: '博望区',
                id: 340506,
                key: 340506
              },
              {
                value: '当涂县',
                id: 340521,
                key: 340521
              },
              {
                value: '含山县',
                id: 340522,
                key: 340522
              },
              {
                value: '和县',
                id: 340523,
                key: 340523
              }
            ]
          },
          {
            key: 341300,
            value: '宿州市',
            id: 341300,
            children: [
              {
                value: '埇桥区',
                id: 341302,
                key: 341302
              },
              {
                value: '砀山县',
                id: 341321,
                key: 341321
              },
              {
                value: '萧县',
                id: 341322,
                key: 341322
              },
              {
                value: '灵璧县',
                id: 341323,
                key: 341323
              },
              {
                value: '泗县',
                id: 341324,
                key: 341324
              }
            ]
          },
          {
            key: 340700,
            value: '铜陵市',
            id: 340700,
            children: [
              {
                value: '铜官区',
                id: 340705,
                key: 340705
              },
              {
                value: '义安区',
                id: 340706,
                key: 340706
              },
              {
                value: '郊区',
                id: 340711,
                key: 340711
              },
              {
                value: '枞阳县',
                id: 340722,
                key: 340722
              }
            ]
          },
          {
            key: 340200,
            value: '芜湖市',
            id: 340200,
            children: [
              {
                value: '镜湖区',
                id: 340202,
                key: 340202
              },
              {
                value: '弋江区',
                id: 340203,
                key: 340203
              },
              {
                value: '鸠江区',
                id: 340207,
                key: 340207
              },
              {
                value: '三山区',
                id: 340208,
                key: 340208
              },
              {
                value: '芜湖县',
                id: 340221,
                key: 340221
              },
              {
                value: '繁昌县',
                id: 340222,
                key: 340222
              },
              {
                value: '南陵县',
                id: 340223,
                key: 340223
              },
              {
                value: '无为县',
                id: 340225,
                key: 340225
              }
            ]
          },
          {
            key: 341800,
            value: '宣城市',
            id: 341800,
            children: [
              {
                value: '宣州区',
                id: 341802,
                key: 341802
              },
              {
                value: '郎溪县',
                id: 341821,
                key: 341821
              },
              {
                value: '广德县',
                id: 341822,
                key: 341822
              },
              {
                value: '泾县',
                id: 341823,
                key: 341823
              },
              {
                value: '绩溪县',
                id: 341824,
                key: 341824
              },
              {
                value: '旌德县',
                id: 341825,
                key: 341825
              },
              {
                value: '宁国市',
                id: 341881,
                key: 341881
              }
            ]
          }
        ]
      },
      {
        key: 150000,
        value: '内蒙古自治区',
        id: 150000,
        children: [
          {
            key: 150100,
            value: '呼和浩特市',
            id: 150100,
            children: [
              {
                value: '新城区',
                id: 150102,
                key: 150102
              },
              {
                value: '回民区',
                id: 150103,
                key: 150103
              },
              {
                value: '玉泉区',
                id: 150104,
                key: 150104
              },
              {
                value: '赛罕区',
                id: 150105,
                key: 150105
              },
              {
                value: '土默特左旗',
                id: 150121,
                key: 150121
              },
              {
                value: '托克托县',
                id: 150122,
                key: 150122
              },
              {
                value: '和林格尔县',
                id: 150123,
                key: 150123
              },
              {
                value: '清水河县',
                id: 150124,
                key: 150124
              },
              {
                value: '武川县',
                id: 150125,
                key: 150125
              }
            ]
          },
          {
            key: 150700,
            value: '呼伦贝尔市',
            id: 150700,
            children: [
              {
                value: '海拉尔区',
                id: 150702,
                key: 150702
              },
              {
                value: '扎赉诺尔区',
                id: 150703,
                key: 150703
              },
              {
                value: '阿荣旗',
                id: 150721,
                key: 150721
              },
              {
                value: '莫力达瓦达斡尔族自治旗',
                id: 150722,
                key: 150722
              },
              {
                value: '鄂伦春自治旗',
                id: 150723,
                key: 150723
              },
              {
                value: '鄂温克族自治旗',
                id: 150724,
                key: 150724
              },
              {
                value: '陈巴尔虎旗',
                id: 150725,
                key: 150725
              },
              {
                value: '新巴尔虎左旗',
                id: 150726,
                key: 150726
              },
              {
                value: '新巴尔虎右旗',
                id: 150727,
                key: 150727
              },
              {
                value: '满洲里市',
                id: 150781,
                key: 150781
              },
              {
                value: '牙克石市',
                id: 150782,
                key: 150782
              },
              {
                value: '扎兰屯市',
                id: 150783,
                key: 150783
              },
              {
                value: '额尔古纳市',
                id: 150784,
                key: 150784
              },
              {
                value: '根河市',
                id: 150785,
                vakeylue: 150785
              }
            ]
          },
          {
            key: 150500,
            value: '通辽市',
            id: 150500,
            children: [
              {
                value: '科尔沁区',
                id: 150502,
                key: 150502
              },
              {
                value: '科尔沁左翼中旗',
                id: 150521,
                key: 150521
              },
              {
                value: '科尔沁左翼后旗',
                id: 150522,
                key: 150522
              },
              {
                value: '开鲁县',
                id: 150523,
                key: 150523
              },
              {
                value: '库伦旗',
                id: 150524,
                key: 150524
              },
              {
                value: '奈曼旗',
                id: 150525,
                key: 150525
              },
              {
                value: '扎鲁特旗',
                id: 150526,
                key: 150526
              },
              {
                value: '霍林郭勒市',
                id: 150581,
                key: 150581
              }
            ]
          },
          {
            key: 150300,
            value: '乌海市',
            id: 150300,
            children: [
              {
                value: '海勃湾区',
                id: 150302,
                key: 150302
              },
              {
                value: '海南区',
                id: 150303,
                key: 150303
              },
              {
                value: '乌达区',
                id: 150304,
                key: 150304
              }
            ]
          },
          {
            key: 150900,
            value: '乌兰察布市',
            id: 150900,
            children: [
              {
                value: '集宁区',
                id: 150902,
                key: 150902
              },
              {
                value: '卓资县',
                id: 150921,
                key: 150921
              },
              {
                value: '化德县',
                id: 150922,
                key: 150922
              },
              {
                value: '商都县',
                id: 150923,
                key: 150923
              },
              {
                value: '兴和县',
                id: 150924,
                key: 150924
              },
              {
                value: '凉城县',
                id: 150925,
                key: 150925
              },
              {
                value: '察哈尔右翼前旗',
                id: 150926,
                key: 150926
              },
              {
                value: '察哈尔右翼中旗',
                id: 150927,
                key: 150927
              },
              {
                value: '察哈尔右翼后旗',
                id: 150928,
                key: 150928
              },
              {
                value: '四子王旗',
                id: 150929,
                key: 150929
              },
              {
                value: '丰镇市',
                id: 150981,
                key: 150981
              }
            ]
          },
          {
            key: 152500,
            value: '锡林郭勒盟',
            id: 152500,
            children: [
              {
                value: '二连浩特市',
                id: 152501,
                key: 152501
              },
              {
                value: '锡林浩特市',
                id: 152502,
                key: 152502
              },
              {
                value: '阿巴嘎旗',
                id: 152522,
                key: 152522
              },
              {
                value: '苏尼特左旗',
                id: 152523,
                key: 152523
              },
              {
                value: '苏尼特右旗',
                id: 152524,
                key: 152524
              },
              {
                value: '东乌珠穆沁旗',
                id: 152525,
                key: 152525
              },
              {
                value: '西乌珠穆沁旗',
                id: 152526,
                key: 152526
              },
              {
                value: '太仆寺旗',
                id: 152527,
                key: 152527
              },
              {
                value: '镶黄旗',
                id: 152528,
                key: 152528
              },
              {
                value: '正镶白旗',
                id: 152529,
                key: 152529
              },
              {
                value: '正蓝旗',
                id: 152530,
                key: 152530
              },
              {
                value: '多伦县',
                id: 152531,
                key: 152531
              }
            ]
          },
          {
            key: 152200,
            value: '兴安盟',
            id: 152200,
            children: [
              {
                value: '乌兰浩特市',
                id: 152201,
                key: 152201
              },
              {
                value: '阿尔山市',
                id: 152202,
                key: 152202
              },
              {
                value: '科尔沁右翼前旗',
                id: 152221,
                key: 152221
              },
              {
                value: '科尔沁右翼中旗',
                id: 152222,
                key: 152222
              },
              {
                value: '扎赉特旗',
                id: 152223,
                key: 152223
              },
              {
                value: '突泉县',
                id: 152224,
                key: 152224
              }
            ]
          },
          {
            key: 152900,
            value: '阿拉善盟',
            id: 152900,
            children: [
              {
                value: '阿拉善左旗',
                id: 152921,
                key: 152921
              },
              {
                value: '阿拉善右旗',
                id: 152922,
                key: 152922
              },
              {
                value: '额济纳旗',
                id: 152923,
                key: 152923
              }
            ]
          },
          {
            key: 150800,
            value: '巴彦淖尔市',
            id: 150800,
            children: [
              {
                value: '临河区',
                id: 150802,
                key: 150802
              },
              {
                value: '五原县',
                id: 150821,
                key: 150821
              },
              {
                value: '磴口县',
                id: 150822,
                key: 150822
              },
              {
                value: '乌拉特前旗',
                id: 150823,
                key: 150823
              },
              {
                value: '乌拉特中旗',
                id: 150824,
                key: 150824
              },
              {
                value: '乌拉特后旗',
                id: 150825,
                key: 150825
              },
              {
                value: '杭锦后旗',
                id: 150826,
                key: 150826
              }
            ]
          },
          {
            key: 150200,
            value: '包头市',
            id: 150200,
            children: [
              {
                value: '东河区',
                id: 150202,
                key: 150202
              },
              {
                value: '昆都仑区',
                id: 150203,
                key: 150203
              },
              {
                value: '青山区',
                id: 150204,
                key: 150204
              },
              {
                value: '石拐区',
                id: 150205,
                key: 150205
              },
              {
                value: '白云鄂博矿区',
                id: 150206,
                key: 150206
              },
              {
                value: '九原区',
                id: 150207,
                key: 150207
              },
              {
                value: '土默特右旗',
                id: 150221,
                key: 150221
              },
              {
                value: '固阳县',
                id: 150222,
                key: 150222
              },
              {
                value: '达尔罕茂明安联合旗',
                id: 150223,
                key: 150223
              }
            ]
          },
          {
            key: 150400,
            value: '赤峰市',
            id: 150400,
            children: [
              {
                value: '红山区',
                id: 150402,
                key: 150402
              },
              {
                value: '元宝山区',
                id: 150403,
                key: 150403
              },
              {
                value: '松山区',
                id: 150404,
                key: 150404
              },
              {
                value: '阿鲁科尔沁旗',
                id: 150421,
                key: 150421
              },
              {
                value: '巴林左旗',
                id: 150422,
                key: 150422
              },
              {
                value: '巴林右旗',
                id: 150423,
                key: 150423
              },
              {
                value: '林西县',
                id: 150424,
                key: 150424
              },
              {
                value: '克什克腾旗',
                id: 150425,
                key: 150425
              },
              {
                value: '翁牛特旗',
                id: 150426,
                key: 150426
              },
              {
                value: '喀喇沁旗',
                id: 150428,
                key: 150428
              },
              {
                value: '宁城县',
                id: 150429,
                key: 150429
              },
              {
                value: '敖汉旗',
                id: 150430,
                key: 150430
              }
            ]
          },
          {
            key: 150600,
            value: '鄂尔多斯市',
            id: 150600,
            children: [
              {
                value: '东胜区',
                id: 150602,
                key: 150602
              },
              {
                value: '康巴什区',
                id: 150603,
                key: 150603
              },
              {
                value: '达拉特旗',
                id: 150621,
                key: 150621
              },
              {
                value: '准格尔旗',
                id: 150622,
                key: 150622
              },
              {
                value: '鄂托克前旗',
                id: 150623,
                key: 150623
              },
              {
                value: '鄂托克旗',
                id: 150624,
                key: 150624
              },
              {
                value: '杭锦旗',
                id: 150625,
                key: 150625
              },
              {
                value: '乌审旗',
                id: 150626,
                key: 150626
              },
              {
                value: '伊金霍洛旗',
                id: 150627,
                key: 150627
              }
            ]
          }
        ]
      },
      {
        key: 140000,
        value: '山西省',
        id: 140000,
        children: [
          {
            key: 140400,
            value: '长治市',
            id: 140400,
            children: [
              {
                value: '城区',
                id: 140402,
                key: 140402
              },
              {
                value: '郊区',
                id: 140411,
                key: 140411
              },
              {
                value: '长治县',
                id: 140421,
                key: 140421
              },
              {
                value: '襄垣县',
                id: 140423,
                key: 140423
              },
              {
                value: '屯留县',
                id: 140424,
                key: 140424
              },
              {
                value: '平顺县',
                id: 140425,
                key: 140425
              },
              {
                value: '黎城县',
                id: 140426,
                key: 140426
              },
              {
                value: '壶关县',
                id: 140427,
                key: 140427
              },
              {
                value: '长子县',
                id: 140428,
                key: 140428
              },
              {
                value: '武乡县',
                id: 140429,
                key: 140429
              },
              {
                value: '沁县',
                id: 140430,
                key: 140430
              },
              {
                value: '沁源县',
                id: 140431,
                key: 140431
              },
              {
                value: '潞城市',
                id: 140481,
                key: 140481
              }
            ]
          },
          {
            key: 140200,
            value: '大同市',
            id: 140200,
            children: [
              {
                value: '城区',
                id: 140202,
                key: 140202
              },
              {
                value: '矿区',
                id: 140203,
                key: 140203
              },
              {
                value: '南郊区',
                id: 140211,
                key: 140211
              },
              {
                value: '新荣区',
                id: 140212,
                key: 140212
              },
              {
                value: '阳高县',
                id: 140221,
                key: 140221
              },
              {
                value: '天镇县',
                id: 140222,
                key: 140222
              },
              {
                value: '广灵县',
                id: 140223,
                key: 140223
              },
              {
                value: '灵丘县',
                id: 140224,
                key: 140224
              },
              {
                value: '浑源县',
                id: 140225,
                key: 140225
              },
              {
                value: '左云县',
                id: 140226,
                key: 140226
              },
              {
                value: '大同县',
                id: 140227,
                key: 140227
              }
            ]
          },
          {
            key: 140500,
            value: '晋城市',
            id: 140500,
            children: [
              {
                value: '城区',
                id: 140502,
                key: 140502
              },
              {
                value: '沁水县',
                id: 140521,
                key: 140521
              },
              {
                value: '阳城县',
                id: 140522,
                key: 140522
              },
              {
                value: '陵川县',
                id: 140524,
                key: 140524
              },
              {
                value: '泽州县',
                id: 140525,
                key: 140525
              },
              {
                value: '高平市',
                id: 140581,
                key: 140581
              }
            ]
          },
          {
            key: 140700,
            value: '晋中市',
            id: 140700,
            children: [
              {
                value: '榆次区',
                id: 140702,
                key: 140702
              },
              {
                value: '榆社县',
                id: 140721,
                key: 140721
              },
              {
                value: '左权县',
                id: 140722,
                key: 140722
              },
              {
                value: '和顺县',
                id: 140723,
                key: 140723
              },
              {
                value: '昔阳县',
                id: 140724,
                key: 140724
              },
              {
                value: '寿阳县',
                id: 140725,
                key: 140725
              },
              {
                value: '太谷县',
                id: 140726,
                key: 140726
              },
              {
                value: '祁县',
                id: 140727,
                key: 140727
              },
              {
                value: '平遥县',
                id: 140728,
                key: 140728
              },
              {
                value: '灵石县',
                id: 140729,
                key: 140729
              },
              {
                value: '介休市',
                id: 140781,
                key: 140781
              }
            ]
          },
          {
            key: 141000,
            value: '临汾市',
            id: 141000,
            children: [
              {
                value: '尧都区',
                id: 141002,
                key: 141002
              },
              {
                value: '曲沃县',
                id: 141021,
                key: 141021
              },
              {
                value: '翼城县',
                id: 141022,
                key: 141022
              },
              {
                value: '襄汾县',
                id: 141023,
                key: 141023
              },
              {
                value: '洪洞县',
                id: 141024,
                key: 141024
              },
              {
                value: '古县',
                id: 141025,
                key: 141025
              },
              {
                value: '安泽县',
                id: 141026,
                key: 141026
              },
              {
                value: '浮山县',
                id: 141027,
                key: 141027
              },
              {
                value: '吉县',
                id: 141028,
                key: 141028
              },
              {
                value: '乡宁县',
                id: 141029,
                key: 141029
              },
              {
                value: '大宁县',
                id: 141030,
                key: 141030
              },
              {
                value: '隰县',
                id: 141031,
                key: 141031
              },
              {
                value: '永和县',
                id: 141032,
                key: 141032
              },
              {
                value: '蒲县',
                id: 141033,
                key: 141033
              },
              {
                value: '汾西县',
                id: 141034,
                key: 141034
              },
              {
                value: '侯马市',
                id: 141081,
                key: 141081
              },
              {
                value: '霍州市',
                id: 141082,
                key: 141082
              }
            ]
          },
          {
            key: 141100,
            value: '吕梁市',
            id: 141100,
            children: [
              {
                value: '离石区',
                id: 141102,
                key: 141102
              },
              {
                value: '文水县',
                id: 141121,
                key: 141121
              },
              {
                value: '交城县',
                id: 141122,
                key: 141122
              },
              {
                value: '兴县',
                id: 141123,
                key: 141123
              },
              {
                value: '临县',
                id: 141124,
                key: 141124
              },
              {
                value: '柳林县',
                id: 141125,
                key: 141125
              },
              {
                value: '石楼县',
                id: 141126,
                key: 141126
              },
              {
                value: '岚县',
                id: 141127,
                key: 141127
              },
              {
                value: '方山县',
                id: 141128,
                key: 141128
              },
              {
                value: '中阳县',
                id: 141129,
                key: 141129
              },
              {
                value: '交口县',
                id: 141130,
                key: 141130
              },
              {
                value: '孝义市',
                id: 141181,
                key: 141181
              },
              {
                value: '汾阳市',
                id: 141182,
                key: 141182
              }
            ]
          },
          {
            key: 140600,
            value: '朔州市',
            id: 140600,
            children: [
              {
                value: '朔城区',
                id: 140602,
                key: 140602
              },
              {
                value: '平鲁区',
                id: 140603,
                key: 140603
              },
              {
                value: '山阴县',
                id: 140621,
                key: 140621
              },
              {
                value: '应县',
                id: 140622,
                key: 140622
              },
              {
                value: '右玉县',
                id: 140623,
                key: 140623
              },
              {
                value: '怀仁县',
                id: 140624,
                key: 140624
              }
            ]
          },
          {
            key: 140100,
            value: '太原市',
            id: 140100,
            children: [
              {
                value: '小店区',
                id: 140105,
                key: 140105
              },
              {
                value: '迎泽区',
                id: 140106,
                key: 140106
              },
              {
                value: '杏花岭区',
                id: 140107,
                key: 140107
              },
              {
                value: '尖草坪区',
                id: 140108,
                key: 140108
              },
              {
                value: '万柏林区',
                id: 140109,
                valkeyue: 140109
              },
              {
                value: '晋源区',
                id: 140110,
                key: 140110
              },
              {
                value: '清徐县',
                id: 140121,
                key: 140121
              },
              {
                value: '阳曲县',
                id: 140122,
                key: 140122
              },
              {
                value: '娄烦县',
                id: 140123,
                key: 140123
              },
              {
                value: '古交市',
                id: 140181,
                key: 140181
              }
            ]
          },
          {
            key: 140900,
            value: '忻州市',
            id: 140900,
            children: [
              {
                value: '忻府区',
                id: 140902,
                key: 140902
              },
              {
                value: '定襄县',
                id: 140921,
                key: 140921
              },
              {
                value: '五台县',
                id: 140922,
                key: 140922
              },
              {
                value: '代县',
                id: 140923,
                key: 140923
              },
              {
                value: '繁峙县',
                id: 140924,
                key: 140924
              },
              {
                value: '宁武县',
                id: 140925,
                key: 140925
              },
              {
                value: '静乐县',
                id: 140926,
                key: 140926
              },
              {
                value: '神池县',
                id: 140927,
                key: 140927
              },
              {
                value: '五寨县',
                id: 140928,
                key: 140928
              },
              {
                value: '岢岚县',
                id: 140929,
                key: 140929
              },
              {
                value: '河曲县',
                id: 140930,
                key: 140930
              },
              {
                value: '保德县',
                id: 140931,
                key: 140931
              },
              {
                value: '偏关县',
                id: 140932,
                key: 140932
              },
              {
                value: '原平市',
                id: 140981,
                key: 140981
              }
            ]
          },
          {
            key: 140300,
            value: '阳泉市',
            id: 140300,
            children: [
              {
                value: '城区',
                id: 140302,
                key: 140302
              },
              {
                value: '矿区',
                id: 140303,
                key: 140303
              },
              {
                value: '郊区',
                id: 140311,
                key: 140311
              },
              {
                value: '平定县',
                id: 140321,
                key: 140321
              },
              {
                value: '盂县',
                id: 140322,
                key: 140322
              }
            ]
          },
          {
            key: 140800,
            value: '运城市',
            id: 140800,
            children: [
              {
                value: '盐湖区',
                id: 140802,
                key: 140802
              },
              {
                value: '临猗县',
                id: 140821,
                key: 140821
              },
              {
                value: '万荣县',
                id: 140822,
                key: 140822
              },
              {
                value: '闻喜县',
                id: 140823,
                key: 140823
              },
              {
                value: '稷山县',
                id: 140824,
                key: 140824
              },
              {
                value: '新绛县',
                id: 140825,
                key: 140825
              },
              {
                value: '绛县',
                id: 140826,
                key: 140826
              },
              {
                value: '垣曲县',
                id: 140827,
                key: 140827
              },
              {
                value: '夏县',
                id: 140828,
                key: 140828
              },
              {
                value: '平陆县',
                id: 140829,
                key: 140829
              },
              {
                value: '芮城县',
                id: 140830,
                key: 140830
              },
              {
                value: '永济市',
                id: 140881,
                key: 140881
              },
              {
                value: '河津市',
                id: 140882,
                key: 140882
              }
            ]
          }
        ]
      },
      {
        key: 420000,
        value: '湖北省',
        id: 420000,
        children: [
          {
            key: 420700,
            value: '鄂州市',
            id: 420700,
            children: [
              {
                value: '梁子湖区',
                id: 420702,
                key: 420702
              },
              {
                value: '华容区',
                id: 420703,
                key: 420703
              },
              {
                value: '鄂城区',
                id: 420704,
                key: 420704
              }
            ]
          },
          {
            key: 422800,
            value: '恩施土家族苗族自治州',
            id: 422800,
            children: [
              {
                value: '恩施市',
                id: 422801,
                key: 422801
              },
              {
                value: '利川市',
                id: 422802,
                key: 422802
              },
              {
                value: '建始县',
                id: 422822,
                key: 422822
              },
              {
                value: '巴东县',
                id: 422823,
                key: 422823
              },
              {
                value: '宣恩县',
                id: 422825,
                key: 422825
              },
              {
                value: '咸丰县',
                id: 422826,
                key: 422826
              },
              {
                value: '来凤县',
                id: 422827,
                key: 422827
              },
              {
                value: '鹤峰县',
                id: 422828,
                key: 422828
              }
            ]
          },
          {
            key: 421100,
            value: '黄冈市',
            id: 421100,
            children: [
              {
                value: '黄州区',
                id: 421102,
                key: 421102
              },
              {
                value: '团风县',
                id: 421121,
                key: 421121
              },
              {
                value: '红安县',
                id: 421122,
                key: 421122
              },
              {
                value: '罗田县',
                id: 421123,
                key: 421123
              },
              {
                value: '英山县',
                id: 421124,
                key: 421124
              },
              {
                value: '浠水县',
                id: 421125,
                key: 421125
              },
              {
                value: '蕲春县',
                id: 421126,
                key: 421126
              },
              {
                value: '黄梅县',
                id: 421127,
                key: 421127
              },
              {
                value: '麻城市',
                id: 421181,
                key: 421181
              },
              {
                value: '武穴市',
                id: 421182,
                key: 421182
              }
            ]
          },
          {
            key: 420200,
            value: '黄石市',
            id: 420200,
            children: [
              {
                value: '黄石港区',
                id: 420202,
                key: 420202
              },
              {
                value: '西塞山区',
                id: 420203,
                key: 420203
              },
              {
                value: '下陆区',
                id: 420204,
                key: 420204
              },
              {
                value: '铁山区',
                id: 420205,
                key: 420205
              },
              {
                value: '阳新县',
                id: 420222,
                key: 420222
              },
              {
                value: '大冶市',
                id: 420281,
                key: 420281
              }
            ]
          },
          {
            key: 420800,
            value: '荆门市',
            id: 420800,
            children: [
              {
                value: '东宝区',
                id: 420802,
                key: 420802
              },
              {
                value: '掇刀区',
                id: 420804,
                key: 420804
              },
              {
                value: '京山县',
                id: 420821,
                key: 420821
              },
              {
                value: '沙洋县',
                id: 420822,
                key: 420822
              },
              {
                value: '钟祥市',
                id: 420881,
                key: 420881
              }
            ]
          },
          {
            key: 421000,
            value: '荆州市',
            id: 421000,
            children: [
              {
                value: '沙市区',
                id: 421002,
                key: 421002
              },
              {
                value: '荆州区',
                id: 421003,
                key: 421003
              },
              {
                value: '公安县',
                id: 421022,
                key: 421022
              },
              {
                value: '监利县',
                id: 421023,
                key: 421023
              },
              {
                value: '江陵县',
                id: 421024,
                key: 421024
              },
              {
                value: '石首市',
                id: 421081,
                key: 421081
              },
              {
                value: '洪湖市',
                id: 421083,
                key: 421083
              },
              {
                value: '松滋市',
                id: 421087,
                key: 421087
              }
            ]
          },
          {
            key: 429005,
            value: '潜江市',
            id: 429005
          },
          {
            key: 429021,
            value: '神农架林区',
            id: 429021
          },
          {
            key: 420300,
            value: '十堰市',
            id: 420300,
            children: [
              {
                value: '茅箭区',
                id: 420302,
                key: 420302
              },
              {
                value: '张湾区',
                id: 420303,
                key: 420303
              },
              {
                value: '郧阳区',
                id: 420304,
                key: 420304
              },
              {
                value: '郧西县',
                id: 420322,
                key: 420322
              },
              {
                value: '竹山县',
                id: 420323,
                key: 420323
              },
              {
                value: '竹溪县',
                id: 420324,
                key: 420324
              },
              {
                value: '房县',
                id: 420325,
                key: 420325
              },
              {
                value: '丹江口市',
                id: 420381,
                key: 420381
              }
            ]
          },
          {
            key: 421300,
            value: '随州市',
            id: 421300,
            children: [
              {
                value: '曾都区',
                id: 421303,
                key: 421303
              },
              {
                value: '随县',
                id: 421321,
                key: 421321
              },
              {
                value: '广水市',
                id: 421381,
                key: 421381
              }
            ]
          },
          {
            key: 429006,
            value: '天门市',
            id: 429006
          },
          {
            key: 420100,
            value: '武汉市',
            id: 420100,
            children: [
              {
                value: '江岸区',
                id: 420102,
                key: 420102
              },
              {
                value: '江汉区',
                id: 420103,
                key: 420103
              },
              {
                value: '硚口区',
                id: 420104,
                key: 420104
              },
              {
                value: '汉阳区',
                id: 420105,
                key: 420105
              },
              {
                value: '武昌区',
                id: 420106,
                key: 420106
              },
              {
                value: '青山区',
                id: 420107,
                key: 420107
              },
              {
                value: '洪山区',
                id: 420111,
                key: 420111
              },
              {
                value: '东西湖区',
                id: 420112,
                key: 420112
              },
              {
                value: '汉南区',
                id: 420113,
                key: 420113
              },
              {
                value: '蔡甸区',
                id: 420114,
                key: 420114
              },
              {
                value: '江夏区',
                id: 420115,
                key: 420115
              },
              {
                value: '黄陂区',
                id: 420116,
                key: 420116
              },
              {
                value: '新洲区',
                id: 420117,
                key: 420117
              }
            ]
          },
          {
            key: 429004,
            value: '仙桃市',
            id: 429004
          },
          {
            key: 421200,
            value: '咸宁市',
            id: 421200,
            children: [
              {
                value: '咸安区',
                id: 421202,
                key: 421202
              },
              {
                value: '嘉鱼县',
                id: 421221,
                key: 421221
              },
              {
                value: '通城县',
                id: 421222,
                key: 421222
              },
              {
                value: '崇阳县',
                id: 421223,
                key: 421223
              },
              {
                value: '通山县',
                id: 421224,
                key: 421224
              },
              {
                value: '赤壁市',
                id: 421281,
                key: 421281
              }
            ]
          },
          {
            key: 420600,
            value: '襄阳市',
            id: 420600,
            children: [
              {
                value: '襄城区',
                id: 420602,
                key: 420602
              },
              {
                value: '樊城区',
                id: 420606,
                key: 420606
              },
              {
                value: '襄州区',
                id: 420607,
                key: 420607
              },
              {
                value: '南漳县',
                id: 420624,
                key: 420624
              },
              {
                value: '谷城县',
                id: 420625,
                key: 420625
              },
              {
                value: '保康县',
                id: 420626,
                key: 420626
              },
              {
                value: '老河口市',
                id: 420682,
                key: 420682
              },
              {
                value: '枣阳市',
                id: 420683,
                key: 420683
              },
              {
                value: '宜城市',
                id: 420684,
                key: 420684
              }
            ]
          },
          {
            key: 420900,
            value: '孝感市',
            id: 420900,
            children: [
              {
                value: '孝南区',
                id: 420902,
                key: 420902
              },
              {
                value: '孝昌县',
                id: 420921,
                key: 420921
              },
              {
                value: '大悟县',
                id: 420922,
                key: 420922
              },
              {
                value: '云梦县',
                id: 420923,
                key: 420923
              },
              {
                value: '应城市',
                id: 420981,
                key: 420981
              },
              {
                value: '安陆市',
                id: 420982,
                key: 420982
              },
              {
                value: '汉川市',
                id: 420984,
                key: 420984
              }
            ]
          },
          {
            key: 420500,
            value: '宜昌市',
            id: 420500,
            children: [
              {
                value: '西陵区',
                id: 420502,
                key: 420502
              },
              {
                value: '伍家岗区',
                id: 420503,
                key: 420503
              },
              {
                value: '点军区',
                id: 420504,
                key: 420504
              },
              {
                value: '猇亭区',
                id: 420505,
                key: 420505
              },
              {
                value: '夷陵区',
                id: 420506,
                key: 420506
              },
              {
                value: '远安县',
                id: 420525,
                key: 420525
              },
              {
                value: '兴山县',
                id: 420526,
                key: 420526
              },
              {
                value: '秭归县',
                id: 420527,
                key: 420527
              },
              {
                value: '长阳土家族自治县',
                id: 420528,
                key: 420528
              },
              {
                value: '五峰土家族自治县',
                id: 420529,
                key: 420529
              },
              {
                value: '宜都市',
                id: 420581,
                key: 420581
              },
              {
                value: '当阳市',
                id: 420582,
                key: 420582
              },
              {
                value: '枝江市',
                id: 420583,
                key: 420583
              }
            ]
          }
        ]
      },
      {
        key: 130000,
        value: '河北省',
        id: 130000,
        children: [
          {
            key: 130600,
            value: '保定市',
            id: 130600,
            children: [
              {
                value: '竞秀区',
                id: 130602,
                key: 130602
              },
              {
                value: '莲池区',
                id: 130606,
                key: 130606
              },
              {
                value: '满城区',
                id: 130621,
                key: 130621
              },
              {
                value: '清苑区',
                id: 130622,
                key: 130622
              },
              {
                value: '涞水县',
                id: 130623,
                key: 130623
              },
              {
                value: '阜平县',
                id: 130624,
                key: 130624
              },
              {
                value: '徐水区',
                id: 130625,
                key: 130625
              },
              {
                value: '定兴县',
                id: 130626,
                key: 130626
              },
              {
                value: '唐县',
                id: 130627,
                key: 130627
              },
              {
                value: '高阳县',
                id: 130628,
                key: 130628
              },
              {
                value: '容城县',
                id: 130629,
                key: 130629
              },
              {
                value: '涞源县',
                id: 130630,
                key: 130630
              },
              {
                value: '望都县',
                id: 130631,
                key: 130631
              },
              {
                value: '安新县',
                id: 130632,
                key: 130632
              },
              {
                value: '易县',
                id: 130633,
                key: 130633
              },
              {
                value: '曲阳县',
                id: 130634,
                key: 130634
              },
              {
                value: '蠡县',
                id: 130635,
                key: 130635
              },
              {
                value: '顺平县',
                id: 130636,
                key: 130636
              },
              {
                value: '博野县',
                id: 130637,
                key: 130637
              },
              {
                value: '雄县',
                id: 130638,
                key: 130638
              },
              {
                value: '涿州市',
                id: 130681,
                key: 130681
              },
              {
                value: '定州市',
                id: 130682,
                key: 130682
              },
              {
                value: '安国市',
                id: 130683,
                key: 130683
              },
              {
                value: '高碑店市',
                id: 130684,
                key: 130684
              }
            ]
          },
          {
            key: 130900,
            value: '沧州市',
            id: 130900,
            children: [
              {
                value: '新华区',
                id: 130902,
                key: 130902
              },
              {
                value: '运河区',
                id: 130903,
                key: 130903
              },
              {
                value: '沧县',
                id: 130921,
                key: 130921
              },
              {
                value: '青县',
                id: 130922,
                key: 130922
              },
              {
                value: '东光县',
                id: 130923,
                key: 130923
              },
              {
                value: '海兴县',
                id: 130924,
                key: 130924
              },
              {
                value: '盐山县',
                id: 130925,
                key: 130925
              },
              {
                value: '肃宁县',
                id: 130926,
                key: 130926
              },
              {
                value: '南皮县',
                id: 130927,
                key: 130927
              },
              {
                value: '吴桥县',
                id: 130928,
                key: 130928
              },
              {
                value: '献县',
                id: 130929,
                key: 130929
              },
              {
                value: '孟村回族自治县',
                id: 130930,
                key: 130930
              },
              {
                value: '泊头市',
                id: 130981,
                key: 130981
              },
              {
                value: '任丘市',
                id: 130982,
                key: 130982
              },
              {
                value: '黄骅市',
                id: 130983,
                key: 130983
              },
              {
                value: '河间市',
                id: 130984,
                key: 130984
              }
            ]
          },
          {
            key: 130800,
            value: '承德市',
            id: 130800,
            children: [
              {
                value: '双桥区',
                id: 130802,
                key: 130802
              },
              {
                value: '双滦区',
                id: 130803,
                key: 130803
              },
              {
                value: '鹰手营子矿区',
                id: 130804,
                key: 130804
              },
              {
                value: '承德县',
                id: 130821,
                key: 130821
              },
              {
                value: '兴隆县',
                id: 130822,
                key: 130822
              },
              {
                value: '平泉市',
                id: 130823,
                key: 130823
              },
              {
                value: '滦平县',
                id: 130824,
                key: 130824
              },
              {
                value: '隆化县',
                id: 130825,
                key: 130825
              },
              {
                value: '丰宁满族自治县',
                id: 130826,
                key: 130826
              },
              {
                value: '宽城满族自治县',
                id: 130827,
                key: 130827
              },
              {
                value: '围场满族蒙古族自治县',
                id: 130828,
                key: 130828
              }
            ]
          },
          {
            key: 130400,
            value: '邯郸市',
            id: 130400,
            children: [
              {
                value: '邯山区',
                id: 130402,
                key: 130402
              },
              {
                value: '丛台区',
                id: 130403,
                key: 130403
              },
              {
                value: '复兴区',
                id: 130404,
                key: 130404
              },
              {
                value: '峰峰矿区',
                id: 130406,
                key: 130406
              },
              {
                value: '临漳县',
                id: 130423,
                key: 130423
              },
              {
                value: '成安县',
                id: 130424,
                key: 130424
              },
              {
                value: '大名县',
                id: 130425,
                key: 130425
              },
              {
                value: '涉县',
                id: 130426,
                key: 130426
              },
              {
                value: '磁县',
                id: 130427,
                key: 130427
              },
              {
                value: '肥乡区',
                id: 130428,
                key: 130428
              },
              {
                value: '永年区',
                id: 130429,
                key: 130429
              },
              {
                value: '邱县',
                id: 130430,
                key: 130430
              },
              {
                value: '鸡泽县',
                id: 130431,
                key: 130431
              },
              {
                value: '广平县',
                id: 130432,
                key: 130432
              },
              {
                value: '馆陶县',
                id: 130433,
                key: 130433
              },
              {
                value: '魏县',
                id: 130434,
                key: 130434
              },
              {
                value: '曲周县',
                id: 130435,
                key: 130435
              },
              {
                value: '武安市',
                id: 130481,
                key: 130481
              }
            ]
          },
          {
            key: 131100,
            value: '衡水市',
            id: 131100,
            children: [
              {
                value: '桃城区',
                id: 131102,
                key: 131102
              },
              {
                value: '枣强县',
                id: 131121,
                key: 131121
              },
              {
                value: '武邑县',
                id: 131122,
                key: 131122
              },
              {
                value: '武强县',
                id: 131123,
                key: 131123
              },
              {
                value: '饶阳县',
                id: 131124,
                key: 131124
              },
              {
                value: '安平县',
                id: 131125,
                key: 131125
              },
              {
                value: '故城县',
                id: 131126,
                key: 131126
              },
              {
                value: '景县',
                id: 131127,
                key: 131127
              },
              {
                value: '阜城县',
                id: 131128,
                key: 131128
              },
              {
                value: '冀州区',
                id: 131181,
                key: 131181
              },
              {
                value: '深州市',
                id: 131182,
                key: 131182
              }
            ]
          },
          {
            key: 131000,
            value: '廊坊市',
            id: 131000,
            children: [
              {
                value: '安次区',
                id: 131002,
                key: 131002
              },
              {
                value: '广阳区',
                id: 131003,
                key: 131003
              },
              {
                value: '固安县',
                id: 131022,
                key: 131022
              },
              {
                value: '永清县',
                id: 131023,
                key: 131023
              },
              {
                value: '香河县',
                id: 131024,
                key: 131024
              },
              {
                value: '大城县',
                id: 131025,
                key: 131025
              },
              {
                value: '文安县',
                id: 131026,
                key: 131026
              },
              {
                value: '大厂回族自治县',
                id: 131028,
                key: 131028
              },
              {
                value: '霸州市',
                id: 131081,
                key: 131081
              },
              {
                value: '三河市',
                id: 131082,
                key: 131082
              }
            ]
          },
          {
            key: 130300,
            value: '秦皇岛市',
            id: 130300,
            children: [
              {
                value: '海港区',
                id: 130302,
                key: 130302
              },
              {
                value: '山海关区',
                id: 130303,
                key: 130303
              },
              {
                value: '北戴河区',
                id: 130304,
                key: 130304
              },
              {
                value: '青龙满族自治县',
                id: 130321,
                key: 130321
              },
              {
                value: '昌黎县',
                id: 130322,
                key: 130322
              },
              {
                value: '抚宁区',
                id: 130323,
                key: 130323
              },
              {
                value: '卢龙县',
                id: 130324,
                key: 130324
              }
            ]
          },
          {
            key: 130100,
            value: '石家庄市',
            id: 130100,
            children: [
              {
                value: '长安区',
                id: 130102,
                key: 130102
              },
              {
                value: '桥西区',
                id: 130104,
                key: 130104
              },
              {
                value: '新华区',
                id: 130105,
                key: 130105
              },
              {
                value: '井陉矿区',
                id: 130107,
                key: 130107
              },
              {
                value: '裕华区',
                id: 130108,
                key: 130108
              },
              {
                value: '藁城区',
                id: 130109,
                key: 130109
              },
              {
                value: '鹿泉区',
                id: 130110,
                key: 130110
              },
              {
                value: '栾城区',
                id: 130111,
                key: 130111
              },
              {
                value: '井陉县',
                id: 130121,
                key: 130121
              },
              {
                value: '正定县',
                id: 130123,
                key: 130123
              },
              {
                value: '行唐县',
                id: 130125,
                key: 130125
              },
              {
                value: '灵寿县',
                id: 130126,
                key: 130126
              },
              {
                value: '高邑县',
                id: 130127,
                key: 130127
              },
              {
                value: '深泽县',
                id: 130128,
                key: 130128
              },
              {
                value: '赞皇县',
                id: 130129,
                key: 130129
              },
              {
                value: '无极县',
                id: 130130,
                key: 130130
              },
              {
                value: '平山县',
                id: 130131,
                key: 130131
              },
              {
                value: '元氏县',
                id: 130132,
                key: 130132
              },
              {
                value: '赵县',
                id: 130133,
                key: 130133
              },
              {
                value: '辛集市',
                id: 130181,
                key: 130181
              },
              {
                value: '晋州市',
                id: 130183,
                key: 130183
              },
              {
                value: '新乐市',
                id: 130184,
                key: 130184
              }
            ]
          },
          {
            key: 130200,
            value: '唐山市',
            id: 130200,
            children: [
              {
                value: '路南区',
                id: 130202,
                key: 130202
              },
              {
                value: '路北区',
                id: 130203,
                key: 130203
              },
              {
                value: '古冶区',
                id: 130204,
                key: 130204
              },
              {
                value: '开平区',
                id: 130205,
                key: 130205
              },
              {
                value: '丰南区',
                id: 130207,
                key: 130207
              },
              {
                value: '丰润区',
                id: 130208,
                key: 130208
              },
              {
                value: '曹妃甸区',
                id: 130209,
                key: 130209
              },
              {
                value: '滦县',
                id: 130223,
                key: 130223
              },
              {
                value: '滦南县',
                id: 130224,
                key: 130224
              },
              {
                value: '乐亭县',
                id: 130225,
                key: 130225
              },
              {
                value: '迁西县',
                id: 130227,
                key: 130227
              },
              {
                value: '玉田县',
                id: 130229,
                key: 130229
              },
              {
                value: '遵化市',
                id: 130281,
                key: 130281
              },
              {
                value: '迁安市',
                id: 130283,
                key: 130283
              }
            ]
          },
          {
            key: 130500,
            value: '邢台市',
            id: 130500,
            children: [
              {
                value: '桥东区',
                id: 130502,
                key: 130502
              },
              {
                value: '桥西区',
                id: 130503,
                key: 130503
              },
              {
                value: '邢台县',
                id: 130521,
                key: 130521
              },
              {
                value: '临城县',
                id: 130522,
                key: 130522
              },
              {
                value: '内丘县',
                id: 130523,
                key: 130523
              },
              {
                value: '柏乡县',
                id: 130524,
                key: 130524
              },
              {
                value: '隆尧县',
                id: 130525,
                key: 130525
              },
              {
                value: '任县',
                id: 130526,
                key: 130526
              },
              {
                value: '南和县',
                id: 130527,
                key: 130527
              },
              {
                value: '宁晋县',
                id: 130528,
                key: 130528
              },
              {
                value: '巨鹿县',
                id: 130529,
                key: 130529
              },
              {
                value: '新河县',
                id: 130530,
                key: 130530
              },
              {
                value: '广宗县',
                id: 130531,
                key: 130531
              },
              {
                value: '平乡县',
                id: 130532,
                key: 130532
              },
              {
                value: '威县',
                id: 130533,
                key: 130533
              },
              {
                value: '清河县',
                id: 130534,
                key: 130534
              },
              {
                value: '临西县',
                id: 130535,
                key: 130535
              },
              {
                value: '南宫市',
                id: 130581,
                key: 130581
              },
              {
                value: '沙河市',
                id: 130582,
                key: 130582
              }
            ]
          },
          {
            key: 130700,
            value: '张家口市',
            id: 130700,
            children: [
              {
                value: '桥东区',
                id: 130702,
                key: 130702
              },
              {
                value: '桥西区',
                id: 130703,
                key: 130703
              },
              {
                value: '宣化区',
                id: 130705,
                key: 130705
              },
              {
                value: '下花园区',
                id: 130706,
                key: 130706
              },
              {
                value: '张北县',
                id: 130722,
                key: 130722
              },
              {
                value: '康保县',
                id: 130723,
                key: 130723
              },
              {
                value: '沽源县',
                id: 130724,
                key: 130724
              },
              {
                value: '尚义县',
                id: 130725,
                key: 130725
              },
              {
                value: '蔚县',
                id: 130726,
                key: 130726
              },
              {
                value: '阳原县',
                id: 130727,
                key: 130727
              },
              {
                value: '怀安县',
                id: 130728,
                key: 130728
              },
              {
                value: '万全区',
                id: 130729,
                key: 130729
              },
              {
                value: '怀来县',
                id: 130730,
                key: 130730
              },
              {
                value: '涿鹿县',
                id: 130731,
                key: 130731
              },
              {
                value: '赤城县',
                id: 130732,
                key: 130732
              },
              {
                value: '崇礼区',
                id: 130733,
                key: 130733
              }
            ]
          }
        ]
      },
      {
        key: 360000,
        value: '江西省',
        id: 360000,
        children: [
          {
            key: 361000,
            value: '抚州市',
            id: 361000,
            children: [
              {
                value: '临川区',
                id: 361002,
                key: 361002
              },
              {
                value: '南城县',
                id: 361021,
                key: 361021
              },
              {
                value: '黎川县',
                id: 361022,
                key: 361022
              },
              {
                value: '南丰县',
                id: 361023,
                key: 361023
              },
              {
                value: '崇仁县',
                id: 361024,
                key: 361024
              },
              {
                value: '乐安县',
                id: 361025,
                key: 361025
              },
              {
                value: '宜黄县',
                id: 361026,
                key: 361026
              },
              {
                value: '金溪县',
                id: 361027,
                key: 361027
              },
              {
                value: '资溪县',
                id: 361028,
                key: 361028
              },
              {
                value: '东乡区',
                id: 361029,
                key: 361029
              },
              {
                value: '广昌县',
                id: 361030,
                key: 361030
              }
            ]
          },
          {
            key: 360700,
            value: '赣州市',
            id: 360700,
            children: [
              {
                value: '章贡区',
                id: 360702,
                key: 360702
              },
              {
                value: '南康区',
                id: 360703,
                key: 360703
              },
              {
                value: '赣县区',
                id: 360721,
                key: 360721
              },
              {
                value: '信丰县',
                id: 360722,
                key: 360722
              },
              {
                value: '大余县',
                id: 360723,
                key: 360723
              },
              {
                value: '上犹县',
                id: 360724,
                key: 360724
              },
              {
                value: '崇义县',
                id: 360725,
                key: 360725
              },
              {
                value: '安远县',
                id: 360726,
                key: 360726
              },
              {
                value: '龙南县',
                id: 360727,
                key: 360727
              },
              {
                value: '定南县',
                id: 360728,
                key: 360728
              },
              {
                value: '全南县',
                id: 360729,
                key: 360729
              },
              {
                value: '宁都县',
                id: 360730,
                key: 360730
              },
              {
                value: '于都县',
                id: 360731,
                key: 360731
              },
              {
                value: '兴国县',
                id: 360732,
                key: 360732
              },
              {
                value: '会昌县',
                id: 360733,
                key: 360733
              },
              {
                value: '寻乌县',
                id: 360734,
                key: 360734
              },
              {
                value: '石城县',
                id: 360735,
                key: 360735
              },
              {
                value: '瑞金市',
                id: 360781,
                key: 360781
              }
            ]
          },
          {
            key: 360800,
            value: '吉安市',
            id: 360800,
            children: [
              {
                value: '吉州区',
                id: 360802,
                key: 360802
              },
              {
                value: '青原区',
                id: 360803,
                key: 360803
              },
              {
                value: '吉安县',
                id: 360821,
                key: 360821
              },
              {
                value: '吉水县',
                id: 360822,
                key: 360822
              },
              {
                value: '峡江县',
                id: 360823,
                key: 360823
              },
              {
                value: '新干县',
                id: 360824,
                key: 360824
              },
              {
                value: '永丰县',
                id: 360825,
                key: 360825
              },
              {
                value: '泰和县',
                id: 360826,
                key: 360826
              },
              {
                value: '遂川县',
                id: 360827,
                key: 360827
              },
              {
                value: '万安县',
                id: 360828,
                key: 360828
              },
              {
                value: '安福县',
                id: 360829,
                key: 360829
              },
              {
                value: '永新县',
                id: 360830,
                key: 360830
              },
              {
                value: '井冈山市',
                id: 360881,
                key: 360881
              }
            ]
          },
          {
            key: 360200,
            value: '景德镇市',
            id: 360200,
            children: [
              {
                value: '昌江区',
                id: 360202,
                key: 360202
              },
              {
                value: '珠山区',
                id: 360203,
                key: 360203
              },
              {
                value: '浮梁县',
                id: 360222,
                key: 360222
              },
              {
                value: '乐平市',
                id: 360281,
                key: 360281
              }
            ]
          },
          {
            key: 360400,
            value: '九江市',
            id: 360400,
            children: [
              {
                value: '濂溪区',
                id: 360402,
                key: 360402
              },
              {
                value: '浔阳区',
                id: 360403,
                key: 360403
              },
              {
                value: '柴桑区',
                id: 360421,
                key: 360421
              },
              {
                value: '武宁县',
                id: 360423,
                key: 360423
              },
              {
                value: '修水县',
                id: 360424,
                key: 360424
              },
              {
                value: '永修县',
                id: 360425,
                key: 360425
              },
              {
                value: '德安县',
                id: 360426,
                key: 360426
              },
              {
                value: '都昌县',
                id: 360428,
                key: 360428
              },
              {
                value: '湖口县',
                id: 360429,
                key: 360429
              },
              {
                value: '彭泽县',
                id: 360430,
                key: 360430
              },
              {
                value: '瑞昌市',
                id: 360481,
                key: 360481
              },
              {
                value: '共青城市',
                id: 360482,
                key: 360482
              },
              {
                value: '庐山市',
                id: 360483,
                key: 360483
              }
            ]
          },
          {
            key: 360100,
            value: '南昌市',
            id: 360100,
            children: [
              {
                value: '东湖区',
                id: 360102,
                key: 360102
              },
              {
                value: '西湖区',
                id: 360103,
                key: 360103
              },
              {
                value: '青云谱区',
                id: 360104,
                key: 360104
              },
              {
                value: '湾里区',
                id: 360105,
                key: 360105
              },
              {
                value: '青山湖区',
                id: 360111,
                key: 360111
              },
              {
                value: '南昌县',
                id: 360121,
                key: 360121
              },
              {
                value: '新建区',
                id: 360122,
                key: 360122
              },
              {
                value: '安义县',
                id: 360123,
                key: 360123
              },
              {
                value: '进贤县',
                id: 360124,
                key: 360124
              }
            ]
          },
          {
            key: 360300,
            value: '萍乡市',
            id: 360300,
            children: [
              {
                value: '安源区',
                id: 360302,
                key: 360302
              },
              {
                value: '湘东区',
                id: 360313,
                key: 360313
              },
              {
                value: '莲花县',
                id: 360321,
                key: 360321
              },
              {
                value: '上栗县',
                id: 360322,
                key: 360322
              },
              {
                value: '芦溪县',
                id: 360323,
                key: 360323
              }
            ]
          },
          {
            key: 361100,
            value: '上饶市',
            id: 361100,
            children: [
              {
                value: '信州区',
                id: 361102,
                key: 361102
              },
              {
                value: '上饶县',
                id: 361121,
                key: 361121
              },
              {
                value: '广丰区',
                id: 361122,
                key: 361122
              },
              {
                value: '玉山县',
                id: 361123,
                key: 361123
              },
              {
                value: '铅山县',
                id: 361124,
                key: 361124
              },
              {
                value: '横峰县',
                id: 361125,
                key: 361125
              },
              {
                value: '弋阳县',
                id: 361126,
                key: 361126
              },
              {
                value: '余干县',
                id: 361127,
                key: 361127
              },
              {
                value: '鄱阳县',
                id: 361128,
                key: 361128
              },
              {
                value: '万年县',
                id: 361129,
                key: 361129
              },
              {
                value: '婺源县',
                id: 361130,
                key: 361130
              },
              {
                value: '德兴市',
                id: 361181,
                key: 361181
              }
            ]
          },
          {
            key: 360500,
            value: '新余市',
            id: 360500,
            children: [
              {
                value: '渝水区',
                id: 360502,
                key: 360502
              },
              {
                value: '分宜县',
                id: 360521,
                key: 360521
              }
            ]
          },
          {
            key: 360900,
            value: '宜春市',
            id: 360900,
            children: [
              {
                value: '袁州区',
                id: 360902,
                key: 360902
              },
              {
                value: '奉新县',
                id: 360921,
                key: 360921
              },
              {
                value: '万载县',
                id: 360922,
                key: 360922
              },
              {
                value: '上高县',
                id: 360923,
                key: 360923
              },
              {
                value: '宜丰县',
                id: 360924,
                key: 360924
              },
              {
                value: '靖安县',
                id: 360925,
                key: 360925
              },
              {
                value: '铜鼓县',
                id: 360926,
                key: 360926
              },
              {
                value: '丰城市',
                id: 360981,
                key: 360981
              },
              {
                value: '樟树市',
                id: 360982,
                key: 360982
              },
              {
                value: '高安市',
                id: 360983,
                key: 360983
              }
            ]
          },
          {
            key: 360600,
            value: '鹰潭市',
            id: 360600,
            children: [
              {
                value: '月湖区',
                id: 360602,
                key: 360602
              },
              {
                value: '余江区',
                id: 360622,
                key: 360622
              },
              {
                value: '贵溪市',
                id: 360681,
                key: 360681
              }
            ]
          }
        ]
      },
      {
        key: 310000,
        value: '上海市',
        id: 310000,
        children: [
          {
            key: 310101,
            value: '黄浦区',
            id: 310101
          },
          {
            key: 310104,
            value: '徐汇区',
            id: 310104
          },
          {
            key: 310105,
            value: '长宁区',
            id: 310105
          },
          {
            key: 310106,
            value: '静安区',
            id: 310106
          },
          {
            key: 310107,
            value: '普陀区',
            id: 310107
          },
          {
            key: 310109,
            value: '虹口区',
            id: 310109
          },
          {
            key: 310110,
            value: '杨浦区',
            id: 310110
          },
          {
            key: 310112,
            value: '闵行区',
            id: 310112
          },
          {
            key: 310113,
            value: '宝山区',
            id: 310113
          },
          {
            key: 310114,
            value: '嘉定区',
            id: 310114
          },
          {
            key: 310115,
            value: '浦东新区',
            id: 310115
          },
          {
            key: 310116,
            value: '金山区',
            id: 310116
          },
          {
            key: 310117,
            value: '松江区',
            id: 310117
          },
          {
            key: 310118,
            value: '青浦区',
            id: 310118
          },
          {
            key: 310120,
            value: '奉贤区',
            id: 310120
          },
          {
            key: 310230,
            value: '崇明区',
            id: 310230
          }
        ]
      },
      {
        key: 330000,
        value: '浙江省',
        id: 330000,
        children: [
          {
            key: 330100,
            value: '杭州市',
            id: 330100,
            children: [
              {
                value: '上城区',
                id: 330102,
                key: 330102
              },
              {
                value: '下城区',
                id: 330103,
                key: 330103
              },
              {
                value: '江干区',
                id: 330104,
                key: 330104
              },
              {
                value: '拱墅区',
                id: 330105,
                key: 330105
              },
              {
                value: '西湖区',
                id: 330106,
                key: 330106
              },
              {
                value: '滨江区',
                id: 330108,
                key: 330108
              },
              {
                value: '萧山区',
                id: 330109,
                key: 330109
              },
              {
                value: '余杭区',
                id: 330110,
                key: 330110
              },
              {
                value: '富阳区',
                id: 330111,
                key: 330111
              },
              {
                value: '桐庐县',
                id: 330122,
                key: 330122
              },
              {
                value: '淳安县',
                id: 330127,
                key: 330127
              },
              {
                value: '建德市',
                id: 330182,
                key: 330182
              },
              {
                value: '临安区',
                id: 330185,
                key: 330185
              }
            ]
          },
          {
            key: 330500,
            value: '湖州市',
            id: 330500,
            children: [
              {
                value: '吴兴区',
                id: 330502,
                key: 330502
              },
              {
                value: '南浔区',
                id: 330503,
                key: 330503
              },
              {
                value: '德清县',
                id: 330521,
                key: 330521
              },
              {
                value: '长兴县',
                id: 330522,
                key: 330522
              },
              {
                value: '安吉县',
                id: 330523,
                key: 330523
              }
            ]
          },
          {
            key: 330400,
            value: '嘉兴市',
            id: 330400,
            children: [
              {
                value: '南湖区',
                id: 330402,
                key: 330402
              },
              {
                value: '秀洲区',
                id: 330411,
                key: 330411
              },
              {
                value: '嘉善县',
                id: 330421,
                key: 330421
              },
              {
                value: '海盐县',
                id: 330424,
                key: 330424
              },
              {
                value: '海宁市',
                id: 330481,
                key: 330481
              },
              {
                value: '平湖市',
                id: 330482,
                key: 330482
              },
              {
                value: '桐乡市',
                id: 330483,
                key: 330483
              }
            ]
          },
          {
            key: 330700,
            value: '金华市',
            id: 330700,
            children: [
              {
                value: '婺城区',
                id: 330702,
                key: 330702
              },
              {
                value: '金东区',
                id: 330703,
                key: 330703
              },
              {
                value: '武义县',
                id: 330723,
                key: 330723
              },
              {
                value: '浦江县',
                id: 330726,
                key: 330726
              },
              {
                value: '磐安县',
                id: 330727,
                key: 330727
              },
              {
                value: '兰溪市',
                id: 330781,
                key: 330781
              },
              {
                value: '义乌市',
                id: 330782,
                key: 330782
              },
              {
                value: '东阳市',
                id: 330783,
                key: 330783
              },
              {
                value: '永康市',
                id: 330784,
                key: 330784
              }
            ]
          },
          {
            key: 331100,
            value: '丽水市',
            id: 331100,
            children: [
              {
                value: '莲都区',
                id: 331102,
                key: 331102
              },
              {
                value: '青田县',
                id: 331121,
                key: 331121
              },
              {
                value: '缙云县',
                id: 331122,
                key: 331122
              },
              {
                value: '遂昌县',
                id: 331123,
                key: 331123
              },
              {
                value: '松阳县',
                id: 331124,
                key: 331124
              },
              {
                value: '云和县',
                id: 331125,
                key: 331125
              },
              {
                value: '庆元县',
                id: 331126,
                key: 331126
              },
              {
                value: '景宁畲族自治县',
                id: 331127,
                key: 331127
              },
              {
                value: '龙泉市',
                id: 331181,
                key: 331181
              }
            ]
          },
          {
            key: 330200,
            value: '宁波市',
            id: 330200,
            children: [
              {
                value: '海曙区',
                id: 330203,
                key: 330203
              },
              {
                value: '江北区',
                id: 330205,
                key: 330205
              },
              {
                value: '北仑区',
                id: 330206,
                key: 330206
              },
              {
                value: '镇海区',
                id: 330211,
                key: 330211
              },
              {
                value: '鄞州区',
                id: 330212,
                key: 330212
              },
              {
                value: '象山县',
                id: 330225,
                key: 330225
              },
              {
                value: '宁海县',
                id: 330226,
                key: 330226
              },
              {
                value: '余姚市',
                id: 330281,
                key: 330281
              },
              {
                value: '慈溪市',
                id: 330282,
                key: 330282
              },
              {
                value: '奉化区',
                id: 330283,
                key: 330283
              }
            ]
          },
          {
            key: 330800,
            value: '衢州市',
            id: 330800,
            children: [
              {
                value: '柯城区',
                id: 330802,
                key: 330802
              },
              {
                value: '衢江区',
                id: 330803,
                key: 330803
              },
              {
                value: '常山县',
                id: 330822,
                key: 330822
              },
              {
                value: '开化县',
                id: 330824,
                key: 330824
              },
              {
                value: '龙游县',
                id: 330825,
                key: 330825
              },
              {
                value: '江山市',
                id: 330881,
                key: 330881
              }
            ]
          },
          {
            key: 330600,
            value: '绍兴市',
            id: 330600,
            children: [
              {
                value: '越城区',
                id: 330602,
                key: 330602
              },
              {
                value: '柯桥区',
                id: 330603,
                key: 330603
              },
              {
                value: '上虞区',
                id: 330604,
                key: 330604
              },
              {
                value: '新昌县',
                id: 330624,
                key: 330624
              },
              {
                value: '诸暨市',
                id: 330681,
                key: 330681
              },
              {
                value: '嵊州市',
                id: 330683,
                key: 330683
              }
            ]
          },
          {
            key: 331000,
            value: '台州市',
            id: 331000,
            children: [
              {
                value: '椒江区',
                id: 331002,
                key: 331002
              },
              {
                value: '黄岩区',
                id: 331003,
                key: 331003
              },
              {
                value: '路桥区',
                id: 331004,
                key: 331004
              },
              {
                value: '玉环市',
                id: 331021,
                key: 331021
              },
              {
                value: '三门县',
                id: 331022,
                key: 331022
              },
              {
                value: '天台县',
                id: 331023,
                key: 331023
              },
              {
                value: '仙居县',
                id: 331024,
                key: 331024
              },
              {
                value: '温岭市',
                id: 331081,
                key: 331081
              },
              {
                value: '临海市',
                id: 331082,
                key: 331082
              }
            ]
          },
          {
            key: 330300,
            value: '温州市',
            id: 330300,
            children: [
              {
                value: '鹿城区',
                id: 330302,
                key: 330302
              },
              {
                value: '龙湾区',
                id: 330303,
                key: 330303
              },
              {
                value: '瓯海区',
                id: 330304,
                key: 330304
              },
              {
                value: '洞头区',
                id: 330322,
                key: 330322
              },
              {
                value: '永嘉县',
                id: 330324,
                key: 330324
              },
              {
                value: '平阳县',
                id: 330326,
                key: 330326
              },
              {
                value: '苍南县',
                id: 330327,
                key: 330327
              },
              {
                value: '文成县',
                id: 330328,
                key: 330328
              },
              {
                value: '泰顺县',
                id: 330329,
                key: 330329
              },
              {
                value: '瑞安市',
                id: 330381,
                key: 330381
              },
              {
                value: '乐清市',
                id: 330382,
                key: 330382
              }
            ]
          },
          {
            key: 330900,
            value: '舟山市',
            id: 330900,
            children: [
              {
                value: '定海区',
                id: 330902,
                key: 330902
              },
              {
                value: '普陀区',
                id: 330903,
                key: 330903
              },
              {
                value: '岱山县',
                id: 330921,
                key: 330921
              },
              {
                value: '嵊泗县',
                id: 330922,
                key: 330922
              }
            ]
          }
        ]
      },
      {
        key: 820000,
        value: '澳门特别行政区',
        id: 820000,
        children: [
          {
            key: 820101,
            value: '澳门半岛',
            id: 820101
          },
          {
            key: 820102,
            value: '凼仔',
            id: 820102
          },
          {
            key: 820103,
            value: '路凼城',
            id: 820103
          },
          {
            key: 820104,
            value: '路环',
            id: 820104
          }
        ]
      },
      {
        key: 650000,
        value: '新疆维吾尔自治区',
        id: 650000,
        children: [
          {
            key: 659002,
            value: '阿拉尔市',
            id: 659002
          },
          {
            key: 654300,
            value: '阿勒泰地区',
            id: 654300,
            children: [
              {
                value: '阿勒泰市',
                id: 654301,
                key: 654301
              },
              {
                value: '布尔津县',
                id: 654321,
                key: 654321
              },
              {
                value: '富蕴县',
                id: 654322,
                key: 654322
              },
              {
                value: '福海县',
                id: 654323,
                key: 654323
              },
              {
                value: '哈巴河县',
                id: 654324,
                key: 654324
              },
              {
                value: '青河县',
                id: 654325,
                key: 654325
              },
              {
                value: '吉木乃县',
                id: 654326,
                key: 654326
              }
            ]
          },
          {
            key: 652800,
            value: '巴音郭楞蒙古自治州',
            id: 652800,
            children: [
              {
                value: '库尔勒市',
                id: 652801,
                key: 652801
              },
              {
                value: '轮台县',
                id: 652822,
                key: 652822
              },
              {
                value: '尉犁县',
                id: 652823,
                key: 652823
              },
              {
                value: '若羌县',
                id: 652824,
                key: 652824
              },
              {
                value: '且末县',
                id: 652825,
                key: 652825
              },
              {
                value: '焉耆回族自治县',
                id: 652826,
                key: 652826
              },
              {
                value: '和静县',
                id: 652827,
                key: 652827
              },
              {
                value: '和硕县',
                id: 652828,
                key: 652828
              },
              {
                value: '博湖县',
                id: 652829,
                key: 652829
              }
            ]
          },
          {
            key: 652700,
            value: '博尔塔拉蒙古自治州',
            id: 652700,
            children: [
              {
                value: '博乐市',
                id: 652701,
                key: 652701
              },
              {
                value: '阿拉山口市',
                id: 652702,
                key: 652702
              },
              {
                value: '精河县',
                id: 652722,
                key: 652722
              },
              {
                value: '温泉县',
                id: 652723,
                key: 652723
              }
            ]
          },
          {
            key: 652300,
            value: '昌吉回族自治州',
            id: 652300,
            children: [
              {
                value: '昌吉市',
                id: 652301,
                key: 652301
              },
              {
                value: '阜康市',
                id: 652302,
                key: 652302
              },
              {
                value: '呼图壁县',
                id: 652323,
                key: 652323
              },
              {
                value: '玛纳斯县',
                id: 652324,
                key: 652324
              },
              {
                value: '奇台县',
                id: 652325,
                key: 652325
              },
              {
                value: '吉木萨尔县',
                id: 652327,
                key: 652327
              },
              {
                value: '木垒哈萨克自治县',
                id: 652328,
                key: 652328
              }
            ]
          },
          {
            key: 652200,
            value: '哈密市',
            id: 652200,
            children: [
              {
                value: '伊州区',
                id: 652201,
                key: 652201
              },
              {
                value: '巴里坤哈萨克自治县',
                id: 652222,
                key: 652222
              },
              {
                value: '伊吾县',
                id: 652223,
                key: 652223
              }
            ]
          },
          {
            key: 653200,
            value: '和田地区',
            id: 653200,
            children: [
              {
                value: '和田市',
                id: 653201,
                key: 653201
              },
              {
                value: '和田县',
                id: 653221,
                key: 653221
              },
              {
                value: '墨玉县',
                id: 653222,
                key: 653222
              },
              {
                value: '皮山县',
                id: 653223,
                key: 653223
              },
              {
                value: '洛浦县',
                id: 653224,
                key: 653224
              },
              {
                value: '策勒县',
                id: 653225,
                key: 653225
              },
              {
                value: '于田县',
                id: 653226,
                key: 653226
              },
              {
                value: '民丰县',
                id: 653227,
                key: 653227
              }
            ]
          },
          {
            key: 653100,
            value: '喀什地区',
            id: 653100,
            children: [
              {
                value: '喀什市',
                id: 653101,
                key: 653101
              },
              {
                value: '疏附县',
                id: 653121,
                key: 653121
              },
              {
                value: '疏勒县',
                id: 653122,
                key: 653122
              },
              {
                value: '英吉沙县',
                id: 653123,
                key: 653123
              },
              {
                value: '泽普县',
                id: 653124,
                key: 653124
              },
              {
                value: '莎车县',
                id: 653125,
                key: 653125
              },
              {
                value: '叶城县',
                id: 653126,
                key: 653126
              },
              {
                value: '麦盖提县',
                id: 653127,
                key: 653127
              },
              {
                value: '岳普湖县',
                id: 653128,
                key: 653128
              },
              {
                value: '伽师县',
                id: 653129,
                key: 653129
              },
              {
                value: '巴楚县',
                id: 653130,
                key: 653130
              },
              {
                value: '塔什库尔干塔吉克自治县',
                id: 653131,
                key: 653131
              }
            ]
          },
          {
            key: 650200,
            value: '克拉玛依市',
            id: 650200,
            children: [
              {
                value: '独山子区',
                id: 650202,
                key: 650202
              },
              {
                value: '克拉玛依区',
                id: 650203,
                key: 650203
              },
              {
                value: '白碱滩区',
                id: 650204,
                key: 650204
              },
              {
                value: '乌尔禾区',
                id: 650205,
                key: 650205
              }
            ]
          },
          {
            key: 659001,
            value: '石河子市',
            id: 659001
          },
          {
            key: 654200,
            value: '塔城地区',
            id: 654200,
            children: [
              {
                value: '塔城市',
                id: 654201,
                key: 654201
              },
              {
                value: '乌苏市',
                id: 654202,
                key: 654202
              },
              {
                value: '额敏县',
                id: 654221,
                key: 654221
              },
              {
                value: '沙湾县',
                id: 654223,
                key: 654223
              },
              {
                value: '托里县',
                id: 654224,
                key: 654224
              },
              {
                value: '裕民县',
                id: 654225,
                key: 654225
              },
              {
                value: '和布克赛尔蒙古自治县',
                id: 654226,
                key: 654226
              }
            ]
          },
          {
            key: 652100,
            value: '吐鲁番市',
            id: 652100,
            children: [
              {
                value: '高昌区',
                id: 652101,
                key: 652101
              },
              {
                value: '鄯善县',
                id: 652122,
                key: 652122
              },
              {
                value: '托克逊县',
                id: 652123,
                key: 652123
              }
            ]
          },
          {
            key: 650100,
            value: '乌鲁木齐市',
            id: 650100,
            children: [
              {
                value: '天山区',
                id: 650102,
                key: 650102
              },
              {
                value: '沙依巴克区',
                id: 650103,
                key: 650103
              },
              {
                value: '新市区',
                id: 650104,
                key: 650104
              },
              {
                value: '水磨沟区',
                id: 650105,
                key: 650105
              },
              {
                value: '头屯河区',
                id: 650106,
                key: 650106
              },
              {
                value: '达坂城区',
                id: 650107,
                key: 650107
              },
              {
                value: '米东区',
                id: 650109,
                key: 650109
              },
              {
                value: '乌鲁木齐县',
                id: 650121,
                key: 650121
              }
            ]
          },
          {
            key: 654000,
            value: '伊犁哈萨克自治州',
            id: 654000,
            children: [
              {
                value: '伊宁市',
                id: 654002,
                key: 654002
              },
              {
                value: '奎屯市',
                id: 654003,
                key: 654003
              },
              {
                value: '霍尔果斯市',
                id: 654004,
                key: 654004
              },
              {
                value: '伊宁县',
                id: 654021,
                key: 654021
              },
              {
                value: '察布查尔锡伯自治县',
                id: 654022,
                key: 654022
              },
              {
                value: '霍城县',
                id: 654023,
                key: 654023
              },
              {
                value: '巩留县',
                id: 654024,
                key: 654024
              },
              {
                value: '新源县',
                id: 654025,
                key: 654025
              },
              {
                value: '昭苏县',
                id: 654026,
                key: 654026
              },
              {
                value: '特克斯县',
                id: 654027,
                key: 654027
              },
              {
                value: '尼勒克县',
                id: 654028,
                key: 654028
              }
            ]
          },
          {
            key: 652900,
            value: '阿克苏地区',
            id: 652900,
            children: [
              {
                value: '阿克苏市',
                id: 652901,
                key: 652901
              },
              {
                value: '温宿县',
                id: 652922,
                key: 652922
              },
              {
                value: '库车县',
                id: 652923,
                key: 652923
              },
              {
                value: '沙雅县',
                id: 652924,
                key: 652924
              },
              {
                value: '新和县',
                id: 652925,
                key: 652925
              },
              {
                value: '拜城县',
                id: 652926,
                key: 652926
              },
              {
                value: '乌什县',
                id: 652927,
                key: 652927
              },
              {
                value: '阿瓦提县',
                id: 652928,
                key: 652928
              },
              {
                value: '柯坪县',
                id: 652929,
                key: 652929
              }
            ]
          },
          {
            key: 653000,
            value: '克孜勒苏柯尔克孜自治州',
            id: 653000,
            children: [
              {
                value: '阿图什市',
                id: 653001,
                key: 653001
              },
              {
                value: '阿克陶县',
                id: 653022,
                key: 653022
              },
              {
                value: '阿合奇县',
                id: 653023,
                key: 653023
              },
              {
                value: '乌恰县',
                id: 653024,
                key: 653024
              }
            ]
          },
          {
            key: 659004,
            value: '五家渠市',
            id: 659004
          },
          {
            key: 659003,
            value: '图木舒克市',
            id: 659003
          },
          {
            key: 659005,
            value: '北屯市',
            id: 659005
          },
          {
            key: 659006,
            value: '铁门关市',
            id: 659006
          },
          {
            key: 659007,
            value: '双河市',
            id: 659007
          },
          {
            key: 659008,
            value: '可克达拉市',
            id: 659008
          },
          {
            key: 659009,
            value: '昆玉市',
            id: 659009
          }
        ]
      },
      {
        key: 350000,
        value: '福建省',
        id: 350000,
        children: [
          {
            key: 350100,
            value: '福州市',
            id: 350100,
            children: [
              {
                value: '鼓楼区',
                id: 350102,
                key: 350102
              },
              {
                value: '台江区',
                id: 350103,
                key: 350103
              },
              {
                value: '仓山区',
                id: 350104,
                key: 350104
              },
              {
                value: '马尾区',
                id: 350105,
                key: 350105
              },
              {
                value: '晋安区',
                id: 350111,
                key: 350111
              },
              {
                value: '闽侯县',
                id: 350121,
                key: 350121
              },
              {
                value: '连江县',
                id: 350122,
                key: 350122
              },
              {
                value: '罗源县',
                id: 350123,
                key: 350123
              },
              {
                value: '闽清县',
                id: 350124,
                key: 350124
              },
              {
                value: '永泰县',
                id: 350125,
                key: 350125
              },
              {
                value: '平潭县',
                id: 350128,
                key: 350128
              },
              {
                value: '福清市',
                id: 350181,
                key: 350181
              },
              {
                value: '长乐区',
                id: 350182,
                key: 350182
              }
            ]
          },
          {
            key: 350800,
            value: '龙岩市',
            id: 350800,
            children: [
              {
                value: '新罗区',
                id: 350802,
                key: 350802
              },
              {
                value: '长汀县',
                id: 350821,
                key: 350821
              },
              {
                value: '永定区',
                id: 350822,
                key: 350822
              },
              {
                value: '上杭县',
                id: 350823,
                key: 350823
              },
              {
                value: '武平县',
                id: 350824,
                key: 350824
              },
              {
                value: '连城县',
                id: 350825,
                key: 350825
              },
              {
                value: '漳平市',
                id: 350881,
                key: 350881
              }
            ]
          },
          {
            key: 350700,
            value: '南平市',
            id: 350700,
            children: [
              {
                value: '延平区',
                id: 350702,
                key: 350702
              },
              {
                value: '顺昌县',
                id: 350721,
                key: 350721
              },
              {
                value: '浦城县',
                id: 350722,
                key: 350722
              },
              {
                value: '光泽县',
                id: 350723,
                key: 350723
              },
              {
                value: '松溪县',
                id: 350724,
                key: 350724
              },
              {
                value: '政和县',
                id: 350725,
                key: 350725
              },
              {
                value: '邵武市',
                id: 350781,
                key: 350781
              },
              {
                value: '武夷山市',
                id: 350782,
                key: 350782
              },
              {
                value: '建瓯市',
                id: 350783,
                key: 350783
              },
              {
                value: '建阳区',
                id: 350784,
                key: 350784
              }
            ]
          },
          {
            key: 350900,
            value: '宁德市',
            id: 350900,
            children: [
              {
                value: '蕉城区',
                id: 350902,
                key: 350902
              },
              {
                value: '霞浦县',
                id: 350921,
                key: 350921
              },
              {
                value: '古田县',
                id: 350922,
                key: 350922
              },
              {
                value: '屏南县',
                id: 350923,
                key: 350923
              },
              {
                value: '寿宁县',
                id: 350924,
                key: 350924
              },
              {
                value: '周宁县',
                id: 350925,
                key: 350925
              },
              {
                value: '柘荣县',
                id: 350926,
                key: 350926
              },
              {
                value: '福安市',
                id: 350981,
                key: 350981
              },
              {
                value: '福鼎市',
                id: 350982,
                key: 350982
              }
            ]
          },
          {
            key: 350300,
            value: '莆田市',
            id: 350300,
            children: [
              {
                value: '城厢区',
                id: 350302,
                key: 350302
              },
              {
                value: '涵江区',
                id: 350303,
                key: 350303
              },
              {
                value: '荔城区',
                id: 350304,
                key: 350304
              },
              {
                value: '秀屿区',
                id: 350305,
                key: 350305
              },
              {
                value: '仙游县',
                id: 350322,
                key: 350322
              }
            ]
          },
          {
            key: 350500,
            value: '泉州市',
            id: 350500,
            children: [
              {
                value: '鲤城区',
                id: 350502,
                key: 350502
              },
              {
                value: '丰泽区',
                id: 350503,
                key: 350503
              },
              {
                value: '洛江区',
                id: 350504,
                key: 350504
              },
              {
                value: '泉港区',
                id: 350505,
                key: 350505
              },
              {
                value: '惠安县',
                id: 350521,
                key: 350521
              },
              {
                value: '安溪县',
                id: 350524,
                key: 350524
              },
              {
                value: '永春县',
                id: 350525,
                key: 350525
              },
              {
                value: '德化县',
                id: 350526,
                key: 350526
              },
              {
                value: '金门县',
                id: 350527,
                key: 350527
              },
              {
                value: '石狮市',
                id: 350581,
                key: 350581
              },
              {
                value: '晋江市',
                id: 350582,
                key: 350582
              },
              {
                value: '南安市',
                id: 350583,
                key: 350583
              }
            ]
          },
          {
            key: 350400,
            value: '三明市',
            id: 350400,
            children: [
              {
                value: '梅列区',
                id: 350402,
                key: 350402
              },
              {
                value: '三元区',
                id: 350403,
                key: 350403
              },
              {
                value: '明溪县',
                id: 350421,
                key: 350421
              },
              {
                value: '清流县',
                id: 350423,
                key: 350423
              },
              {
                value: '宁化县',
                id: 350424,
                key: 350424
              },
              {
                value: '大田县',
                id: 350425,
                key: 350425
              },
              {
                value: '尤溪县',
                id: 350426,
                key: 350426
              },
              {
                value: '沙县',
                id: 350427,
                key: 350427
              },
              {
                value: '将乐县',
                id: 350428,
                key: 350428
              },
              {
                value: '泰宁县',
                id: 350429,
                key: 350429
              },
              {
                value: '建宁县',
                id: 350430,
                key: 350430
              },
              {
                value: '永安市',
                id: 350481,
                key: 350481
              }
            ]
          },
          {
            key: 350200,
            value: '厦门市',
            id: 350200,
            children: [
              {
                value: '思明区',
                id: 350203,
                key: 350203
              },
              {
                value: '海沧区',
                id: 350205,
                key: 350205
              },
              {
                value: '湖里区',
                id: 350206,
                key: 350206
              },
              {
                value: '集美区',
                id: 350211,
                key: 350211
              },
              {
                value: '同安区',
                id: 350212,
                key: 350212
              },
              {
                value: '翔安区',
                id: 350213,
                key: 350213
              }
            ]
          },
          {
            key: 350600,
            value: '漳州市',
            id: 350600,
            children: [
              {
                value: '芗城区',
                id: 350602,
                key: 350602
              },
              {
                value: '龙文区',
                id: 350603,
                key: 350603
              },
              {
                value: '云霄县',
                id: 350622,
                key: 350622
              },
              {
                value: '漳浦县',
                id: 350623,
                key: 350623
              },
              {
                value: '诏安县',
                id: 350624,
                key: 350624
              },
              {
                value: '长泰县',
                id: 350625,
                key: 350625
              },
              {
                value: '东山县',
                id: 350626,
                key: 350626
              },
              {
                value: '南靖县',
                id: 350627,
                key: 350627
              },
              {
                value: '平和县',
                id: 350628,
                key: 350628
              },
              {
                value: '华安县',
                id: 350629,
                key: 350629
              },
              {
                value: '龙海市',
                id: 350681,
                key: 350681
              }
            ]
          }
        ]
      },
      {
        key: 120000,
        value: '天津市',
        id: 120000,
        children: [
          {
            key: 120101,
            value: '和平区',
            id: 120101
          },
          {
            key: 120102,
            value: '河东区',
            id: 120102
          },
          {
            key: 120103,
            value: '河西区',
            id: 120103
          },
          {
            key: 120104,
            value: '南开区',
            id: 120104
          },
          {
            key: 120105,
            value: '河北区',
            id: 120105
          },
          {
            key: 120106,
            value: '红桥区',
            id: 120106
          },
          {
            key: 120110,
            value: '东丽区',
            id: 120110
          },
          {
            key: 120111,
            value: '西青区',
            id: 120111
          },
          {
            key: 120112,
            value: '津南区',
            id: 120112
          },
          {
            key: 120113,
            value: '北辰区',
            id: 120113
          },
          {
            key: 120114,
            value: '武清区',
            id: 120114
          },
          {
            key: 120115,
            value: '宝坻区',
            id: 120115
          },
          {
            key: 120116,
            value: '滨海新区',
            id: 120116
          },
          {
            key: 120221,
            value: '宁河区',
            id: 120221
          },
          {
            key: 120223,
            value: '静海区',
            id: 120223
          },
          {
            key: 120225,
            value: '蓟州区',
            id: 120225
          }
        ]
      },
      {
        key: 110000,
        value: '北京市',
        id: 110000,
        children: [
          {
            key: 110101,
            value: '东城区',
            id: 110101
          },
          {
            key: 110102,
            value: '西城区',
            id: 110102
          },
          {
            key: 110105,
            value: '朝阳区',
            id: 110105
          },
          {
            key: 110106,
            value: '丰台区',
            id: 110106
          },
          {
            key: 110107,
            value: '石景山区',
            id: 110107
          },
          {
            key: 110108,
            value: '海淀区',
            id: 110108
          },
          {
            key: 110109,
            value: '门头沟区',
            id: 110109
          },
          {
            key: 110111,
            value: '房山区',
            id: 110111
          },
          {
            key: 110112,
            value: '通州区',
            id: 110112
          },
          {
            key: 110113,
            value: '顺义区',
            id: 110113
          },
          {
            key: 110114,
            value: '昌平区',
            id: 110114
          },
          {
            key: 110115,
            value: '大兴区',
            id: 110115
          },
          {
            key: 110116,
            value: '怀柔区',
            id: 110116
          },
          {
            key: 110117,
            value: '平谷区',
            id: 110117
          },
          {
            key: 110228,
            value: '密云区',
            id: 110228
          },
          {
            key: 110229,
            value: '延庆区',
            id: 110229
          }
        ]
      },
      {
        key: 640000,
        value: '宁夏回族自治区',
        id: 640000,
        children: [
          {
            key: 640400,
            value: '固原市',
            id: 640400,
            children: [
              {
                value: '原州区',
                id: 640402,
                key: 640402
              },
              {
                value: '西吉县',
                id: 640422,
                key: 640422
              },
              {
                value: '隆德县',
                id: 640423,
                key: 640423
              },
              {
                value: '泾源县',
                id: 640424,
                key: 640424
              },
              {
                value: '彭阳县',
                id: 640425,
                key: 640425
              }
            ]
          },
          {
            key: 640100,
            value: '银川市',
            id: 640100,
            children: [
              {
                value: '兴庆区',
                id: 640104,
                key: 640104
              },
              {
                value: '西夏区',
                id: 640105,
                key: 640105
              },
              {
                value: '金凤区',
                id: 640106,
                key: 640106
              },
              {
                value: '永宁县',
                id: 640121,
                key: 640121
              },
              {
                value: '贺兰县',
                id: 640122,
                key: 640122
              },
              {
                value: '灵武市',
                id: 640181,
                key: 640181
              }
            ]
          },
          {
            key: 640200,
            value: '石嘴山市',
            id: 640200,
            children: [
              {
                value: '大武口区',
                id: 640202,
                key: 640202
              },
              {
                value: '惠农区',
                id: 640205,
                key: 640205
              },
              {
                value: '平罗县',
                id: 640221,
                key: 640221
              }
            ]
          },
          {
            key: 640300,
            value: '吴忠市',
            id: 640300,
            children: [
              {
                value: '利通区',
                id: 640302,
                key: 640302
              },
              {
                value: '红寺堡区',
                id: 640303,
                key: 640303
              },
              {
                value: '盐池县',
                id: 640323,
                key: 640323
              },
              {
                value: '同心县',
                id: 640324,
                key: 640324
              },
              {
                value: '青铜峡市',
                id: 640381,
                key: 640381
              }
            ]
          },
          {
            key: 640500,
            value: '中卫市',
            id: 640500,
            children: [
              {
                value: '沙坡头区',
                id: 640502,
                key: 640502
              },
              {
                value: '中宁县',
                id: 640521,
                key: 640521
              },
              {
                value: '海原县',
                id: 640522,
                key: 640522
              }
            ]
          }
        ]
      },
      {
        key: 530000,
        value: '云南省',
        id: 530000,
        children: [
          {
            key: 530500,
            value: '保山市',
            id: 530500,
            children: [
              {
                value: '隆阳区',
                id: 530502,
                key: 530502
              },
              {
                value: '施甸县',
                id: 530521,
                key: 530521
              },
              {
                value: '腾冲市',
                id: 530522,
                key: 530522
              },
              {
                value: '龙陵县',
                id: 530523,
                key: 530523
              },
              {
                value: '昌宁县',
                id: 530524,
                key: 530524
              }
            ]
          },
          {
            key: 532300,
            value: '楚雄彝族自治州',
            id: 532300,
            children: [
              {
                value: '楚雄市',
                id: 532301,
                key: 532301
              },
              {
                value: '双柏县',
                id: 532322,
                key: 532322
              },
              {
                value: '牟定县',
                id: 532323,
                key: 532323
              },
              {
                value: '南华县',
                id: 532324,
                key: 532324
              },
              {
                value: '姚安县',
                id: 532325,
                key: 532325
              },
              {
                value: '大姚县',
                id: 532326,
                key: 532326
              },
              {
                value: '永仁县',
                id: 532327,
                key: 532327
              },
              {
                value: '元谋县',
                id: 532328,
                key: 532328
              },
              {
                value: '武定县',
                id: 532329,
                key: 532329
              },
              {
                value: '禄丰县',
                id: 532331,
                key: 532331
              }
            ]
          },
          {
            key: 530400,
            value: '玉溪市',
            id: 530400,
            children: [
              {
                value: '红塔区',
                id: 530402,
                key: 530402
              },
              {
                value: '江川区',
                id: 530421,
                key: 530421
              },
              {
                value: '澄江县',
                id: 530422,
                key: 530422
              },
              {
                value: '通海县',
                id: 530423,
                key: 530423
              },
              {
                value: '华宁县',
                id: 530424,
                key: 530424
              },
              {
                value: '易门县',
                id: 530425,
                key: 530425
              },
              {
                value: '峨山彝族自治县',
                id: 530426,
                key: 530426
              },
              {
                value: '新平彝族傣族自治县',
                id: 530427,
                key: 530427
              },
              {
                value: '元江县',
                id: 530428,
                key: 530428
              }
            ]
          },
          {
            key: 530600,
            value: '昭通市',
            id: 530600,
            children: [
              {
                value: '昭阳区',
                id: 530602,
                key: 530602
              },
              {
                value: '鲁甸县',
                id: 530621,
                key: 530621
              },
              {
                value: '巧家县',
                id: 530622,
                key: 530622
              },
              {
                value: '盐津县',
                id: 530623,
                key: 530623
              },
              {
                value: '大关县',
                id: 530624,
                key: 530624
              },
              {
                value: '永善县',
                id: 530625,
                key: 530625
              },
              {
                value: '绥江县',
                id: 530626,
                key: 530626
              },
              {
                value: '镇雄县',
                id: 530627,
                key: 530627
              },
              {
                value: '彝良县',
                id: 530628,
                key: 530628
              },
              {
                value: '威信县',
                id: 530629,
                key: 530629
              },
              {
                value: '水富县',
                id: 530630,
                key: 530630
              }
            ]
          },
          {
            key: 530300,
            value: '曲靖市',
            id: 530300,
            children: [
              {
                value: '麒麟区',
                id: 530302,
                key: 530302
              },
              {
                value: '马龙县',
                id: 530321,
                key: 530321
              },
              {
                value: '陆良县',
                id: 530322,
                key: 530322
              },
              {
                value: '师宗县',
                id: 530323,
                key: 530323
              },
              {
                value: '罗平县',
                id: 530324,
                key: 530324
              },
              {
                value: '富源县',
                id: 530325,
                key: 530325
              },
              {
                value: '会泽县',
                id: 530326,
                key: 530326
              },
              {
                value: '沾益区',
                id: 530328,
                key: 530328
              },
              {
                value: '宣威市',
                id: 530381,
                key: 530381
              }
            ]
          },
          {
            key: 530800,
            value: '普洱市',
            id: 530800,
            children: [
              {
                value: '思茅区',
                id: 530802,
                key: 530802
              },
              {
                value: '宁洱哈尼族彝族自治县',
                id: 530821,
                key: 530821
              },
              {
                value: '墨江哈尼族自治县',
                id: 530822,
                key: 530822
              },
              {
                value: '景东彝族自治县',
                id: 530823,
                key: 530823
              },
              {
                value: '景谷傣族彝族自治县',
                id: 530824,
                key: 530824
              },
              {
                value: '镇沅县',
                id: 530825,
                key: 530825
              },
              {
                value: '江城哈尼族彝族自治县',
                id: 530826,
                key: 530826
              },
              {
                value: '孟连县',
                id: 530827,
                key: 530827
              },
              {
                value: '澜沧拉祜族自治县',
                id: 530828,
                key: 530828
              },
              {
                value: '西盟佤族自治县',
                id: 530829,
                key: 530829
              }
            ]
          },
          {
            key: 532600,
            value: '文山壮族苗族自治州',
            id: 532600,
            children: [
              {
                value: '文山市',
                id: 532601,
                key: 532601
              },
              {
                value: '砚山县',
                id: 532622,
                key: 532622
              },
              {
                value: '西畴县',
                id: 532623,
                key: 532623
              },
              {
                value: '麻栗坡县',
                id: 532624,
                key: 532624
              },
              {
                value: '马关县',
                id: 532625,
                key: 532625
              },
              {
                value: '丘北县',
                id: 532626,
                key: 532626
              },
              {
                value: '广南县',
                id: 532627,
                key: 532627
              },
              {
                value: '富宁县',
                id: 532628,
                key: 532628
              }
            ]
          },
          {
            key: 532800,
            value: '西双版纳傣族自治州',
            id: 532800,
            children: [
              {
                value: '景洪市',
                id: 532801,
                key: 532801
              },
              {
                value: '勐海县',
                id: 532822,
                key: 532822
              },
              {
                value: '勐腊县',
                id: 532823,
                key: 532823
              }
            ]
          },
          {
            key: 532900,
            value: '大理白族自治州',
            id: 532900,
            children: [
              {
                value: '大理市',
                id: 532901,
                key: 532901
              },
              {
                value: '漾濞彝族自治县',
                id: 532922,
                key: 532922
              },
              {
                value: '祥云县',
                id: 532923,
                key: 532923
              },
              {
                value: '宾川县',
                id: 532924,
                key: 532924
              },
              {
                value: '弥渡县',
                id: 532925,
                key: 532925
              },
              {
                value: '南涧彝族自治县',
                id: 532926,
                key: 532926
              },
              {
                value: '巍山彝族回族自治县',
                id: 532927,
                key: 532927
              },
              {
                value: '永平县',
                id: 532928,
                key: 532928
              },
              {
                value: '云龙县',
                id: 532929,
                key: 532929
              },
              {
                value: '洱源县',
                id: 532930,
                key: 532930
              },
              {
                value: '剑川县',
                id: 532931,
                key: 532931
              },
              {
                value: '鹤庆县',
                id: 532932,
                key: 532932
              }
            ]
          },
          {
            key: 533100,
            value: '德宏傣族景颇族自治州',
            id: 533100,
            children: [
              {
                value: '瑞丽市',
                id: 533102,
                key: 533102
              },
              {
                value: '芒市',
                id: 533103,
                key: 533103
              },
              {
                value: '梁河县',
                id: 533122,
                key: 533122
              },
              {
                value: '盈江县',
                id: 533123,
                key: 533123
              },
              {
                value: '陇川县',
                id: 533124,
                key: 533124
              }
            ]
          },
          {
            key: 533400,
            value: '迪庆藏族自治州',
            id: 533400,
            children: [
              {
                value: '香格里拉市',
                id: 533421,
                key: 533421
              },
              {
                value: '德钦县',
                id: 533422,
                key: 533422
              },
              {
                value: '维西傈僳族自治县',
                id: 533423,
                key: 533423
              }
            ]
          },
          {
            key: 532500,
            value: '红河哈尼族彝族自治州',
            id: 532500,
            children: [
              {
                value: '个旧市',
                id: 532501,
                key: 532501
              },
              {
                value: '开远市',
                id: 532502,
                key: 532502
              },
              {
                value: '蒙自市',
                id: 532503,
                key: 532503
              },
              {
                value: '弥勒市',
                id: 532504,
                key: 532504
              },
              {
                value: '屏边苗族自治县',
                id: 532523,
                key: 532523
              },
              {
                value: '建水县',
                id: 532524,
                key: 532524
              },
              {
                value: '石屏县',
                id: 532525,
                key: 532525
              },
              {
                value: '泸西县',
                id: 532527,
                key: 532527
              },
              {
                value: '元阳县',
                id: 532528,
                key: 532528
              },
              {
                value: '红河县',
                id: 532529,
                key: 532529
              },
              {
                value: '金平苗族瑶族傣族自治县',
                id: 532530,
                key: 532530
              },
              {
                value: '绿春县',
                id: 532531,
                key: 532531
              },
              {
                value: '河口瑶族自治县',
                id: 532532,
                key: 532532
              }
            ]
          },
          {
            key: 530100,
            value: '昆明市',
            id: 530100,
            children: [
              {
                value: '五华区',
                id: 530102,
                key: 530102
              },
              {
                value: '盘龙区',
                id: 530103,
                key: 530103
              },
              {
                value: '官渡区',
                id: 530111,
                key: 530111
              },
              {
                value: '西山区',
                id: 530112,
                key: 530112
              },
              {
                value: '东川区',
                id: 530113,
                key: 530113
              },
              {
                value: '呈贡区',
                id: 530114,
                key: 530114
              },
              {
                value: '晋宁区',
                id: 530122,
                key: 530122
              },
              {
                value: '富民县',
                id: 530124,
                key: 530124
              },
              {
                value: '宜良县',
                id: 530125,
                key: 530125
              },
              {
                value: '石林彝族自治县',
                id: 530126,
                key: 530126
              },
              {
                value: '嵩明县',
                id: 530127,
                key: 530127
              },
              {
                value: '禄劝彝族苗族自治县',
                id: 530128,
                key: 530128
              },
              {
                value: '寻甸回族彝族自治县',
                id: 530129,
                valkeyue: 530129
              },
              {
                value: '安宁市',
                id: 530181,
                key: 530181
              }
            ]
          },
          {
            key: 530700,
            value: '丽江市',
            id: 530700,
            children: [
              {
                value: '古城区',
                id: 530702,
                key: 530702
              },
              {
                value: '玉龙纳西族自治县',
                id: 530721,
                key: 530721
              },
              {
                value: '永胜县',
                id: 530722,
                key: 530722
              },
              {
                value: '华坪县',
                id: 530723,
                key: 530723
              },
              {
                value: '宁蒗彝族自治县',
                id: 530724,
                key: 530724
              }
            ]
          },
          {
            key: 530900,
            value: '临沧市',
            id: 530900,
            children: [
              {
                value: '临翔区',
                id: 530902,
                key: 530902
              },
              {
                value: '凤庆县',
                id: 530921,
                key: 530921
              },
              {
                value: '云县',
                id: 530922,
                key: 530922
              },
              {
                value: '永德县',
                id: 530923,
                key: 530923
              },
              {
                value: '镇康县',
                id: 530924,
                key: 530924
              },
              {
                value: '双江县',
                id: 530925,
                key: 530925
              },
              {
                value: '耿马傣族佤族自治县',
                id: 530926,
                key: 530926
              },
              {
                value: '沧源佤族自治县',
                id: 530927,
                key: 530927
              }
            ]
          },
          {
            key: 533300,
            value: '怒江傈僳族自治州',
            id: 533300,
            children: [
              {
                value: '泸水市',
                id: 533321,
                key: 533321
              },
              {
                value: '福贡县',
                id: 533323,
                key: 533323
              },
              {
                value: '贡山独龙族怒族自治县',
                id: 533324,
                key: 533324
              },
              {
                value: '兰坪白族普米族自治县',
                id: 533325,
                key: 533325
              }
            ]
          }
        ]
      },
      {
        key: 210000,
        value: '辽宁省',
        id: 210000,
        children: [
          {
            key: 210300,
            value: '鞍山市',
            id: 210300,
            children: [
              {
                value: '铁东区',
                id: 210302,
                key: 210302
              },
              {
                value: '铁西区',
                id: 210303,
                key: 210303
              },
              {
                value: '立山区',
                id: 210304,
                key: 210304
              },
              {
                value: '千山区',
                id: 210311,
                key: 210311
              },
              {
                value: '台安县',
                id: 210321,
                key: 210321
              },
              {
                value: '岫岩满族自治县',
                id: 210323,
                key: 210323
              },
              {
                value: '海城市',
                id: 210381,
                key: 210381
              }
            ]
          },
          {
            key: 210500,
            value: '本溪市',
            id: 210500,
            children: [
              {
                value: '平山区',
                id: 210502,
                key: 210502
              },
              {
                value: '溪湖区',
                id: 210503,
                key: 210503
              },
              {
                value: '明山区',
                id: 210504,
                key: 210504
              },
              {
                value: '南芬区',
                id: 210505,
                key: 210505
              },
              {
                value: '本溪满族自治县',
                id: 210521,
                key: 210521
              },
              {
                value: '桓仁满族自治县',
                id: 210522,
                key: 210522
              }
            ]
          },
          {
            key: 211300,
            value: '朝阳市',
            id: 211300,
            children: [
              {
                value: '双塔区',
                id: 211302,
                key: 211302
              },
              {
                value: '龙城区',
                id: 211303,
                key: 211303
              },
              {
                value: '朝阳县',
                id: 211321,
                key: 211321
              },
              {
                value: '建平县',
                id: 211322,
                key: 211322
              },
              {
                value: '喀喇沁左翼蒙古族自治县',
                id: 211324,
                key: 211324
              },
              {
                value: '北票市',
                id: 211381,
                key: 211381
              },
              {
                value: '凌源市',
                id: 211382,
                key: 211382
              }
            ]
          },
          {
            key: 210800,
            value: '营口市',
            id: 210800,
            children: [
              {
                value: '站前区',
                id: 210802,
                key: 210802
              },
              {
                value: '西市区',
                id: 210803,
                key: 210803
              },
              {
                value: '鲅鱼圈区',
                id: 210804,
                key: 210804
              },
              {
                value: '老边区',
                id: 210811,
                key: 210811
              },
              {
                value: '盖州市',
                id: 210881,
                key: 210881
              },
              {
                value: '大石桥市',
                id: 210882,
                key: 210882
              }
            ]
          },
          {
            key: 210100,
            value: '沈阳市',
            id: 210100,
            children: [
              {
                value: '和平区',
                id: 210102,
                key: 210102
              },
              {
                value: '沈河区',
                id: 210103,
                key: 210103
              },
              {
                value: '大东区',
                id: 210104,
                key: 210104
              },
              {
                value: '皇姑区',
                id: 210105,
                key: 210105
              },
              {
                value: '铁西区',
                id: 210106,
                key: 210106
              },
              {
                value: '苏家屯区',
                id: 210111,
                key: 210111
              },
              {
                value: '浑南区',
                id: 210112,
                key: 210112
              },
              {
                value: '沈北新区',
                id: 210113,
                key: 210113
              },
              {
                value: '于洪区',
                id: 210114,
                key: 210114
              },
              {
                value: '辽中区',
                id: 210122,
                key: 210122
              },
              {
                value: '康平县',
                id: 210123,
                key: 210123
              },
              {
                value: '法库县',
                id: 210124,
                key: 210124
              },
              {
                value: '新民市',
                id: 210181,
                key: 210181
              }
            ]
          },
          {
            key: 211200,
            value: '铁岭市',
            id: 211200,
            children: [
              {
                value: '银州区',
                id: 211202,
                key: 211202
              },
              {
                value: '清河区',
                id: 211204,
                key: 211204
              },
              {
                value: '铁岭县',
                id: 211221,
                key: 211221
              },
              {
                value: '西丰县',
                id: 211223,
                key: 211223
              },
              {
                value: '昌图县',
                id: 211224,
                key: 211224
              },
              {
                value: '调兵山市',
                id: 211281,
                key: 211281
              },
              {
                value: '开原市',
                id: 211282,
                key: 211282
              }
            ]
          },
          {
            key: 210200,
            value: '大连市',
            id: 210200,
            children: [
              {
                value: '中山区',
                id: 210202,
                key: 210202
              },
              {
                value: '西岗区',
                id: 210203,
                key: 210203
              },
              {
                value: '沙河口区',
                id: 210204,
                key: 210204
              },
              {
                value: '甘井子区',
                id: 210211,
                key: 210211
              },
              {
                value: '旅顺口区',
                id: 210212,
                key: 210212
              },
              {
                value: '金州区',
                id: 210213,
                key: 210213
              },
              {
                value: '长海县',
                id: 210224,
                key: 210224
              },
              {
                value: '瓦房店市',
                id: 210281,
                key: 210281
              },
              {
                value: '普兰店区',
                id: 210282,
                key: 210282
              },
              {
                value: '庄河市',
                id: 210283,
                key: 210283
              }
            ]
          },
          {
            key: 210600,
            value: '丹东市',
            id: 210600,
            children: [
              {
                value: '元宝区',
                id: 210602,
                key: 210602
              },
              {
                value: '振兴区',
                id: 210603,
                key: 210603
              },
              {
                value: '振安区',
                id: 210604,
                key: 210604
              },
              {
                value: '宽甸满族自治县',
                id: 210624,
                key: 210624
              },
              {
                value: '东港市',
                id: 210681,
                key: 210681
              },
              {
                value: '凤城市',
                id: 210682,
                key: 210682
              }
            ]
          },
          {
            key: 210400,
            value: '抚顺市',
            id: 210400,
            children: [
              {
                value: '新抚区',
                id: 210402,
                key: 210402
              },
              {
                value: '东洲区',
                id: 210403,
                key: 210403
              },
              {
                value: '望花区',
                id: 210404,
                key: 210404
              },
              {
                value: '顺城区',
                id: 210411,
                key: 210411
              },
              {
                value: '抚顺县',
                id: 210421,
                key: 210421
              },
              {
                value: '新宾满族自治县',
                id: 210422,
                key: 210422
              },
              {
                value: '清原满族自治县',
                id: 210423,
                key: 210423
              }
            ]
          },
          {
            key: 210900,
            value: '阜新市',
            id: 210900,
            children: [
              {
                value: '海州区',
                id: 210902,
                key: 210902
              },
              {
                value: '新邱区',
                id: 210903,
                key: 210903
              },
              {
                value: '太平区',
                id: 210904,
                key: 210904
              },
              {
                value: '清河门区',
                id: 210905,
                key: 210905
              },
              {
                value: '细河区',
                id: 210911,
                key: 210911
              },
              {
                value: '阜新蒙古族自治县',
                id: 210921,
                key: 210921
              },
              {
                value: '彰武县',
                id: 210922,
                key: 210922
              }
            ]
          },
          {
            key: 211400,
            value: '葫芦岛市',
            id: 211400,
            children: [
              {
                value: '连山区',
                id: 211402,
                key: 211402
              },
              {
                value: '龙港区',
                id: 211403,
                key: 211403
              },
              {
                value: '南票区',
                id: 211404,
                key: 211404
              },
              {
                value: '绥中县',
                id: 211421,
                key: 211421
              },
              {
                value: '建昌县',
                id: 211422,
                key: 211422
              },
              {
                value: '兴城市',
                id: 211481,
                key: 211481
              }
            ]
          },
          {
            key: 210700,
            value: '锦州市',
            id: 210700,
            children: [
              {
                value: '古塔区',
                id: 210702,
                key: 210702
              },
              {
                value: '凌河区',
                id: 210703,
                key: 210703
              },
              {
                value: '太和区',
                id: 210711,
                key: 210711
              },
              {
                value: '黑山县',
                id: 210726,
                key: 210726
              },
              {
                value: '义县',
                id: 210727,
                key: 210727
              },
              {
                value: '凌海市',
                id: 210781,
                key: 210781
              },
              {
                value: '北镇市',
                id: 210782,
                key: 210782
              }
            ]
          },
          {
            key: 211000,
            value: '辽阳市',
            id: 211000,
            children: [
              {
                value: '白塔区',
                id: 211002,
                key: 211002
              },
              {
                value: '文圣区',
                id: 211003,
                key: 211003
              },
              {
                value: '宏伟区',
                id: 211004,
                key: 211004
              },
              {
                value: '弓长岭区',
                id: 211005,
                key: 211005
              },
              {
                value: '太子河区',
                id: 211011,
                key: 211011
              },
              {
                value: '辽阳县',
                id: 211021,
                key: 211021
              },
              {
                value: '灯塔市',
                id: 211081,
                key: 211081
              }
            ]
          },
          {
            key: 211100,
            value: '盘锦市',
            id: 211100,
            children: [
              {
                value: '双台子区',
                id: 211102,
                key: 211102
              },
              {
                value: '兴隆台区',
                id: 211103,
                key: 211103
              },
              {
                value: '大洼区',
                id: 211121,
                key: 211121
              },
              {
                value: '盘山县',
                id: 211122,
                key: 211122
              }
            ]
          }
        ]
      },
      {
        key: 610000,
        value: '陕西省',
        id: 610000,
        children: [
          {
            key: 610900,
            value: '安康市',
            id: 610900,
            children: [
              {
                value: '汉滨区',
                id: 610902,
                key: 610902
              },
              {
                value: '汉阴县',
                id: 610921,
                key: 610921
              },
              {
                value: '石泉县',
                id: 610922,
                key: 610922
              },
              {
                value: '宁陕县',
                id: 610923,
                key: 610923
              },
              {
                value: '紫阳县',
                id: 610924,
                key: 610924
              },
              {
                value: '岚皋县',
                id: 610925,
                key: 610925
              },
              {
                value: '平利县',
                id: 610926,
                key: 610926
              },
              {
                value: '镇坪县',
                id: 610927,
                key: 610927
              },
              {
                value: '旬阳县',
                id: 610928,
                key: 610928
              },
              {
                value: '白河县',
                id: 610929,
                key: 610929
              }
            ]
          },
          {
            key: 610300,
            value: '宝鸡市',
            id: 610300,
            children: [
              {
                value: '渭滨区',
                id: 610302,
                key: 610302
              },
              {
                value: '金台区',
                id: 610303,
                key: 610303
              },
              {
                value: '陈仓区',
                id: 610304,
                key: 610304
              },
              {
                value: '凤翔县',
                id: 610322,
                key: 610322
              },
              {
                value: '岐山县',
                id: 610323,
                key: 610323
              },
              {
                value: '扶风县',
                id: 610324,
                key: 610324
              },
              {
                value: '眉县',
                id: 610326,
                key: 610326
              },
              {
                value: '陇县',
                id: 610327,
                key: 610327
              },
              {
                value: '千阳县',
                id: 610328,
                key: 610328
              },
              {
                value: '麟游县',
                id: 610329,
                key: 610329
              },
              {
                value: '凤县',
                id: 610330,
                key: 610330
              },
              {
                value: '太白县',
                id: 610331,
                key: 610331
              }
            ]
          },
          {
            key: 610700,
            value: '汉中市',
            id: 610700,
            children: [
              {
                value: '汉台区',
                id: 610702,
                key: 610702
              },
              {
                value: '南郑区',
                id: 610721,
                key: 610721
              },
              {
                value: '城固县',
                id: 610722,
                key: 610722
              },
              {
                value: '洋县',
                id: 610723,
                key: 610723
              },
              {
                value: '西乡县',
                id: 610724,
                key: 610724
              },
              {
                value: '勉县',
                id: 610725,
                key: 610725
              },
              {
                value: '宁强县',
                id: 610726,
                key: 610726
              },
              {
                value: '略阳县',
                id: 610727,
                key: 610727
              },
              {
                value: '镇巴县',
                id: 610728,
                key: 610728
              },
              {
                value: '留坝县',
                id: 610729,
                key: 610729
              },
              {
                value: '佛坪县',
                id: 610730,
                key: 610730
              }
            ]
          },
          {
            key: 611000,
            value: '商洛市',
            id: 611000,
            children: [
              {
                value: '商州区',
                id: 611002,
                key: 611002
              },
              {
                value: '洛南县',
                id: 611021,
                key: 611021
              },
              {
                value: '丹凤县',
                id: 611022,
                key: 611022
              },
              {
                value: '商南县',
                id: 611023,
                key: 611023
              },
              {
                value: '山阳县',
                id: 611024,
                key: 611024
              },
              {
                value: '镇安县',
                id: 611025,
                key: 611025
              },
              {
                value: '柞水县',
                id: 611026,
                key: 611026
              }
            ]
          },
          {
            key: 610600,
            value: '延安市',
            id: 610600,
            children: [
              {
                value: '宝塔区',
                id: 610602,
                key: 610602
              },
              {
                value: '延长县',
                id: 610621,
                key: 610621
              },
              {
                value: '延川县',
                id: 610622,
                key: 610622
              },
              {
                value: '子长县',
                id: 610623,
                key: 610623
              },
              {
                value: '安塞区',
                id: 610624,
                key: 610624
              },
              {
                value: '志丹县',
                id: 610625,
                key: 610625
              },
              {
                value: '吴起县',
                id: 610626,
                key: 610626
              },
              {
                value: '甘泉县',
                id: 610627,
                key: 610627
              },
              {
                value: '富县',
                id: 610628,
                key: 610628
              },
              {
                value: '洛川县',
                id: 610629,
                key: 610629
              },
              {
                value: '宜川县',
                id: 610630,
                key: 610630
              },
              {
                value: '黄龙县',
                id: 610631,
                key: 610631
              },
              {
                value: '黄陵县',
                id: 610632,
                key: 610632
              }
            ]
          },
          {
            key: 610800,
            value: '榆林市',
            id: 610800,
            children: [
              {
                value: '榆阳区',
                id: 610802,
                key: 610802
              },
              {
                value: '神木市',
                id: 610821,
                key: 610821
              },
              {
                value: '府谷县',
                id: 610822,
                key: 610822
              },
              {
                value: '横山区',
                id: 610823,
                key: 610823
              },
              {
                value: '靖边县',
                id: 610824,
                key: 610824
              },
              {
                value: '定边县',
                id: 610825,
                key: 610825
              },
              {
                value: '绥德县',
                id: 610826,
                key: 610826
              },
              {
                value: '米脂县',
                id: 610827,
                key: 610827
              },
              {
                value: '佳县',
                id: 610828,
                key: 610828
              },
              {
                value: '吴堡县',
                id: 610829,
                key: 610829
              },
              {
                value: '清涧县',
                id: 610830,
                key: 610830
              },
              {
                value: '子洲县',
                id: 610831,
                key: 610831
              }
            ]
          },
          {
            key: 610200,
            value: '铜川市',
            id: 610200,
            children: [
              {
                value: '王益区',
                id: 610202,
                key: 610202
              },
              {
                value: '印台区',
                id: 610203,
                key: 610203
              },
              {
                value: '耀州区',
                id: 610204,
                key: 610204
              },
              {
                value: '宜君县',
                id: 610222,
                key: 610222
              }
            ]
          },
          {
            key: 610500,
            value: '渭南市',
            id: 610500,
            children: [
              {
                value: '临渭区',
                id: 610502,
                key: 610502
              },
              {
                value: '华州区',
                id: 610521,
                key: 610521
              },
              {
                value: '潼关县',
                id: 610522,
                key: 610522
              },
              {
                value: '大荔县',
                id: 610523,
                key: 610523
              },
              {
                value: '合阳县',
                id: 610524,
                key: 610524
              },
              {
                value: '澄城县',
                id: 610525,
                key: 610525
              },
              {
                value: '蒲城县',
                id: 610526,
                key: 610526
              },
              {
                value: '白水县',
                id: 610527,
                key: 610527
              },
              {
                value: '富平县',
                id: 610528,
                key: 610528
              },
              {
                value: '韩城市',
                id: 610581,
                key: 610581
              },
              {
                value: '华阴市',
                id: 610582,
                key: 610582
              }
            ]
          },
          {
            key: 610100,
            value: '西安市',
            id: 610100,
            children: [
              {
                value: '新城区',
                id: 610102,
                key: 610102
              },
              {
                value: '碑林区',
                id: 610103,
                key: 610103
              },
              {
                value: '莲湖区',
                id: 610104,
                key: 610104
              },
              {
                value: '灞桥区',
                id: 610111,
                key: 610111
              },
              {
                value: '未央区',
                id: 610112,
                key: 610112
              },
              {
                value: '雁塔区',
                id: 610113,
                key: 610113
              },
              {
                value: '阎良区',
                id: 610114,
                key: 610114
              },
              {
                value: '临潼区',
                id: 610115,
                key: 610115
              },
              {
                value: '长安区',
                id: 610116,
                key: 610116
              },
              {
                value: '蓝田县',
                id: 610122,
                key: 610122
              },
              {
                value: '周至县',
                id: 610124,
                key: 610124
              },
              {
                value: '鄠邑区',
                id: 610125,
                key: 610125
              },
              {
                value: '高陵区',
                id: 610126,
                key: 610126
              }
            ]
          },
          {
            key: 610400,
            value: '咸阳市',
            id: 610400,
            children: [
              {
                value: '秦都区',
                id: 610402,
                key: 610402
              },
              {
                value: '杨陵区',
                id: 610403,
                key: 610403
              },
              {
                value: '渭城区',
                id: 610404,
                key: 610404
              },
              {
                value: '三原县',
                id: 610422,
                key: 610422
              },
              {
                value: '泾阳县',
                id: 610423,
                key: 610423
              },
              {
                value: '乾县',
                id: 610424,
                key: 610424
              },
              {
                value: '礼泉县',
                id: 610425,
                key: 610425
              },
              {
                value: '永寿县',
                id: 610426,
                key: 610426
              },
              {
                value: '彬州市',
                id: 610427,
                key: 610427
              },
              {
                value: '长武县',
                id: 610428,
                key: 610428
              },
              {
                value: '旬邑县',
                id: 610429,
                key: 610429
              },
              {
                value: '淳化县',
                id: 610430,
                key: 610430
              },
              {
                value: '武功县',
                id: 610431,
                key: 610431
              },
              {
                value: '兴平市',
                id: 610481,
                key: 610481
              }
            ]
          }
        ]
      },
      {
        key: 520000,
        value: '贵州省',
        id: 520000,
        children: [
          {
            key: 520400,
            value: '安顺市',
            id: 520400,
            children: [
              {
                value: '西秀区',
                id: 520402,
                key: 520402
              },
              {
                value: '平坝区',
                id: 520421,
                key: 520421
              },
              {
                value: '普定县',
                id: 520422,
                key: 520422
              },
              {
                value: '镇宁布依族苗族自治县',
                id: 520423,
                key: 520423
              },
              {
                value: '关岭布依族苗族自治县',
                id: 520424,
                key: 520424
              },
              {
                value: '紫云苗族布依族自治县',
                id: 520425,
                key: 520425
              }
            ]
          },
          {
            key: 520500,
            value: '毕节市',
            id: 520500,
            children: [
              {
                value: '七星关区',
                id: 520502,
                key: 520502
              },
              {
                value: '大方县',
                id: 520521,
                key: 520521
              },
              {
                value: '黔西县',
                id: 520522,
                key: 520522
              },
              {
                value: '金沙县',
                id: 520523,
                key: 520523
              },
              {
                value: '织金县',
                id: 520524,
                key: 520524
              },
              {
                value: '纳雍县',
                id: 520525,
                key: 520525
              },
              {
                value: '威宁彝族回族苗族自治县',
                id: 520526,
                key: 520526
              },
              {
                value: '赫章县',
                id: 520527,
                key: 520527
              }
            ]
          },
          {
            key: 520100,
            value: '贵阳市',
            id: 520100,
            children: [
              {
                value: '南明区',
                id: 520102,
                key: 520102
              },
              {
                value: '云岩区',
                id: 520103,
                key: 520103
              },
              {
                value: '花溪区',
                id: 520111,
                key: 520111
              },
              {
                value: '乌当区',
                id: 520112,
                key: 520112
              },
              {
                value: '白云区',
                id: 520113,
                key: 520113
              },
              {
                value: '观山湖区',
                id: 520115,
                key: 520115
              },
              {
                value: '开阳县',
                id: 520121,
                key: 520121
              },
              {
                value: '息烽县',
                id: 520122,
                key: 520122
              },
              {
                value: '修文县',
                id: 520123,
                key: 520123
              },
              {
                value: '清镇市',
                id: 520181,
                key: 520181
              }
            ]
          },
          {
            key: 520200,
            value: '六盘水市',
            id: 520200,
            children: [
              {
                value: '钟山区',
                id: 520201,
                key: 520201
              },
              {
                value: '六枝特区',
                id: 520203,
                key: 520203
              },
              {
                value: '水城县',
                id: 520221,
                key: 520221
              },
              {
                value: '盘州市',
                id: 520222,
                key: 520222
              }
            ]
          },
          {
            key: 522600,
            value: '黔东南苗族侗族自治州',
            id: 522600,
            children: [
              {
                value: '凯里市',
                id: 522601,
                key: 522601
              },
              {
                value: '黄平县',
                id: 522622,
                key: 522622
              },
              {
                value: '施秉县',
                id: 522623,
                key: 522623
              },
              {
                value: '三穗县',
                id: 522624,
                key: 522624
              },
              {
                value: '镇远县',
                id: 522625,
                key: 522625
              },
              {
                value: '岑巩县',
                id: 522626,
                key: 522626
              },
              {
                value: '天柱县',
                id: 522627,
                key: 522627
              },
              {
                value: '锦屏县',
                id: 522628,
                key: 522628
              },
              {
                value: '剑河县',
                id: 522629,
                key: 522629
              },
              {
                value: '台江县',
                id: 522630,
                key: 522630
              },
              {
                value: '黎平县',
                id: 522631,
                key: 522631
              },
              {
                value: '榕江县',
                id: 522632,
                key: 522632
              },
              {
                value: '从江县',
                id: 522633,
                key: 522633
              },
              {
                value: '雷山县',
                id: 522634,
                key: 522634
              },
              {
                value: '麻江县',
                id: 522635,
                key: 522635
              },
              {
                value: '丹寨县',
                id: 522636,
                key: 522636
              }
            ]
          },
          {
            key: 522700,
            value: '黔南布依族苗族自治州',
            id: 522700,
            children: [
              {
                value: '都匀市',
                id: 522701,
                key: 522701
              },
              {
                value: '福泉市',
                id: 522702,
                key: 522702
              },
              {
                value: '荔波县',
                id: 522722,
                key: 522722
              },
              {
                value: '贵定县',
                id: 522723,
                key: 522723
              },
              {
                value: '瓮安县',
                id: 522725,
                key: 522725
              },
              {
                value: '独山县',
                id: 522726,
                key: 522726
              },
              {
                value: '平塘县',
                id: 522727,
                key: 522727
              },
              {
                value: '罗甸县',
                id: 522728,
                key: 522728
              },
              {
                value: '长顺县',
                id: 522729,
                key: 522729
              },
              {
                value: '龙里县',
                id: 522730,
                key: 522730
              },
              {
                value: '惠水县',
                id: 522731,
                key: 522731
              },
              {
                value: '三都水族自治县',
                id: 522732,
                key: 522732
              }
            ]
          },
          {
            key: 522300,
            value: '黔西南布依族苗族自治州',
            id: 522300,
            children: [
              {
                value: '兴义市',
                id: 522301,
                key: 522301
              },
              {
                value: '兴仁县',
                id: 522322,
                key: 522322
              },
              {
                value: '普安县',
                id: 522323,
                key: 522323
              },
              {
                value: '晴隆县',
                id: 522324,
                key: 522324
              },
              {
                value: '贞丰县',
                id: 522325,
                key: 522325
              },
              {
                value: '望谟县',
                id: 522326,
                key: 522326
              },
              {
                value: '册亨县',
                id: 522327,
                key: 522327
              },
              {
                value: '安龙县',
                id: 522328,
                key: 522328
              }
            ]
          },
          {
            key: 520600,
            value: '铜仁市',
            id: 520600,
            children: [
              {
                value: '碧江区',
                id: 520602,
                key: 520602
              },
              {
                value: '万山区',
                id: 520603,
                key: 520603
              },
              {
                value: '江口县',
                id: 520621,
                key: 520621
              },
              {
                value: '玉屏侗族自治县',
                id: 520622,
                key: 520622
              },
              {
                value: '石阡县',
                id: 520623,
                key: 520623
              },
              {
                value: '思南县',
                id: 520624,
                key: 520624
              },
              {
                value: '印江土家族苗族自治县',
                id: 520625,
                key: 520625
              },
              {
                value: '德江县',
                id: 520626,
                key: 520626
              },
              {
                value: '沿河土家族自治县',
                id: 520627,
                key: 520627
              },
              {
                value: '松桃苗族自治县',
                id: 520628,
                key: 520628
              }
            ]
          },
          {
            key: 520300,
            value: '遵义市',
            id: 520300,
            children: [
              {
                value: '红花岗区',
                id: 520302,
                key: 520302
              },
              {
                value: '汇川区',
                id: 520303,
                key: 520303
              },
              {
                value: '播州区',
                id: 520321,
                key: 520321
              },
              {
                value: '桐梓县',
                id: 520322,
                key: 520322
              },
              {
                value: '绥阳县',
                id: 520323,
                key: 520323
              },
              {
                value: '正安县',
                id: 520324,
                key: 520324
              },
              {
                value: '道真仡佬族苗族自治县',
                id: 520325,
                key: 520325
              },
              {
                value: '务川仡佬族苗族自治县',
                id: 520326,
                key: 520326
              },
              {
                value: '凤冈县',
                id: 520327,
                key: 520327
              },
              {
                value: '湄潭县',
                id: 520328,
                key: 520328
              },
              {
                value: '余庆县',
                id: 520329,
                key: 520329
              },
              {
                value: '习水县',
                id: 520330,
                key: 520330
              },
              {
                value: '赤水市',
                id: 520381,
                key: 520381
              },
              {
                value: '仁怀市',
                id: 520382,
                key: 520382
              }
            ]
          }
        ]
      },
      {
        key: 810000,
        value: '香港特别行政区',
        id: 810000,
        children: [
          {
            key: 810101,
            value: '中西区',
            id: 810101
          },
          {
            key: 810102,
            value: '东区',
            id: 810102
          },
          {
            key: 810103,
            value: '九龙城区',
            id: 810103
          },
          {
            key: 810104,
            value: '观塘区',
            id: 810104
          },
          {
            key: 810105,
            value: '南区',
            id: 810105
          },
          {
            key: 810106,
            value: '深水埗区',
            id: 810106
          },
          {
            key: 810107,
            value: '湾仔区',
            id: 810107
          },
          {
            key: 810108,
            value: '黄大仙区',
            id: 810108
          },
          {
            key: 810109,
            value: '油尖旺区',
            id: 810109
          },
          {
            key: 810110,
            value: '离岛区',
            id: 810110
          },
          {
            key: 810111,
            value: '葵青区',
            id: 810111
          },
          {
            key: 810112,
            value: '北区',
            id: 810112
          },
          {
            key: 810113,
            value: '西贡区',
            id: 810113
          },
          {
            key: 810114,
            value: '沙田区',
            id: 810114
          },
          {
            key: 810115,
            value: '屯门区',
            id: 810115
          },
          {
            key: 810116,
            value: '大埔区',
            id: 810116
          },
          {
            key: 810117,
            value: '荃湾区',
            id: 810117
          },
          {
            key: 810118,
            value: '元朗区',
            id: 810118
          }
        ]
      },
      {
        key: 230000,
        value: '黑龙江省',
        id: 230000,
        children: [
          {
            key: 230700,
            value: '伊春市',
            id: 230700,
            children: [
              {
                value: '伊春区',
                id: 230702,
                key: 230702
              },
              {
                value: '南岔区',
                id: 230703,
                key: 230703
              },
              {
                value: '友好区',
                id: 230704,
                key: 230704
              },
              {
                value: '西林区',
                id: 230705,
                key: 230705
              },
              {
                value: '翠峦区',
                id: 230706,
                key: 230706
              },
              {
                value: '新青区',
                id: 230707,
                key: 230707
              },
              {
                value: '美溪区',
                id: 230708,
                key: 230708
              },
              {
                value: '金山屯区',
                id: 230709,
                key: 230709
              },
              {
                value: '五营区',
                id: 230710,
                key: 230710
              },
              {
                value: '乌马河区',
                id: 230711,
                key: 230711
              },
              {
                value: '汤旺河区',
                id: 230712,
                key: 230712
              },
              {
                value: '带岭区',
                id: 230713,
                key: 230713
              },
              {
                value: '乌伊岭区',
                id: 230714,
                key: 230714
              },
              {
                value: '红星区',
                id: 230715,
                key: 230715
              },
              {
                value: '上甘岭区',
                id: 230716,
                key: 230716
              },
              {
                value: '嘉荫县',
                id: 230722,
                key: 230722
              },
              {
                value: '铁力市',
                id: 230781,
                key: 230781
              }
            ]
          },
          {
            key: 230900,
            value: '七台河市',
            id: 230900,
            children: [
              {
                value: '新兴区',
                id: 230902,
                key: 230902
              },
              {
                value: '桃山区',
                id: 230903,
                key: 230903
              },
              {
                value: '茄子河区',
                id: 230904,
                key: 230904
              },
              {
                value: '勃利县',
                id: 230921,
                key: 230921
              }
            ]
          },
          {
            key: 230200,
            value: '齐齐哈尔市',
            id: 230200,
            children: [
              {
                value: '龙沙区',
                id: 230202,
                key: 230202
              },
              {
                value: '建华区',
                id: 230203,
                key: 230203
              },
              {
                value: '铁锋区',
                id: 230204,
                key: 230204
              },
              {
                value: '昂昂溪区',
                id: 230205,
                key: 230205
              },
              {
                value: '富拉尔基区',
                id: 230206,
                key: 230206
              },
              {
                value: '碾子山区',
                id: 230207,
                key: 230207
              },
              {
                value: '梅里斯达斡尔族区',
                id: 230208,
                key: 230208
              },
              {
                value: '龙江县',
                id: 230221,
                key: 230221
              },
              {
                value: '依安县',
                id: 230223,
                key: 230223
              },
              {
                value: '泰来县',
                id: 230224,
                key: 230224
              },
              {
                value: '甘南县',
                id: 230225,
                key: 230225
              },
              {
                value: '富裕县',
                id: 230227,
                key: 230227
              },
              {
                value: '克山县',
                id: 230229,
                key: 230229
              },
              {
                value: '克东县',
                id: 230230,
                key: 230230
              },
              {
                value: '拜泉县',
                id: 230231,
                key: 230231
              },
              {
                value: '讷河市',
                id: 230281,
                key: 230281
              }
            ]
          },
          {
            key: 230500,
            value: '双鸭山市',
            id: 230500,
            children: [
              {
                value: '尖山区',
                id: 230502,
                key: 230502
              },
              {
                value: '岭东区',
                id: 230503,
                key: 230503
              },
              {
                value: '四方台区',
                id: 230505,
                key: 230505
              },
              {
                value: '宝山区',
                id: 230506,
                key: 230506
              },
              {
                value: '集贤县',
                id: 230521,
                key: 230521
              },
              {
                value: '友谊县',
                id: 230522,
                key: 230522
              },
              {
                value: '宝清县',
                id: 230523,
                key: 230523
              },
              {
                value: '饶河县',
                id: 230524,
                key: 230524
              }
            ]
          },
          {
            key: 231200,
            value: '绥化市',
            id: 231200,
            children: [
              {
                value: '北林区',
                id: 231202,
                key: 231202
              },
              {
                value: '望奎县',
                id: 231221,
                key: 231221
              },
              {
                value: '兰西县',
                id: 231222,
                key: 231222
              },
              {
                value: '青冈县',
                id: 231223,
                key: 231223
              },
              {
                value: '庆安县',
                id: 231224,
                key: 231224
              },
              {
                value: '明水县',
                id: 231225,
                key: 231225
              },
              {
                value: '绥棱县',
                id: 231226,
                key: 231226
              },
              {
                value: '安达市',
                id: 231281,
                key: 231281
              },
              {
                value: '肇东市',
                id: 231282,
                key: 231282
              },
              {
                value: '海伦市',
                id: 231283,
                key: 231283
              }
            ]
          },
          {
            key: 230600,
            value: '大庆市',
            id: 230600,
            children: [
              {
                value: '萨尔图区',
                id: 230602,
                key: 230602
              },
              {
                value: '龙凤区',
                id: 230603,
                key: 230603
              },
              {
                value: '让胡路区',
                id: 230604,
                key: 230604
              },
              {
                value: '红岗区',
                id: 230605,
                key: 230605
              },
              {
                value: '大同区',
                id: 230606,
                key: 230606
              },
              {
                value: '肇州县',
                id: 230621,
                key: 230621
              },
              {
                value: '肇源县',
                id: 230622,
                key: 230622
              },
              {
                value: '林甸县',
                id: 230623,
                key: 230623
              },
              {
                value: '杜尔伯特蒙古族自治县',
                id: 230624,
                key: 230624
              }
            ]
          },
          {
            key: 232700,
            value: '大兴安岭地区',
            id: 232700,
            children: [
              {
                value: '呼玛县',
                id: 232721,
                key: 232721
              },
              {
                value: '塔河县',
                id: 232722,
                key: 232722
              },
              {
                value: '漠河县',
                id: 232723,
                key: 232723
              }
            ]
          },
          {
            key: 230100,
            value: '哈尔滨市',
            id: 230100,
            children: [
              {
                value: '道里区',
                id: 230102,
                key: 230102
              },
              {
                value: '南岗区',
                id: 230103,
                key: 230103
              },
              {
                value: '道外区',
                id: 230104,
                key: 230104
              },
              {
                value: '平房区',
                id: 230108,
                key: 230108
              },
              {
                value: '松北区',
                id: 230109,
                key: 230109
              },
              {
                value: '香坊区',
                id: 230110,
                key: 230110
              },
              {
                value: '呼兰区',
                id: 230111,
                key: 230111
              },
              {
                value: '阿城区',
                id: 230112,
                key: 230112
              },
              {
                value: '依兰县',
                id: 230123,
                key: 230123
              },
              {
                value: '方正县',
                id: 230124,
                key: 230124
              },
              {
                value: '宾县',
                id: 230125,
                key: 230125
              },
              {
                value: '巴彦县',
                id: 230126,
                key: 230126
              },
              {
                value: '木兰县',
                id: 230127,
                key: 230127
              },
              {
                value: '通河县',
                id: 230128,
                key: 230128
              },
              {
                value: '延寿县',
                id: 230129,
                key: 230129
              },
              {
                value: '双城区',
                id: 230182,
                key: 230182
              },
              {
                value: '尚志市',
                id: 230183,
                key: 230183
              },
              {
                value: '五常市',
                id: 230184,
                key: 230184
              }
            ]
          },
          {
            key: 230400,
            value: '鹤岗市',
            id: 230400,
            children: [
              {
                value: '向阳区',
                id: 230402,
                key: 230402
              },
              {
                value: '工农区',
                id: 230403,
                key: 230403
              },
              {
                value: '南山区',
                id: 230404,
                key: 230404
              },
              {
                value: '兴安区',
                id: 230405,
                key: 230405
              },
              {
                value: '东山区',
                id: 230406,
                key: 230406
              },
              {
                value: '兴山区',
                id: 230407,
                key: 230407
              },
              {
                value: '萝北县',
                id: 230421,
                key: 230421
              },
              {
                value: '绥滨县',
                id: 230422,
                key: 230422
              }
            ]
          },
          {
            key: 231100,
            value: '黑河市',
            id: 231100,
            children: [
              {
                value: '爱辉区',
                id: 231102,
                key: 231102
              },
              {
                value: '嫩江县',
                id: 231121,
                key: 231121
              },
              {
                value: '逊克县',
                id: 231123,
                key: 231123
              },
              {
                value: '孙吴县',
                id: 231124,
                key: 231124
              },
              {
                value: '北安市',
                id: 231181,
                key: 231181
              },
              {
                value: '五大连池市',
                id: 231182,
                key: 231182
              }
            ]
          },
          {
            key: 230300,
            value: '鸡西市',
            id: 230300,
            children: [
              {
                value: '鸡冠区',
                id: 230302,
                key: 230302
              },
              {
                value: '恒山区',
                id: 230303,
                key: 230303
              },
              {
                value: '滴道区',
                id: 230304,
                key: 230304
              },
              {
                value: '梨树区',
                id: 230305,
                key: 230305
              },
              {
                value: '城子河区',
                id: 230306,
                key: 230306
              },
              {
                value: '麻山区',
                id: 230307,
                key: 230307
              },
              {
                value: '鸡东县',
                id: 230321,
                key: 230321
              },
              {
                value: '虎林市',
                id: 230381,
                key: 230381
              },
              {
                value: '密山市',
                id: 230382,
                key: 230382
              }
            ]
          },
          {
            key: 230800,
            value: '佳木斯市',
            id: 230800,
            children: [
              {
                value: '向阳区',
                id: 230803,
                key: 230803
              },
              {
                value: '前进区',
                id: 230804,
                key: 230804
              },
              {
                value: '东风区',
                id: 230805,
                key: 230805
              },
              {
                value: '郊区',
                id: 230811,
                key: 230811
              },
              {
                value: '桦南县',
                id: 230822,
                key: 230822
              },
              {
                value: '桦川县',
                id: 230826,
                key: 230826
              },
              {
                value: '汤原县',
                id: 230828,
                key: 230828
              },
              {
                value: '抚远市',
                id: 230833,
                key: 230833
              },
              {
                value: '同江市',
                id: 230881,
                key: 230881
              },
              {
                value: '富锦市',
                id: 230882,
                key: 230882
              }
            ]
          },
          {
            key: 231000,
            value: '牡丹江市',
            id: 231000,
            children: [
              {
                value: '东安区',
                id: 231002,
                key: 231002
              },
              {
                value: '阳明区',
                id: 231003,
                key: 231003
              },
              {
                value: '爱民区',
                id: 231004,
                key: 231004
              },
              {
                value: '西安区',
                id: 231005,
                key: 231005
              },
              {
                value: '东宁市',
                id: 231024,
                key: 231024
              },
              {
                value: '林口县',
                id: 231025,
                key: 231025
              },
              {
                value: '绥芬河市',
                id: 231081,
                key: 231081
              },
              {
                value: '海林市',
                id: 231083,
                key: 231083
              },
              {
                value: '宁安市',
                id: 231084,
                key: 231084
              },
              {
                value: '穆棱市',
                id: 231085,
                key: 231085
              }
            ]
          }
        ]
      },
      {
        key: 460000,
        value: '海南省',
        id: 460000,
        children: [
          {
            key: 469025,
            value: '白沙黎族自治县',
            id: 469025
          },
          {
            key: 469029,
            value: '保亭黎族苗族自治县',
            id: 469029
          },
          {
            key: 469026,
            value: '昌江黎族自治县',
            id: 469026
          },
          {
            key: 469023,
            value: '澄迈县',
            id: 469023
          },
          {
            key: 469003,
            value: '儋州市',
            id: 469003
          },
          {
            key: 469021,
            value: '定安县',
            id: 469021
          },
          {
            key: 469007,
            value: '东方市',
            id: 469007
          },
          {
            key: 460100,
            value: '海口市',
            id: 460100,
            children: [
              {
                value: '秀英区',
                id: 460105,
                key: 460105
              },
              {
                value: '龙华区',
                id: 460106,
                key: 460106
              },
              {
                value: '琼山区',
                id: 460107,
                key: 460107
              },
              {
                value: '美兰区',
                id: 460108,
                key: 460108
              }
            ]
          },
          {
            key: 469024,
            value: '临高县',
            id: 469024
          },
          {
            key: 469028,
            value: '陵水黎族自治县',
            id: 469028
          },
          {
            key: 469002,
            value: '琼海市',
            id: 469002
          },
          {
            key: 460200,
            value: '三亚市',
            id: 460200,
            children: [
              {
                value: '海棠区',
                id: 460202,
                key: 460202
              },
              {
                value: '吉阳区',
                id: 460203,
                key: 460203
              },
              {
                value: '天涯区',
                id: 460204,
                key: 460204
              },
              {
                value: '崖州区',
                id: 460205,
                key: 460205
              }
            ]
          },
          {
            key: 469001,
            value: '五指山市',
            id: 469001
          },
          {
            key: 469006,
            value: '万宁市',
            id: 469006
          },
          {
            key: 469005,
            value: '文昌市',
            id: 469005
          },
          {
            key: 469022,
            value: '屯昌县',
            id: 469022
          },
          {
            key: 460300,
            value: '三沙市',
            id: 460300
          },
          {
            key: 469030,
            value: '琼中黎族苗族自治县',
            id: 469030
          },
          {
            key: 469027,
            value: '乐东黎族自治县',
            id: 469027
          }
        ]
      },
      {
        key: 440000,
        value: '广东省',
        id: 440000,
        children: [
          {
            key: 440400,
            value: '珠海市',
            id: 440400,
            children: [
              {
                value: '香洲区',
                id: 440402,
                key: 440402
              },
              {
                value: '斗门区',
                id: 440403,
                key: 440403
              },
              {
                value: '金湾区',
                id: 440404,
                key: 440404
              }
            ]
          },
          {
            key: 445300,
            value: '云浮市',
            id: 445300,
            children: [
              {
                value: '云城区',
                id: 445302,
                key: 445302
              },
              {
                value: '云安区',
                id: 445303,
                key: 445303
              },
              {
                value: '新兴县',
                id: 445321,
                key: 445321
              },
              {
                value: '郁南县',
                id: 445322,
                key: 445322
              },
              {
                value: '罗定市',
                id: 445381,
                key: 445381
              }
            ]
          },
          {
            key: 440800,
            value: '湛江市',
            id: 440800,
            children: [
              {
                value: '赤坎区',
                id: 440802,
                key: 440802
              },
              {
                value: '霞山区',
                id: 440803,
                key: 440803
              },
              {
                value: '坡头区',
                id: 440804,
                key: 440804
              },
              {
                value: '麻章区',
                id: 440811,
                key: 440811
              },
              {
                value: '遂溪县',
                id: 440823,
                key: 440823
              },
              {
                value: '徐闻县',
                id: 440825,
                key: 440825
              },
              {
                value: '廉江市',
                id: 440881,
                key: 440881
              },
              {
                value: '雷州市',
                id: 440882,
                key: 440882
              },
              {
                value: '吴川市',
                id: 440883,
                key: 440883
              }
            ]
          },
          {
            key: 441200,
            value: '肇庆市',
            id: 441200,
            children: [
              {
                value: '端州区',
                id: 441202,
                key: 441202
              },
              {
                value: '鼎湖区',
                id: 441203,
                key: 441203
              },
              {
                value: '广宁县',
                id: 441223,
                key: 441223
              },
              {
                value: '怀集县',
                id: 441224,
                key: 441224
              },
              {
                value: '封开县',
                id: 441225,
                key: 441225
              },
              {
                value: '德庆县',
                id: 441226,
                key: 441226
              },
              {
                value: '高要区',
                id: 441283,
                key: 441283
              },
              {
                value: '四会市',
                id: 441284,
                key: 441284
              }
            ]
          },
          {
            key: 442000,
            value: '中山市',
            id: 442000
          },
          {
            key: 440900,
            value: '茂名市',
            id: 440900,
            children: [
              {
                value: '茂南区',
                id: 440902,
                key: 440902
              },
              {
                value: '电白区',
                id: 440904,
                key: 440904
              },
              {
                value: '高州市',
                id: 440981,
                key: 440981
              },
              {
                value: '化州市',
                id: 440982,
                key: 440982
              },
              {
                value: '信宜市',
                id: 440983,
                key: 440983
              }
            ]
          },
          {
            key: 441400,
            value: '梅州市',
            id: 441400,
            children: [
              {
                value: '梅江区',
                id: 441402,
                key: 441402
              },
              {
                value: '梅县区',
                id: 441403,
                key: 441403
              },
              {
                value: '大埔县',
                id: 441422,
                key: 441422
              },
              {
                value: '丰顺县',
                id: 441423,
                key: 441423
              },
              {
                value: '五华县',
                id: 441424,
                key: 441424
              },
              {
                value: '平远县',
                id: 441426,
                key: 441426
              },
              {
                value: '蕉岭县',
                id: 441427,
                key: 441427
              },
              {
                value: '兴宁市',
                id: 441481,
                valkeyue: 441481
              }
            ]
          },
          {
            key: 441800,
            value: '清远市',
            id: 441800,
            children: [
              {
                value: '清城区',
                id: 441802,
                key: 441802
              },
              {
                value: '清新区',
                id: 441803,
                key: 441803
              },
              {
                value: '佛冈县',
                id: 441821,
                key: 441821
              },
              {
                value: '阳山县',
                id: 441823,
                key: 441823
              },
              {
                value: '连山壮族瑶族自治县',
                id: 441825,
                key: 441825
              },
              {
                value: '连南瑶族自治县',
                id: 441826,
                key: 441826
              },
              {
                value: '英德市',
                id: 441881,
                key: 441881
              },
              {
                value: '连州市',
                id: 441882,
                key: 441882
              }
            ]
          },
          {
            key: 440500,
            value: '汕头市',
            id: 440500,
            children: [
              {
                value: '龙湖区',
                id: 440507,
                key: 440507
              },
              {
                value: '金平区',
                id: 440511,
                key: 440511
              },
              {
                value: '濠江区',
                id: 440512,
                key: 440512
              },
              {
                value: '潮阳区',
                id: 440513,
                key: 440513
              },
              {
                value: '潮南区',
                id: 440514,
                key: 440514
              },
              {
                value: '澄海区',
                id: 440515,
                key: 440515
              },
              {
                value: '南澳县',
                id: 440523,
                key: 440523
              }
            ]
          },
          {
            key: 441500,
            value: '汕尾市',
            id: 441500,
            children: [
              {
                value: '城区',
                id: 441502,
                key: 441502
              },
              {
                value: '海丰县',
                id: 441521,
                key: 441521
              },
              {
                value: '陆河县',
                id: 441523,
                key: 441523
              },
              {
                value: '陆丰市',
                id: 441581,
                key: 441581
              }
            ]
          },
          {
            key: 440200,
            value: '韶关市',
            id: 440200,
            children: [
              {
                value: '武江区',
                id: 440203,
                key: 440203
              },
              {
                value: '浈江区',
                id: 440204,
                key: 440204
              },
              {
                value: '曲江区',
                id: 440205,
                key: 440205
              },
              {
                value: '始兴县',
                id: 440222,
                key: 440222
              },
              {
                value: '仁化县',
                id: 440224,
                key: 440224
              },
              {
                value: '翁源县',
                id: 440229,
                key: 440229
              },
              {
                value: '乳源瑶族自治县',
                id: 440232,
                key: 440232
              },
              {
                value: '新丰县',
                id: 440233,
                key: 440233
              },
              {
                value: '乐昌市',
                id: 440281,
                key: 440281
              },
              {
                value: '南雄市',
                id: 440282,
                key: 440282
              }
            ]
          },
          {
            key: 440300,
            value: '深圳市',
            id: 440300,
            children: [
              {
                value: '罗湖区',
                id: 440303,
                key: 440303
              },
              {
                value: '福田区',
                id: 440304,
                key: 440304
              },
              {
                value: '南山区',
                id: 440305,
                key: 440305
              },
              {
                value: '宝安区',
                id: 440306,
                key: 440306
              },
              {
                value: '龙岗区',
                id: 440307,
                key: 440307
              },
              {
                value: '盐田区',
                id: 440308,
                key: 440308
              },
              {
                value: '龙华区',
                id: 440309,
                key: 440309
              },
              {
                value: '坪山区',
                id: 440310,
                key: 440310
              }
            ]
          },
          {
            key: 441700,
            value: '阳江市',
            id: 441700,
            children: [
              {
                value: '江城区',
                id: 441702,
                key: 441702
              },
              {
                value: '阳西县',
                id: 441721,
                key: 441721
              },
              {
                value: '阳东区',
                id: 441723,
                key: 441723
              },
              {
                value: '阳春市',
                id: 441781,
                key: 441781
              }
            ]
          },
          {
            key: 445100,
            value: '潮州市',
            id: 445100,
            children: [
              {
                value: '湘桥区',
                id: 445102,
                key: 445102
              },
              {
                value: '潮安区',
                id: 445121,
                key: 445121
              },
              {
                value: '饶平县',
                id: 445122,
                key: 445122
              }
            ]
          },
          {
            key: 441900,
            value: '东莞市',
            id: 441900
          },
          {
            key: 440600,
            value: '佛山市',
            id: 440600,
            children: [
              {
                value: '禅城区',
                id: 440604,
                key: 440604
              },
              {
                value: '南海区',
                id: 440605,
                key: 440605
              },
              {
                value: '顺德区',
                id: 440606,
                key: 440606
              },
              {
                value: '三水区',
                id: 440607,
                key: 440607
              },
              {
                value: '高明区',
                id: 440608,
                key: 440608
              }
            ]
          },
          {
            key: 440100,
            value: '广州市',
            id: 440100,
            children: [
              {
                value: '荔湾区',
                id: 440103,
                key: 440103
              },
              {
                value: '越秀区',
                id: 440104,
                key: 440104
              },
              {
                value: '海珠区',
                id: 440105,
                key: 440105
              },
              {
                value: '天河区',
                id: 440106,
                key: 440106
              },
              {
                value: '白云区',
                id: 440111,
                key: 440111
              },
              {
                value: '黄埔区',
                id: 440112,
                key: 440112
              },
              {
                value: '番禺区',
                id: 440113,
                key: 440113
              },
              {
                value: '花都区',
                id: 440114,
                key: 440114
              },
              {
                value: '南沙区',
                id: 440115,
                key: 440115
              },
              {
                value: '增城区',
                id: 440183,
                key: 440183
              },
              {
                value: '从化区',
                id: 440184,
                key: 440184
              }
            ]
          },
          {
            key: 441600,
            value: '河源市',
            id: 441600,
            children: [
              {
                value: '源城区',
                id: 441602,
                key: 441602
              },
              {
                value: '紫金县',
                id: 441621,
                key: 441621
              },
              {
                value: '龙川县',
                id: 441622,
                key: 441622
              },
              {
                value: '连平县',
                id: 441623,
                key: 441623
              },
              {
                value: '和平县',
                id: 441624,
                key: 441624
              },
              {
                value: '东源县',
                id: 441625,
                key: 441625
              }
            ]
          },
          {
            key: 441300,
            value: '惠州市',
            id: 441300,
            children: [
              {
                value: '惠城区',
                id: 441302,
                key: 441302
              },
              {
                value: '惠阳区',
                id: 441303,
                key: 441303
              },
              {
                value: '博罗县',
                id: 441322,
                key: 441322
              },
              {
                value: '惠东县',
                id: 441323,
                key: 441323
              },
              {
                value: '龙门县',
                id: 441324,
                key: 441324
              }
            ]
          },
          {
            key: 440700,
            value: '江门市',
            id: 440700,
            children: [
              {
                value: '蓬江区',
                id: 440703,
                key: 440703
              },
              {
                value: '江海区',
                id: 440704,
                key: 440704
              },
              {
                value: '新会区',
                id: 440705,
                key: 440705
              },
              {
                value: '台山市',
                id: 440781,
                key: 440781
              },
              {
                value: '开平市',
                id: 440783,
                key: 440783
              },
              {
                value: '鹤山市',
                id: 440784,
                key: 440784
              },
              {
                value: '恩平市',
                id: 440785,
                key: 440785
              }
            ]
          },
          {
            key: 445200,
            value: '揭阳市',
            id: 445200,
            children: [
              {
                value: '榕城区',
                id: 445202,
                key: 445202
              },
              {
                value: '揭东区',
                id: 445203,
                key: 445203
              },
              {
                value: '揭西县',
                id: 445222,
                key: 445222
              },
              {
                value: '惠来县',
                id: 445224,
                key: 445224
              },
              {
                value: '普宁市',
                id: 445281,
                key: 445281
              }
            ]
          }
        ]
      },
      {
        key: 500000,
        value: '重庆市',
        id: 500000,
        children: [
          {
            key: 500101,
            value: '万州区',
            id: 500101
          },
          {
            key: 500102,
            value: '涪陵区',
            id: 500102
          },
          {
            key: 500103,
            value: '渝中区',
            id: 500103
          },
          {
            key: 500104,
            value: '大渡口区',
            id: 500104
          },
          {
            key: 500105,
            value: '江北区',
            id: 500105
          },
          {
            key: 500106,
            value: '沙坪坝区',
            id: 500106
          },
          {
            key: 500107,
            value: '九龙坡区',
            id: 500107
          },
          {
            key: 500108,
            value: '南岸区',
            id: 500108
          },
          {
            key: 500109,
            value: '北碚区',
            id: 500109
          },
          {
            key: 500110,
            value: '綦江区',
            id: 500110
          },
          {
            key: 500111,
            value: '大足区',
            id: 500111
          },
          {
            key: 500112,
            value: '渝北区',
            id: 500112
          },
          {
            key: 500113,
            value: '巴南区',
            id: 500113
          },
          {
            key: 500114,
            value: '黔江区',
            id: 500114
          },
          {
            key: 500115,
            value: '长寿区',
            id: 500115
          },
          {
            key: 500116,
            value: '江津区',
            id: 500116
          },
          {
            key: 500117,
            value: '合川区',
            id: 500117
          },
          {
            key: 500118,
            value: '永川区',
            id: 500118
          },
          {
            key: 500119,
            value: '南川区',
            id: 500119
          },
          {
            key: 500120,
            value: '璧山区',
            id: 500120
          },
          {
            key: 500151,
            value: '铜梁区',
            id: 500151
          },
          {
            key: 500223,
            value: '潼南区',
            id: 500223
          },
          {
            key: 500226,
            value: '荣昌区',
            id: 500226
          },
          {
            key: 500228,
            value: '梁平区',
            id: 500228
          },
          {
            key: 500229,
            value: '城口县',
            id: 500229
          },
          {
            key: 500230,
            value: '丰都县',
            id: 500230
          },
          {
            key: 500231,
            value: '垫江县',
            id: 500231
          },
          {
            key: 500232,
            value: '武隆区',
            id: 500232
          },
          {
            key: 500233,
            value: '忠县',
            id: 500233
          },
          {
            key: 500234,
            value: '开州区',
            id: 500234
          },
          {
            key: 500235,
            value: '云阳县',
            id: 500235
          },
          {
            key: 500236,
            value: '奉节县',
            id: 500236
          },
          {
            key: 500237,
            value: '巫山县',
            id: 500237
          },
          {
            key: 500238,
            value: '巫溪县',
            id: 500238
          },
          {
            key: 500240,
            value: '石柱土家族自治县',
            id: 500240
          },
          {
            key: 500241,
            value: '秀山土家族苗族自治县',
            id: 500241
          },
          {
            key: 500242,
            value: '酉阳土家族苗族自治县',
            id: 500242
          },
          {
            key: 500243,
            value: '彭水苗族土家族自治县',
            id: 500243
          }
        ]
      },
      {
        key: 410000,
        value: '河南省',
        id: 410000,
        children: [
          {
            key: 410500,
            value: '安阳市',
            id: 410500,
            children: [
              {
                value: '文峰区',
                id: 410502,
                key: 410502
              },
              {
                value: '北关区',
                id: 410503,
                key: 410503
              },
              {
                value: '殷都区',
                id: 410505,
                key: 410505
              },
              {
                value: '龙安区',
                id: 410506,
                key: 410506
              },
              {
                value: '安阳县',
                id: 410522,
                key: 410522
              },
              {
                value: '汤阴县',
                id: 410523,
                key: 410523
              },
              {
                value: '滑县',
                id: 410526,
                key: 410526
              },
              {
                value: '内黄县',
                id: 410527,
                key: 410527
              },
              {
                value: '林州市',
                id: 410581,
                key: 410581
              }
            ]
          },
          {
            key: 410600,
            value: '鹤壁市',
            id: 410600,
            children: [
              {
                value: '鹤山区',
                id: 410602,
                key: 410602
              },
              {
                value: '山城区',
                id: 410603,
                key: 410603
              },
              {
                value: '淇滨区',
                id: 410611,
                key: 410611
              },
              {
                value: '浚县',
                id: 410621,
                key: 410621
              },
              {
                value: '淇县',
                id: 410622,
                key: 410622
              }
            ]
          },
          {
            key: 419001,
            value: '济源市',
            id: 419001
          },
          {
            key: 410800,
            value: '焦作市',
            id: 410800,
            children: [
              {
                value: '解放区',
                id: 410802,
                key: 410802
              },
              {
                value: '中站区',
                id: 410803,
                key: 410803
              },
              {
                value: '马村区',
                id: 410804,
                key: 410804
              },
              {
                value: '山阳区',
                id: 410811,
                key: 410811
              },
              {
                value: '修武县',
                id: 410821,
                key: 410821
              },
              {
                value: '博爱县',
                id: 410822,
                key: 410822
              },
              {
                value: '武陟县',
                id: 410823,
                key: 410823
              },
              {
                value: '温县',
                id: 410825,
                key: 410825
              },
              {
                value: '沁阳市',
                id: 410882,
                key: 410882
              },
              {
                value: '孟州市',
                id: 410883,
                key: 410883
              }
            ]
          },
          {
            key: 410200,
            value: '开封市',
            id: 410200,
            children: [
              {
                value: '龙亭区',
                id: 410202,
                key: 410202
              },
              {
                value: '顺河回族区',
                id: 410203,
                key: 410203
              },
              {
                value: '鼓楼区',
                id: 410204,
                key: 410204
              },
              {
                value: '禹王台区',
                id: 410205,
                key: 410205
              },
              {
                value: '祥符区',
                id: 410212,
                key: 410212
              },
              {
                value: '杞县',
                id: 410221,
                key: 410221
              },
              {
                value: '通许县',
                id: 410222,
                key: 410222
              },
              {
                value: '尉氏县',
                id: 410223,
                key: 410223
              },
              {
                value: '兰考县',
                id: 410225,
                key: 410225
              }
            ]
          },
          {
            key: 410300,
            value: '洛阳市',
            id: 410300,
            children: [
              {
                value: '老城区',
                id: 410302,
                key: 410302
              },
              {
                value: '西工区',
                id: 410303,
                key: 410303
              },
              {
                value: '瀍河回族区',
                id: 410304,
                key: 410304
              },
              {
                value: '涧西区',
                id: 410305,
                key: 410305
              },
              {
                value: '吉利区',
                id: 410306,
                key: 410306
              },
              {
                value: '洛龙区',
                id: 410311,
                key: 410311
              },
              {
                value: '孟津县',
                id: 410322,
                key: 410322
              },
              {
                value: '新安县',
                id: 410323,
                key: 410323
              },
              {
                value: '栾川县',
                id: 410324,
                key: 410324
              },
              {
                value: '嵩县',
                id: 410325,
                key: 410325
              },
              {
                value: '汝阳县',
                id: 410326,
                key: 410326
              },
              {
                value: '宜阳县',
                id: 410327,
                key: 410327
              },
              {
                value: '洛宁县',
                id: 410328,
                key: 410328
              },
              {
                value: '伊川县',
                id: 410329,
                key: 410329
              },
              {
                value: '偃师市',
                id: 410381,
                key: 410381
              }
            ]
          },
          {
            key: 411100,
            value: '漯河市',
            id: 411100,
            children: [
              {
                value: '源汇区',
                id: 411102,
                key: 411102
              },
              {
                value: '郾城区',
                id: 411103,
                key: 411103
              },
              {
                value: '召陵区',
                id: 411104,
                key: 411104
              },
              {
                value: '舞阳县',
                id: 411121,
                key: 411121
              },
              {
                value: '临颍县',
                id: 411122,
                key: 411122
              }
            ]
          },
          {
            key: 411300,
            value: '南阳市',
            id: 411300,
            children: [
              {
                value: '宛城区',
                id: 411302,
                key: 411302
              },
              {
                value: '卧龙区',
                id: 411303,
                key: 411303
              },
              {
                value: '南召县',
                id: 411321,
                key: 411321
              },
              {
                value: '方城县',
                id: 411322,
                key: 411322
              },
              {
                value: '西峡县',
                id: 411323,
                key: 411323
              },
              {
                value: '镇平县',
                id: 411324,
                key: 411324
              },
              {
                value: '内乡县',
                id: 411325,
                key: 411325
              },
              {
                value: '淅川县',
                id: 411326,
                key: 411326
              },
              {
                value: '社旗县',
                id: 411327,
                key: 411327
              },
              {
                value: '唐河县',
                id: 411328,
                key: 411328
              },
              {
                value: '新野县',
                id: 411329,
                key: 411329
              },
              {
                value: '桐柏县',
                id: 411330,
                key: 411330
              },
              {
                value: '邓州市',
                id: 411381,
                key: 411381
              }
            ]
          },
          {
            key: 410400,
            value: '平顶山市',
            id: 410400,
            children: [
              {
                value: '新华区',
                id: 410402,
                key: 410402
              },
              {
                value: '卫东区',
                id: 410403,
                key: 410403
              },
              {
                value: '石龙区',
                id: 410404,
                key: 410404
              },
              {
                value: '湛河区',
                id: 410411,
                key: 410411
              },
              {
                value: '宝丰县',
                id: 410421,
                key: 410421
              },
              {
                value: '叶县',
                id: 410422,
                key: 410422
              },
              {
                value: '鲁山县',
                id: 410423,
                key: 410423
              },
              {
                value: '郏县',
                id: 410425,
                key: 410425
              },
              {
                value: '舞钢市',
                id: 410481,
                key: 410481
              },
              {
                value: '汝州市',
                id: 410482,
                key: 410482
              }
            ]
          },
          {
            key: 410900,
            value: '濮阳市',
            id: 410900,
            children: [
              {
                value: '华龙区',
                id: 410902,
                key: 410902
              },
              {
                value: '清丰县',
                id: 410922,
                key: 410922
              },
              {
                value: '南乐县',
                id: 410923,
                key: 410923
              },
              {
                value: '范县',
                id: 410926,
                key: 410926
              },
              {
                value: '台前县',
                id: 410927,
                key: 410927
              },
              {
                value: '濮阳县',
                id: 410928,
                key: 410928
              }
            ]
          },
          {
            key: 411200,
            value: '三门峡市',
            id: 411200,
            children: [
              {
                value: '湖滨区',
                id: 411202,
                key: 411202
              },
              {
                value: '渑池县',
                id: 411221,
                key: 411221
              },
              {
                value: '陕州区',
                id: 411222,
                key: 411222
              },
              {
                value: '卢氏县',
                id: 411224,
                key: 411224
              },
              {
                value: '义马市',
                id: 411281,
                key: 411281
              },
              {
                value: '灵宝市',
                id: 411282,
                key: 411282
              }
            ]
          },
          {
            key: 411400,
            value: '商丘市',
            id: 411400,
            children: [
              {
                value: '梁园区',
                id: 411402,
                key: 411402
              },
              {
                value: '睢阳区',
                id: 411403,
                key: 411403
              },
              {
                value: '民权县',
                id: 411421,
                key: 411421
              },
              {
                value: '睢县',
                id: 411422,
                key: 411422
              },
              {
                value: '宁陵县',
                id: 411423,
                key: 411423
              },
              {
                value: '柘城县',
                id: 411424,
                key: 411424
              },
              {
                value: '虞城县',
                id: 411425,
                key: 411425
              },
              {
                value: '夏邑县',
                id: 411426,
                key: 411426
              },
              {
                value: '永城市',
                id: 411481,
                key: 411481
              }
            ]
          },
          {
            key: 410700,
            value: '新乡市',
            id: 410700,
            children: [
              {
                value: '红旗区',
                id: 410702,
                key: 410702
              },
              {
                value: '卫滨区',
                id: 410703,
                key: 410703
              },
              {
                value: '凤泉区',
                id: 410704,
                key: 410704
              },
              {
                value: '牧野区',
                id: 410711,
                key: 410711
              },
              {
                value: '新乡县',
                id: 410721,
                key: 410721
              },
              {
                value: '获嘉县',
                id: 410724,
                key: 410724
              },
              {
                value: '原阳县',
                id: 410725,
                key: 410725
              },
              {
                value: '延津县',
                id: 410726,
                key: 410726
              },
              {
                value: '封丘县',
                id: 410727,
                key: 410727
              },
              {
                value: '长垣县',
                id: 410728,
                key: 410728
              },
              {
                value: '卫辉市',
                id: 410781,
                key: 410781
              },
              {
                value: '辉县市',
                id: 410782,
                key: 410782
              }
            ]
          },
          {
            key: 411500,
            value: '信阳市',
            id: 411500,
            children: [
              {
                value: '浉河区',
                id: 411502,
                key: 411502
              },
              {
                value: '平桥区',
                id: 411503,
                key: 411503
              },
              {
                value: '罗山县',
                id: 411521,
                key: 411521
              },
              {
                value: '光山县',
                id: 411522,
                key: 411522
              },
              {
                value: '新县',
                id: 411523,
                key: 411523
              },
              {
                value: '商城县',
                id: 411524,
                key: 411524
              },
              {
                value: '固始县',
                id: 411525,
                key: 411525
              },
              {
                value: '潢川县',
                id: 411526,
                key: 411526
              },
              {
                value: '淮滨县',
                id: 411527,
                key: 411527
              },
              {
                value: '息县',
                id: 411528,
                key: 411528
              }
            ]
          },
          {
            key: 411000,
            value: '许昌市',
            id: 411000,
            children: [
              {
                value: '魏都区',
                id: 411002,
                key: 411002
              },
              {
                value: '建安区',
                id: 411023,
                key: 411023
              },
              {
                value: '鄢陵县',
                id: 411024,
                key: 411024
              },
              {
                value: '襄城县',
                id: 411025,
                key: 411025
              },
              {
                value: '禹州市',
                id: 411081,
                key: 411081
              },
              {
                value: '长葛市',
                id: 411082,
                key: 411082
              }
            ]
          },
          {
            key: 410100,
            value: '郑州市',
            id: 410100,
            children: [
              {
                value: '中原区',
                id: 410102,
                key: 410102
              },
              {
                value: '二七区',
                id: 410103,
                key: 410103
              },
              {
                value: '管城回族区',
                id: 410104,
                key: 410104
              },
              {
                value: '金水区',
                id: 410105,
                key: 410105
              },
              {
                value: '上街区',
                id: 410106,
                key: 410106
              },
              {
                value: '惠济区',
                id: 410108,
                key: 410108
              },
              {
                value: '中牟县',
                id: 410122,
                key: 410122
              },
              {
                value: '巩义市',
                id: 410181,
                key: 410181
              },
              {
                value: '荥阳市',
                id: 410182,
                key: 410182
              },
              {
                value: '新密市',
                id: 410183,
                key: 410183
              },
              {
                value: '新郑市',
                id: 410184,
                key: 410184
              },
              {
                value: '登封市',
                id: 410185,
                key: 410185
              }
            ]
          },
          {
            key: 411600,
            value: '周口市',
            id: 411600,
            children: [
              {
                value: '川汇区',
                id: 411602,
                key: 411602
              },
              {
                value: '扶沟县',
                id: 411621,
                key: 411621
              },
              {
                value: '西华县',
                id: 411622,
                key: 411622
              },
              {
                value: '商水县',
                id: 411623,
                key: 411623
              },
              {
                value: '沈丘县',
                id: 411624,
                key: 411624
              },
              {
                value: '郸城县',
                id: 411625,
                key: 411625
              },
              {
                value: '淮阳县',
                id: 411626,
                key: 411626
              },
              {
                value: '太康县',
                id: 411627,
                key: 411627
              },
              {
                value: '鹿邑县',
                id: 411628,
                key: 411628
              },
              {
                value: '项城市',
                id: 411681,
                key: 411681
              }
            ]
          },
          {
            key: 411700,
            value: '驻马店市',
            id: 411700,
            children: [
              {
                value: '驿城区',
                id: 411702,
                key: 411702
              },
              {
                value: '西平县',
                id: 411721,
                key: 411721
              },
              {
                value: '上蔡县',
                id: 411722,
                key: 411722
              },
              {
                value: '平舆县',
                id: 411723,
                key: 411723
              },
              {
                value: '正阳县',
                id: 411724,
                key: 411724
              },
              {
                value: '确山县',
                id: 411725,
                key: 411725
              },
              {
                value: '泌阳县',
                id: 411726,
                key: 411726
              },
              {
                value: '汝南县',
                id: 411727,
                key: 411727
              },
              {
                value: '遂平县',
                id: 411728,
                key: 411728
              },
              {
                value: '新蔡县',
                id: 411729,
                key: 411729
              }
            ]
          }
        ]
      },
      {
        key: 620000,
        value: '甘肃省',
        id: 620000,
        children: [
          {
            key: 620100,
            value: '兰州市',
            id: 620100,
            children: [
              {
                value: '城关区',
                id: 620102,
                key: 620102
              },
              {
                value: '七里河区',
                id: 620103,
                key: 620103
              },
              {
                value: '西固区',
                id: 620104,
                key: 620104
              },
              {
                value: '安宁区',
                id: 620105,
                key: 620105
              },
              {
                value: '红古区',
                id: 620111,
                key: 620111
              },
              {
                value: '永登县',
                id: 620121,
                key: 620121
              },
              {
                value: '皋兰县',
                id: 620122,
                key: 620122
              },
              {
                value: '榆中县',
                id: 620123,
                key: 620123
              }
            ]
          },
          {
            key: 622900,
            value: '临夏回族自治州',
            id: 622900,
            children: [
              {
                value: '临夏市',
                id: 622901,
                key: 622901
              },
              {
                value: '临夏县',
                id: 622921,
                key: 622921
              },
              {
                value: '康乐县',
                id: 622922,
                key: 622922
              },
              {
                value: '永靖县',
                id: 622923,
                key: 622923
              },
              {
                value: '广河县',
                id: 622924,
                key: 622924
              },
              {
                value: '和政县',
                id: 622925,
                key: 622925
              },
              {
                value: '东乡族自治县',
                id: 622926,
                key: 622926
              },
              {
                value: '积石山县',
                id: 622927,
                key: 622927
              }
            ]
          },
          {
            key: 621200,
            value: '陇南市',
            id: 621200,
            children: [
              {
                value: '武都区',
                id: 621202,
                key: 621202
              },
              {
                value: '成县',
                id: 621221,
                key: 621221
              },
              {
                value: '文县',
                id: 621222,
                key: 621222
              },
              {
                value: '宕昌县',
                id: 621223,
                key: 621223
              },
              {
                value: '康县',
                id: 621224,
                key: 621224
              },
              {
                value: '西和县',
                id: 621225,
                key: 621225
              },
              {
                value: '礼县',
                id: 621226,
                key: 621226
              },
              {
                value: '徽县',
                id: 621227,
                key: 621227
              },
              {
                value: '两当县',
                id: 621228,
                key: 621228
              }
            ]
          },
          {
            key: 620800,
            value: '平凉市',
            id: 620800,
            children: [
              {
                value: '崆峒区',
                id: 620802,
                key: 620802
              },
              {
                value: '泾川县',
                id: 620821,
                key: 620821
              },
              {
                value: '灵台县',
                id: 620822,
                key: 620822
              },
              {
                value: '崇信县',
                id: 620823,
                key: 620823
              },
              {
                value: '华亭县',
                id: 620824,
                key: 620824
              },
              {
                value: '庄浪县',
                id: 620825,
                key: 620825
              },
              {
                value: '静宁县',
                id: 620826,
                key: 620826
              }
            ]
          },
          {
            key: 621000,
            value: '庆阳市',
            id: 621000,
            children: [
              {
                value: '西峰区',
                id: 621002,
                key: 621002
              },
              {
                value: '庆城县',
                id: 621021,
                key: 621021
              },
              {
                value: '环县',
                id: 621022,
                key: 621022
              },
              {
                value: '华池县',
                id: 621023,
                key: 621023
              },
              {
                value: '合水县',
                id: 621024,
                key: 621024
              },
              {
                value: '正宁县',
                id: 621025,
                key: 621025
              },
              {
                value: '宁县',
                id: 621026,
                key: 621026
              },
              {
                value: '镇原县',
                id: 621027,
                key: 621027
              }
            ]
          },
          {
            key: 620500,
            value: '天水市',
            id: 620500,
            children: [
              {
                value: '秦州区',
                id: 620502,
                key: 620502
              },
              {
                value: '麦积区',
                id: 620503,
                key: 620503
              },
              {
                value: '清水县',
                id: 620521,
                key: 620521
              },
              {
                value: '秦安县',
                id: 620522,
                key: 620522
              },
              {
                value: '甘谷县',
                id: 620523,
                key: 620523
              },
              {
                value: '武山县',
                id: 620524,
                key: 620524
              },
              {
                value: '张家川回族自治县',
                id: 620525,
                key: 620525
              }
            ]
          },
          {
            key: 620600,
            value: '武威市',
            id: 620600,
            children: [
              {
                value: '凉州区',
                id: 620602,
                key: 620602
              },
              {
                value: '民勤县',
                id: 620621,
                key: 620621
              },
              {
                value: '古浪县',
                id: 620622,
                key: 620622
              },
              {
                value: '天祝藏族自治县',
                id: 620623,
                key: 620623
              }
            ]
          },
          {
            key: 620700,
            value: '张掖市',
            id: 620700,
            children: [
              {
                value: '甘州区',
                id: 620702,
                key: 620702
              },
              {
                value: '肃南裕固族自治县',
                id: 620721,
                key: 620721
              },
              {
                value: '民乐县',
                id: 620722,
                key: 620722
              },
              {
                value: '临泽县',
                id: 620723,
                key: 620723
              },
              {
                value: '高台县',
                id: 620724,
                key: 620724
              },
              {
                value: '山丹县',
                id: 620725,
                key: 620725
              }
            ]
          },
          {
            key: 620400,
            value: '白银市',
            id: 620400,
            children: [
              {
                value: '白银区',
                id: 620402,
                key: 620402
              },
              {
                value: '平川区',
                id: 620403,
                key: 620403
              },
              {
                value: '靖远县',
                id: 620421,
                key: 620421
              },
              {
                value: '会宁县',
                id: 620422,
                key: 620422
              },
              {
                value: '景泰县',
                id: 620423,
                key: 620423
              }
            ]
          },
          {
            key: 621100,
            value: '定西市',
            id: 621100,
            children: [
              {
                value: '安定区',
                id: 621102,
                key: 621102
              },
              {
                value: '通渭县',
                id: 621121,
                key: 621121
              },
              {
                value: '陇西县',
                id: 621122,
                key: 621122
              },
              {
                value: '渭源县',
                id: 621123,
                key: 621123
              },
              {
                value: '临洮县',
                id: 621124,
                key: 621124
              },
              {
                value: '漳县',
                id: 621125,
                key: 621125
              },
              {
                value: '岷县',
                id: 621126,
                key: 621126
              }
            ]
          },
          {
            key: 623000,
            value: '甘南藏族自治州',
            id: 623000,
            children: [
              {
                value: '合作市',
                id: 623001,
                key: 623001
              },
              {
                value: '临潭县',
                id: 623021,
                key: 623021
              },
              {
                value: '卓尼县',
                id: 623022,
                key: 623022
              },
              {
                value: '舟曲县',
                id: 623023,
                key: 623023
              },
              {
                value: '迭部县',
                id: 623024,
                key: 623024
              },
              {
                value: '玛曲县',
                id: 623025,
                key: 623025
              },
              {
                value: '碌曲县',
                id: 623026,
                key: 623026
              },
              {
                value: '夏河县',
                id: 623027,
                key: 623027
              }
            ]
          },
          {
            key: 620200,
            value: '嘉峪关市',
            id: 620200
          },
          {
            key: 620300,
            value: '金昌市',
            id: 620300,
            children: [
              {
                value: '金川区',
                id: 620302,
                key: 620302
              },
              {
                value: '永昌县',
                id: 620321,
                key: 620321
              }
            ]
          },
          {
            key: 620900,
            value: '酒泉市',
            id: 620900,
            children: [
              {
                value: '肃州区',
                id: 620902,
                key: 620902
              },
              {
                value: '金塔县',
                id: 620921,
                key: 620921
              },
              {
                value: '瓜州县',
                id: 620922,
                key: 620922
              },
              {
                value: '肃北蒙古族自治县',
                id: 620923,
                key: 620923
              },
              {
                value: '阿克塞哈萨克族自治县',
                id: 620924,
                key: 620924
              },
              {
                value: '玉门市',
                id: 620981,
                key: 620981
              },
              {
                value: '敦煌市',
                id: 620982,
                key: 620982
              }
            ]
          }
        ]
      },
      {
        key: 430000,
        value: '湖南省',
        id: 430000,
        children: [
          {
            key: 430100,
            value: '长沙市',
            id: 430100,
            children: [
              {
                value: '芙蓉区',
                id: 430102,
                key: 430102
              },
              {
                value: '天心区',
                id: 430103,
                key: 430103
              },
              {
                value: '岳麓区',
                id: 430104,
                key: 430104
              },
              {
                value: '开福区',
                id: 430105,
                key: 430105
              },
              {
                value: '雨花区',
                id: 430111,
                key: 430111
              },
              {
                value: '望城区',
                id: 430112,
                key: 430112
              },
              {
                value: '长沙县',
                id: 430121,
                key: 430121
              },
              {
                value: '宁乡市',
                id: 430124,
                key: 430124
              },
              {
                value: '浏阳市',
                id: 430181,
                key: 430181
              }
            ]
          },
          {
            key: 430700,
            value: '常德市',
            id: 430700,
            children: [
              {
                value: '武陵区',
                id: 430702,
                key: 430702
              },
              {
                value: '鼎城区',
                id: 430703,
                key: 430703
              },
              {
                value: '安乡县',
                id: 430721,
                key: 430721
              },
              {
                value: '汉寿县',
                id: 430722,
                key: 430722
              },
              {
                value: '澧县',
                id: 430723,
                key: 430723
              },
              {
                value: '临澧县',
                id: 430724,
                key: 430724
              },
              {
                value: '桃源县',
                id: 430725,
                key: 430725
              },
              {
                value: '石门县',
                id: 430726,
                key: 430726
              },
              {
                value: '津市市',
                id: 430781,
                key: 430781
              }
            ]
          },
          {
            key: 431100,
            value: '永州市',
            id: 431100,
            children: [
              {
                value: '零陵区',
                id: 431102,
                key: 431102
              },
              {
                value: '冷水滩区',
                id: 431103,
                key: 431103
              },
              {
                value: '祁阳县',
                id: 431121,
                key: 431121
              },
              {
                value: '东安县',
                id: 431122,
                key: 431122
              },
              {
                value: '双牌县',
                id: 431123,
                key: 431123
              },
              {
                value: '道县',
                id: 431124,
                key: 431124
              },
              {
                value: '江永县',
                id: 431125,
                key: 431125
              },
              {
                value: '宁远县',
                id: 431126,
                key: 431126
              },
              {
                value: '蓝山县',
                id: 431127,
                key: 431127
              },
              {
                value: '新田县',
                id: 431128,
                key: 431128
              },
              {
                value: '江华瑶族自治县',
                id: 431129,
                key: 431129
              }
            ]
          },
          {
            key: 430600,
            value: '岳阳市',
            id: 430600,
            children: [
              {
                value: '岳阳楼区',
                id: 430602,
                key: 430602
              },
              {
                value: '云溪区',
                id: 430603,
                key: 430603
              },
              {
                value: '君山区',
                id: 430611,
                key: 430611
              },
              {
                value: '岳阳县',
                id: 430621,
                key: 430621
              },
              {
                value: '华容县',
                id: 430623,
                key: 430623
              },
              {
                value: '湘阴县',
                id: 430624,
                key: 430624
              },
              {
                value: '平江县',
                id: 430626,
                key: 430626
              },
              {
                value: '汨罗市',
                id: 430681,
                key: 430681
              },
              {
                value: '临湘市',
                id: 430682,
                key: 430682
              }
            ]
          },
          {
            key: 430800,
            value: '张家界市',
            id: 430800,
            children: [
              {
                value: '永定区',
                id: 430802,
                key: 430802
              },
              {
                value: '武陵源区',
                id: 430811,
                key: 430811
              },
              {
                value: '慈利县',
                id: 430821,
                key: 430821
              },
              {
                value: '桑植县',
                id: 430822,
                key: 430822
              }
            ]
          },
          {
            key: 430200,
            value: '株洲市',
            id: 430200,
            children: [
              {
                value: '荷塘区',
                id: 430202,
                key: 430202
              },
              {
                value: '芦淞区',
                id: 430203,
                key: 430203
              },
              {
                value: '石峰区',
                id: 430204,
                key: 430204
              },
              {
                value: '天元区',
                id: 430211,
                key: 430211
              },
              {
                value: '株洲县',
                id: 430221,
                key: 430221
              },
              {
                value: '攸县',
                id: 430223,
                key: 430223
              },
              {
                value: '茶陵县',
                id: 430224,
                key: 430224
              },
              {
                value: '炎陵县',
                id: 430225,
                key: 430225
              },
              {
                value: '醴陵市',
                id: 430281,
                key: 430281
              }
            ]
          },
          {
            key: 431000,
            value: '郴州市',
            id: 431000,
            children: [
              {
                value: '北湖区',
                id: 431002,
                key: 431002
              },
              {
                value: '苏仙区',
                id: 431003,
                key: 431003
              },
              {
                value: '桂阳县',
                id: 431021,
                key: 431021
              },
              {
                value: '宜章县',
                id: 431022,
                key: 431022
              },
              {
                value: '永兴县',
                id: 431023,
                key: 431023
              },
              {
                value: '嘉禾县',
                id: 431024,
                key: 431024
              },
              {
                value: '临武县',
                id: 431025,
                key: 431025
              },
              {
                value: '汝城县',
                id: 431026,
                key: 431026
              },
              {
                value: '桂东县',
                id: 431027,
                key: 431027
              },
              {
                value: '安仁县',
                id: 431028,
                key: 431028
              },
              {
                value: '资兴市',
                id: 431081,
                key: 431081
              }
            ]
          },
          {
            key: 430400,
            value: '衡阳市',
            id: 430400,
            children: [
              {
                value: '珠晖区',
                id: 430405,
                key: 430405
              },
              {
                value: '雁峰区',
                id: 430406,
                key: 430406
              },
              {
                value: '石鼓区',
                id: 430407,
                key: 430407
              },
              {
                value: '蒸湘区',
                id: 430408,
                key: 430408
              },
              {
                value: '南岳区',
                id: 430412,
                key: 430412
              },
              {
                value: '衡阳县',
                id: 430421,
                key: 430421
              },
              {
                value: '衡南县',
                id: 430422,
                key: 430422
              },
              {
                value: '衡山县',
                id: 430423,
                key: 430423
              },
              {
                value: '衡东县',
                id: 430424,
                key: 430424
              },
              {
                value: '祁东县',
                id: 430426,
                key: 430426
              },
              {
                value: '耒阳市',
                id: 430481,
                key: 430481
              },
              {
                value: '常宁市',
                id: 430482,
                key: 430482
              }
            ]
          },
          {
            key: 431200,
            value: '怀化市',
            id: 431200,
            children: [
              {
                value: '鹤城区',
                id: 431202,
                key: 431202
              },
              {
                value: '中方县',
                id: 431221,
                key: 431221
              },
              {
                value: '沅陵县',
                id: 431222,
                key: 431222
              },
              {
                value: '辰溪县',
                id: 431223,
                key: 431223
              },
              {
                value: '溆浦县',
                id: 431224,
                key: 431224
              },
              {
                value: '会同县',
                id: 431225,
                key: 431225
              },
              {
                value: '麻阳苗族自治县',
                id: 431226,
                key: 431226
              },
              {
                value: '新晃侗族自治县',
                id: 431227,
                key: 431227
              },
              {
                value: '芷江侗族自治县',
                id: 431228,
                key: 431228
              },
              {
                value: '靖州苗族侗族自治县',
                id: 431229,
                key: 431229
              },
              {
                value: '通道侗族自治县',
                id: 431230,
                key: 431230
              },
              {
                value: '洪江市',
                id: 431281,
                key: 431281
              }
            ]
          },
          {
            key: 431300,
            value: '娄底市',
            id: 431300,
            children: [
              {
                value: '娄星区',
                id: 431302,
                key: 431302
              },
              {
                value: '双峰县',
                id: 431321,
                key: 431321
              },
              {
                value: '新化县',
                id: 431322,
                key: 431322
              },
              {
                value: '冷水江市',
                id: 431381,
                key: 431381
              },
              {
                value: '涟源市',
                id: 431382,
                key: 431382
              }
            ]
          },
          {
            key: 430500,
            value: '邵阳市',
            id: 430500,
            children: [
              {
                value: '双清区',
                id: 430502,
                key: 430502
              },
              {
                value: '大祥区',
                id: 430503,
                key: 430503
              },
              {
                value: '北塔区',
                id: 430511,
                key: 430511
              },
              {
                value: '邵东县',
                id: 430521,
                key: 430521
              },
              {
                value: '新邵县',
                id: 430522,
                key: 430522
              },
              {
                value: '邵阳县',
                id: 430523,
                key: 430523
              },
              {
                value: '隆回县',
                id: 430524,
                key: 430524
              },
              {
                value: '洞口县',
                id: 430525,
                key: 430525
              },
              {
                value: '绥宁县',
                id: 430527,
                key: 430527
              },
              {
                value: '新宁县',
                id: 430528,
                key: 430528
              },
              {
                value: '城步苗族自治县',
                id: 430529,
                key: 430529
              },
              {
                value: '武冈市',
                id: 430581,
                key: 430581
              }
            ]
          },
          {
            key: 430300,
            value: '湘潭市',
            id: 430300,
            children: [
              {
                value: '雨湖区',
                id: 430302,
                key: 430302
              },
              {
                value: '岳塘区',
                id: 430304,
                key: 430304
              },
              {
                value: '湘潭县',
                id: 430321,
                key: 430321
              },
              {
                value: '湘乡市',
                id: 430381,
                key: 430381
              },
              {
                value: '韶山市',
                id: 430382,
                key: 430382
              }
            ]
          },
          {
            key: 433100,
            value: '湘西土家族苗族自治州',
            id: 433100,
            children: [
              {
                value: '吉首市',
                id: 433101,
                key: 433101
              },
              {
                value: '泸溪县',
                id: 433122,
                key: 433122
              },
              {
                value: '凤凰县',
                id: 433123,
                key: 433123
              },
              {
                value: '花垣县',
                id: 433124,
                key: 433124
              },
              {
                value: '保靖县',
                id: 433125,
                key: 433125
              },
              {
                value: '古丈县',
                id: 433126,
                key: 433126
              },
              {
                value: '永顺县',
                id: 433127,
                key: 433127
              },
              {
                value: '龙山县',
                id: 433130,
                key: 433130
              }
            ]
          },
          {
            key: 430900,
            value: '益阳市',
            id: 430900,
            children: [
              {
                value: '资阳区',
                id: 430902,
                key: 430902
              },
              {
                value: '赫山区',
                id: 430903,
                key: 430903
              },
              {
                value: '南县',
                id: 430921,
                key: 430921
              },
              {
                value: '桃江县',
                id: 430922,
                key: 430922
              },
              {
                value: '安化县',
                id: 430923,
                key: 430923
              },
              {
                value: '沅江市',
                id: 430981,
                key: 430981
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 9000,
    value: '国外',
    id: 9000,
    children: [
      {
        key: 3000,
        value: '北美洲',
        id: 3000,
        children: [
          {
            value: '安提瓜和巴布达',
            id: 3028,
            key: 3028
          },
          {
            value: '巴巴多斯',
            id: 3052,
            key: 3052
          },
          {
            value: '巴哈马',
            id: 3044,
            key: 3044
          },
          {
            value: '巴拿马',
            id: 3591,
            key: 3591
          },
          {
            value: '伯利兹',
            id: 3084,
            key: 3084
          },
          {
            value: '多米尼加',
            id: 3214,
            key: 3214
          },
          {
            value: '多米尼克',
            id: 3212,
            key: 3212
          },
          {
            value: '哥斯达黎加',
            id: 3188,
            key: 3188
          },
          {
            value: '格林纳达',
            id: 3308,
            key: 3308
          },
          {
            value: '古巴',
            id: 3192,
            key: 3192
          },
          {
            value: '海地',
            id: 3332,
            key: 3332
          },
          {
            value: '洪都拉斯',
            id: 3340,
            key: 3340
          },
          {
            value: '加拿大',
            id: 3124,
            key: 3124
          },
          {
            value: '美国',
            id: 3840,
            key: 3840
          },
          {
            value: '墨西哥',
            id: 3484,
            key: 3484
          },
          {
            value: '尼加拉瓜',
            id: 3558,
            key: 3558
          },
          {
            value: '萨尔瓦多',
            id: 3222,
            key: 3222
          },
          {
            value: '圣基茨和尼维斯',
            id: 3659,
            key: 3659
          },
          {
            value: '圣卢西亚',
            id: 3662,
            key: 3662
          },
          {
            value: '圣文森特和格林纳丁斯',
            id: 3670,
            key: 3670
          },
          {
            value: '特立尼达和多巴哥',
            id: 3780,
            key: 3780
          },
          {
            value: '危地马拉',
            id: 3320,
            key: 3320
          },
          {
            value: '牙买加',
            id: 3388,
            key: 3388
          }
        ]
      },
      {
        key: 2000,
        value: '非洲',
        id: 2000,
        children: [
          {
            value: '阿尔及利亚',
            id: 2012,
            key: 2012
          },
          {
            value: '埃及',
            id: 2818,
            key: 2818
          },
          {
            value: '埃塞俄比亚',
            id: 2231,
            key: 2231
          },
          {
            value: '安哥拉',
            id: 2024,
            key: 2024
          },
          {
            value: '贝宁',
            id: 2204,
            key: 2204
          },
          {
            value: '博茨瓦纳',
            id: 2072,
            key: 2072
          },
          {
            value: '布基纳法索',
            id: 2854,
            key: 2854
          },
          {
            value: '布隆迪',
            id: 2108,
            key: 2108
          },
          {
            value: '赤道几内亚',
            id: 2226,
            key: 2226
          },
          {
            value: '多哥',
            id: 2768,
            key: 2768
          },
          {
            value: '厄立特里亚',
            id: 2232,
            key: 2232
          },
          {
            value: '佛得角',
            id: 2132,
            key: 2132
          },
          {
            value: '冈比亚',
            id: 2270,
            key: 2270
          },
          {
            value: '刚果（布）',
            id: 2178,
            key: 2178
          },
          {
            value: '刚果（金）',
            id: 2180,
            key: 2180
          },
          {
            value: '吉布提',
            id: 2262,
            key: 2262
          },
          {
            value: '几内亚',
            id: 2324,
            key: 2324
          },
          {
            value: '几内亚比绍',
            id: 2624,
            key: 2624
          },
          {
            value: '加纳',
            id: 2288,
            key: 2288
          },
          {
            value: '加蓬',
            id: 2266,
            key: 2266
          },
          {
            value: '津巴布韦',
            id: 2716,
            key: 2716
          },
          {
            value: '喀麦隆',
            id: 2120,
            key: 2120
          },
          {
            value: '科摩罗',
            id: 2174,
            key: 2174
          },
          {
            value: '科特迪瓦',
            id: 2384,
            key: 2384
          },
          {
            value: '肯尼亚',
            id: 2404,
            key: 2404
          },
          {
            value: '莱索托',
            id: 2426,
            key: 2426
          },
          {
            value: '利比里亚',
            id: 2430,
            key: 2430
          },
          {
            value: '利比亚',
            id: 2434,
            key: 2434
          },
          {
            value: '卢旺达',
            id: 2646,
            key: 2646
          },
          {
            value: '马达加斯加',
            id: 2450,
            key: 2450
          },
          {
            value: '马拉维',
            id: 2454,
            key: 2454
          },
          {
            value: '马里',
            id: 2466,
            key: 2466
          },
          {
            value: '毛里求斯',
            id: 2480,
            key: 2480
          },
          {
            value: '毛里塔尼亚',
            id: 2478,
            key: 2478
          },
          {
            value: '摩洛哥',
            id: 2504,
            key: 2504
          },
          {
            value: '莫桑比克',
            id: 2508,
            key: 2508
          },
          {
            value: '纳米比亚',
            id: 2516,
            key: 2516
          },
          {
            value: '南非',
            id: 2710,
            key: 2710
          },
          {
            value: '南苏丹',
            id: 2728,
            key: 2728
          },
          {
            value: '尼日尔',
            id: 2562,
            key: 2562
          },
          {
            value: '尼日利亚',
            id: 2566,
            key: 2566
          },
          {
            value: '塞拉利昂',
            id: 2694,
            key: 2694
          },
          {
            value: '塞内加尔',
            id: 2686,
            key: 2686
          },
          {
            value: '塞舌尔',
            id: 2690,
            key: 2690
          },
          {
            value: '圣多美和普林西比',
            id: 2678,
            key: 2678
          },
          {
            value: '斯威士兰',
            id: 2748,
            key: 2748
          },
          {
            value: '苏丹',
            id: 2729,
            key: 2729
          },
          {
            value: '索马里',
            id: 2706,
            key: 2706
          },
          {
            value: '坦桑尼亚',
            id: 2834,
            key: 2834
          },
          {
            value: '突尼斯',
            id: 2788,
            key: 2788
          },
          {
            value: '乌干达',
            id: 2800,
            key: 2800
          },
          {
            value: '赞比亚',
            id: 2894,
            key: 2894
          },
          {
            value: '乍得',
            id: 2148,
            key: 2148
          },
          {
            value: '中非',
            id: 2140,
            key: 2140
          }
        ]
      },
      {
        key: 1000,
        value: '亚洲',
        id: 1000,
        children: [
          {
            value: '阿富汗',
            id: 1004,
            key: 1004
          },
          {
            value: '阿联酋',
            id: 1784,
            key: 1784
          },
          {
            value: '阿曼',
            id: 1512,
            key: 1512
          },
          {
            value: '阿塞拜疆',
            id: 1031,
            key: 1031
          },
          {
            value: '巴基斯坦',
            id: 1586,
            key: 1586
          },
          {
            value: '巴勒斯坦',
            id: 1275,
            key: 1275
          },
          {
            value: '巴林',
            id: 1048,
            key: 1048
          },
          {
            value: '不丹',
            id: 1064,
            key: 1064
          },
          {
            value: '朝鲜',
            id: 1408,
            key: 1408
          },
          {
            value: '东帝汶',
            id: 1626,
            key: 1626
          },
          {
            value: '菲律宾',
            id: 1608,
            key: 1608
          },
          {
            value: '格鲁吉亚',
            id: 1268,
            key: 1268
          },
          {
            value: '哈萨克斯坦',
            id: 1398,
            key: 1398
          },
          {
            value: '韩国',
            id: 1410,
            key: 1410
          },
          {
            value: '吉尔吉斯斯坦',
            id: 1417,
            key: 1417
          },
          {
            value: '柬埔寨',
            id: 1116,
            key: 1116
          },
          {
            value: '卡塔尔',
            id: 1634,
            key: 1634
          },
          {
            value: '科威特',
            id: 1414,
            key: 1414
          },
          {
            value: '老挝',
            id: 1418,
            key: 1418
          },
          {
            value: '黎巴嫩',
            id: 1422,
            key: 1422
          },
          {
            value: '马尔代夫',
            id: 1462,
            key: 1462
          },
          {
            value: '马来西亚',
            id: 1458,
            key: 1458
          },
          {
            value: '蒙古国',
            id: 1496,
            key: 1496
          },
          {
            value: '孟加拉',
            id: 1050,
            key: 1050
          },
          {
            value: '缅甸',
            id: 1104,
            key: 1104
          },
          {
            value: '尼泊尔',
            id: 1524,
            key: 1524
          },
          {
            value: '日本',
            id: 1392,
            key: 1392
          },
          {
            value: '沙特阿拉伯',
            id: 1682,
            key: 1682
          },
          {
            value: '斯里兰卡',
            id: 1144,
            key: 1144
          },
          {
            value: '塔吉克斯坦',
            id: 1762,
            key: 1762
          },
          {
            value: '泰国',
            id: 1764,
            key: 1764
          },
          {
            value: '土库曼斯坦',
            id: 1795,
            key: 1795
          },
          {
            value: '文莱',
            id: 1096,
            key: 1096
          },
          {
            value: '乌兹别克斯坦',
            id: 1860,
            key: 1860
          },
          {
            value: '新加坡',
            id: 1702,
            key: 1702
          },
          {
            value: '叙利亚',
            id: 1760,
            key: 1760
          },
          {
            value: '亚美尼亚',
            id: 1051,
            key: 1051
          },
          {
            value: '也门',
            id: 1887,
            key: 1887
          },
          {
            value: '伊拉克',
            id: 1368,
            key: 1368
          },
          {
            value: '伊朗',
            id: 1364,
            key: 1364
          },
          {
            value: '以色列',
            id: 1376,
            key: 1376
          },
          {
            value: '印度',
            id: 1356,
            key: 1356
          },
          {
            value: '印度尼西亚',
            id: 1360,
            key: 1360
          },
          {
            value: '约旦',
            id: 1400,
            key: 1400
          },
          {
            value: '越南',
            id: 1704,
            key: 1704
          }
        ]
      },
      {
        key: 7000,
        value: '大洋洲',
        id: 7000,
        children: [
          {
            value: '澳大利亚',
            id: 7036,
            key: 7036
          },
          {
            value: '巴布亚新几内亚',
            id: 7598,
            key: 7598
          },
          {
            value: '斐济',
            id: 7242,
            key: 7242
          },
          {
            value: '基里巴斯',
            id: 7296,
            key: 7296
          },
          {
            value: '马绍尔群岛',
            id: 7584,
            key: 7584
          },
          {
            value: '密克罗尼西亚联邦',
            id: 7583,
            key: 7583
          },
          {
            value: '瑙鲁',
            id: 7520,
            key: 7520
          },
          {
            value: '帕劳',
            id: 7585,
            key: 7585
          },
          {
            value: '萨摩亚',
            id: 7882,
            key: 7882
          },
          {
            value: '所罗门群岛',
            id: 7090,
            key: 7090
          },
          {
            value: '汤加',
            id: 7776,
            key: 7776
          },
          {
            value: '图瓦卢',
            id: 7798,
            key: 7798
          },
          {
            value: '瓦努阿图',
            id: 7548,
            key: 7548
          },
          {
            value: '新西兰',
            id: 7554,
            key: 7554
          }
        ]
      },
      {
        key: 6000,
        value: '欧洲',
        id: 6000,
        children: [
          {
            value: '阿尔巴尼亚',
            id: 6008,
            key: 6008
          },
          {
            value: '爱尔兰',
            id: 6372,
            key: 6372
          },
          {
            value: '爱沙尼亚',
            id: 6233,
            key: 6233
          },
          {
            value: '安道尔',
            id: 6020,
            key: 6020
          },
          {
            value: '奥地利',
            id: 6040,
            key: 6040
          },
          {
            value: '白俄罗斯',
            id: 6112,
            key: 6112
          },
          {
            value: '保加利亚',
            id: 6100,
            key: 6100
          },
          {
            value: '比利时',
            id: 6056,
            key: 6056
          },
          {
            value: '冰岛',
            id: 6352,
            key: 6352
          },
          {
            value: '波黑',
            id: 6070,
            key: 6070
          },
          {
            value: '波兰',
            id: 6616,
            key: 6616
          },
          {
            value: '丹麦',
            id: 6208,
            key: 6208
          },
          {
            value: '德国',
            id: 6276,
            key: 6276
          },
          {
            value: '俄罗斯',
            id: 6643,
            key: 6643
          },
          {
            value: '法国',
            id: 6250,
            key: 6250
          },
          {
            value: '梵蒂冈',
            id: 6336,
            key: 6336
          },
          {
            value: '芬兰',
            id: 6246,
            key: 6246
          },
          {
            value: '荷兰',
            id: 6528,
            key: 6528
          },
          {
            value: '黑山',
            id: 6499,
            key: 6499
          },
          {
            value: '捷克',
            id: 6203,
            key: 6203
          },
          {
            value: '克罗地亚',
            id: 6191,
            key: 6191
          },
          {
            value: '拉脱维亚',
            id: 6428,
            key: 6428
          },
          {
            value: '立陶宛',
            id: 6440,
            key: 6440
          },
          {
            value: '列支敦士登',
            id: 6438,
            key: 6438
          },
          {
            value: '卢森堡',
            id: 6442,
            key: 6442
          },
          {
            value: '罗马尼亚',
            id: 6642,
            key: 6642
          },
          {
            value: '马耳他',
            id: 6470,
            key: 6470
          },
          {
            value: '马其顿',
            id: 6807,
            key: 6807
          },
          {
            value: '摩尔多瓦',
            id: 6498,
            key: 6498
          },
          {
            value: '摩纳哥',
            id: 6492,
            key: 6492
          },
          {
            value: '挪威',
            id: 6578,
            key: 6578
          },
          {
            value: '葡萄牙',
            id: 6620,
            key: 6620
          },
          {
            value: '瑞典',
            id: 6752,
            key: 6752
          },
          {
            value: '瑞士',
            id: 6756,
            key: 6756
          },
          {
            value: '塞尔维亚',
            id: 6688,
            key: 6688
          },
          {
            value: '塞浦路斯',
            id: 6196,
            key: 6196
          },
          {
            value: '圣马力诺',
            id: 6674,
            key: 6674
          },
          {
            value: '斯洛伐克',
            id: 6703,
            key: 6703
          },
          {
            value: '斯洛文尼亚',
            id: 6705,
            key: 6705
          },
          {
            value: '土耳其',
            id: 6792,
            key: 6792
          },
          {
            value: '乌克兰',
            id: 6804,
            key: 6804
          },
          {
            value: '西班牙',
            id: 6724,
            key: 6724
          },
          {
            value: '希腊',
            id: 6300,
            key: 6300
          },
          {
            value: '匈牙利',
            id: 6348,
            key: 6348
          },
          {
            value: '意大利',
            id: 6380,
            key: 6380
          },
          {
            value: '英国',
            id: 6826,
            key: 6826
          }
        ]
      },
      {
        key: 5000,
        value: '南美洲',
        id: 5000,
        children: [
          {
            value: '阿根廷',
            id: 5032,
            key: 5032
          },
          {
            value: '巴拉圭',
            id: 5600,
            key: 5600
          },
          {
            value: '巴西',
            id: 5076,
            key: 5076
          },
          {
            value: '玻利维亚',
            id: 5068,
            key: 5068
          },
          {
            value: '厄瓜多尔',
            id: 5218,
            key: 5218
          },
          {
            value: '哥伦比亚',
            id: 5170,
            key: 5170
          },
          {
            value: '圭亚那',
            id: 5328,
            key: 5328
          },
          {
            value: '秘鲁',
            id: 5604,
            key: 5604
          },
          {
            value: '苏里南',
            id: 5740,
            key: 5740
          },
          {
            value: '委内瑞拉',
            id: 5862,
            key: 5862
          },
          {
            value: '乌拉圭',
            id: 5858,
            key: 5858
          },
          {
            value: '智利',
            id: 5152,
            key: 5152
          }
        ]
      }
    ]
  }
]
